<div class="menubar-hoverable header-fixed menubar-pin"
  style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
  <!-- header -->
  <!--  -->


  <!-- BEGIN BASE-->
  <div id="base">

    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas">
    </div><!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->

    <!-- BEGIN CONTENT-->
    <div id="content">
      <section class="has-actions style-default-bright">

        <div class="row">
          <div class="col-lg-6" style="width: 100%">
            <h2 class="text-primary">{{ 'feesManagement' | translate }}</h2>
            <article class="margin-bottom-xxl">
              <p class="lead">
                {{ 'manageYourSchoolFeesForTheAcademicYear' | translate }}
                <span style="color: var(--filter-dropdown-color)">
                  <select [(ngModel)]="academicInfo.current_academic" (change)="academicChanged()" style="border:none">
                    <option *ngFor="let ac of academicInfo.academicList" [ngValue]="ac.pkAcademicId">
                      {{ ac.Year }}{{ac.current ? ('current'|translate):''}}
                    </option>

                  </select>
                </span> <!--<span style="color: var(--filter-dropdown-color)">{{feeDashDetails?.academicYear}}</span>-->.
              </p>
            </article>
          </div><!--end .col -->
        </div>


        <div class="row">
          <!-- BEGIN LAYOUT LEFT SIDEBAR -->
          <div class="col-md-12">
            <div class="card tabs-left style-default-light" style="background: white;">
              <ul class="card-head nav nav-tabs" data-toggle="tabs" style="background: #f2f3f3">
                <li [style.display]="academicPermissions.SCHOOL_FEES_DASHBOARD == 'ENABLED' ? '' : 'none'"
                  class="active" id="overview_tab"><a
                    (click)="getFeeDashDetails();getPaidLateFeeCount();academicInfo.current_tab = 'OVERVIEW'"
                    style="cursor: pointer;" data-target="#overview" data-toggle="tab">{{ 'overview' | translate }}</a></li>
                <li
                  [style.display]="(academicPermissions.FEES_BOARD == 'ENABLED' && ((academicInfo.current_academic_state == 'RUNNING' || academicInfo.current_academic_state == 'NOT_STARTED') || (academicPermissions.FEES_CONFIG_PAST_ACADEMIC == 'ENABLED'))) ? '' : 'none'"
                  id="feeboard_tab"><a style="cursor: pointer;" data-target="#feeboard" data-toggle="tab"
                    (click)="academicInfo.current_tab = 'FEES_BOARD'">{{ 'feesBoard' | translate }}</a></li>
                <li
                  [style.display]="(academicPermissions.FEES_COLLECTION == 'ENABLED' || academicPermissions.SCHOOL_ADMIN_FEE_COLLECTION_VIEW == 'ENABLED') ? '' : 'none'"
                  id="fee_collection_tab"><a id="_fee_collection_tab" style="cursor: pointer;"
                    (click)="feesCollectionTabClicked();academicInfo.current_tab = 'FEE_COLLECTION'"
                    data-target="#fee-collections" data-toggle="tab">{{ 'feeCollection' | translate }}</a></li>
                <li [style.display]="academicPermissions.FEES_DISCOUNT == 'ENABLED' ? '' : 'none'" id="discount_tab"><a
                    style="cursor: pointer;" data-target="#discount" data-toggle="tab"
                    (click)="discountDetails();academicInfo.current_tab = 'DISCOUNTS'">{{ 'discounts' | translate }}</a></li>
                <li
                  [style.display]="(academicPermissions.FEES_SETTINGS == 'ENABLED' && (academicInfo.current_academic_state == 'RUNNING' || academicInfo.current_academic_state == 'NOT_STARTED')) ? '' : 'none'"
                  id="fee_settings_tab"><a style="cursor: pointer;" data-target="#fees-settings" data-toggle="tab"
                    (click)="openFeesSettingsTab()">{{ 'settings' | translate }}</a></li>
                <li class="hide"><a href="#duefee">{{ 'dueFees' | translate }}</a></li>
              </ul>
              <div class="card-body tab-content style-default-bright">

                <!-- Overview -->
                <div class="tab-pane active" id="overview"
                  [style.display]="academicPermissions.SCHOOL_FEES_DASHBOARD == 'ENABLED' ? '' : 'none'">
                  <!-- "Academic Year Basis" header tab bar removed — it only ever had
                       one real tab (Financial Term Basis is commented out/dead), so the
                       bar was decorative; the All/Active/Inactive toggle now sits in its
                       place instead. #academic_year_basis is kept as a plain container
                       (no longer a Bootstrap .tab-pane) since nothing switches it anymore. -->
                  <div>
                    <div id="academic_year_basis">
                      <div class="fm-status-toggle" role="tablist" aria-label="Student status">
                        <button type="button" class="fm-status-toggle-btn" [class.active]="studentStatusFilter === 'total'"
                          (click)="setStudentStatusFilter('total')">{{ 'all' | translate }}</button>
                        <button type="button" class="fm-status-toggle-btn" [class.active]="studentStatusFilter === 'active'"
                          (click)="setStudentStatusFilter('active')">{{ 'active' | translate }}</button>
                        <button type="button" class="fm-status-toggle-btn" [class.active]="studentStatusFilter === 'inactive'"
                          (click)="setStudentStatusFilter('inactive')">{{ 'inactive' | translate }}</button>
                      </div>
                      <div class="fm-metrics">
                        <div class="fm-metric-card fm-metric-rose">
                          <div class="fm-metric-icon fm-metric-icon-rose"><i class="ph ph-chart-line"></i></div>
                          <strong class="fm-metric-value">
                            <app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="feeDashDetails.TotalAmount === undefined"></app-loader>
                            <ng-container *ngIf="feeDashDetails.TotalAmount !== undefined">{{currType}} {{feeDashDetails.TotalAmount || 0 | number}}</ng-container>
                          </strong>
                          <p class="fm-metric-label">{{ 'totalFees' | translate }}</p>
                        </div>
                        <div class="fm-metric-card fm-metric-teal">
                          <div class="fm-metric-icon fm-metric-icon-teal"><i class="ph ph-wallet"></i></div>
                          <strong class="fm-metric-value">
                            <app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="feeDashDetails.CollectedAmount === undefined"></app-loader>
                            <ng-container *ngIf="feeDashDetails.CollectedAmount !== undefined">{{currType}} {{feeDashDetails.CollectedAmount || 0 | number}}</ng-container>
                          </strong>
                          <p class="fm-metric-label">{{ 'collectedFees' | translate }}</p>
                        </div>
                        <div class="fm-metric-card fm-metric-amber">
                          <div class="fm-metric-icon fm-metric-icon-amber"><i class="ph ph-seal-percent"></i></div>
                          <strong class="fm-metric-value">
                            <app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="feeDashDetails.DiscountAmount === undefined"></app-loader>
                            <ng-container *ngIf="feeDashDetails.DiscountAmount !== undefined">{{currType}} {{feeDashDetails.DiscountAmount || 0 | number}}</ng-container>
                          </strong>
                          <p class="fm-metric-label">{{ 'discountMade' | translate }}</p>
                        </div>
                        <div class="fm-metric-card fm-metric-slate">
                          <div class="fm-metric-icon fm-metric-icon-slate"><i class="ph ph-hourglass"></i></div>
                          <strong class="fm-metric-value">
                            <app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="feeDashDetails.PendingAmount === undefined"></app-loader>
                            <ng-container *ngIf="feeDashDetails.PendingAmount !== undefined">{{currType}} {{feeDashDetails.PendingAmount || 0 | number}}</ng-container>
                          </strong>
                          <p class="fm-metric-label">{{ 'pendingFees' | translate }}</p>
                        </div>
                        <div class="fm-metric-card fm-metric-blue" *ngIf="academicPermissions.LATE_FEE_COLLECTION == 'ENABLED'">
                          <div class="fm-metric-icon fm-metric-icon-blue"><i class="ph ph-clock-countdown"></i></div>
                          <strong class="fm-metric-value">
                            <app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="totalLateFeesPaid === null"></app-loader>
                            <ng-container *ngIf="totalLateFeesPaid !== null">{{currType}} {{totalLateFeesPaid || 0 | number}}</ng-container>
                          </strong>
                          <p class="fm-metric-label">{{ 'lateFees' | translate }}</p>
                        </div>
                      </div>
                      <div class="fm-details-section">
                        <div class="fm-details-toolbar">
                          <h3 class="fm-details-title">{{ 'feesDetails' | translate }}</h3>
                          <form class="fm-details-form" autocomplete="off">
                            <!-- Dropdown hidden per request (removed from view), but kept in
                                 the DOM — fetchFeeDetailOfStandard() in the .ts still reads
                                 its value via jQuery ($('#selectInterval').val()), and always
                                 defaults to "SUMMARY" (Entire Academic Year) since that's its
                                 only remaining selected option. Removing the element outright
                                 would make that lookup return undefined and silently break
                                 "View Fee Details" (no interval branch would match). -->
                            <select id="selectInterval" name="selectInterval" class="form-control" style="display: none;">
                              <option selected value="SUMMARY">{{ 'entireAcademicYear' | translate }}</option>
                            </select>
                            <select id="selectStandard" name="selectStandard" class="fm-select">
                              <option value="">{{ 'entireSchool' | translate }}</option>
                              <option id="{{'sel_'+std.pkClassStandardsId}}" value="{{std.pkClassStandardsId}}"
                                *ngFor="let std of classStanderds">{{std.ClassStandard}}</option>
                            </select>
                            <button type="button" class="fm-btn fm-btn-primary"
                              (click)="viewFeeDeails()">{{ 'viewFeeDetails' | translate }}</button>
                            <button type="button" class="fm-btn fm-btn-outline" (click)="exportStandardFeeDetailsToExcel()"
                              *ngIf="isShowFeeDetailsOverview && standardFeeDetails.length>0">{{ 'export' | translate }} <i class="ri-upload-2-line"></i></button>
                          </form>
                        </div>

                        <div class="fm-details-table-wrap" *ngIf="isShowFeeDetailsOverview && standardFeeDetails.length>0">
                          <table id="datatable100" class="fm-details-table">
                            <thead>
                              <tr>
                                <th>{{ 'className' | translate }}</th>
                                <th>{{ 'section' | translate }}</th>
                                <th>{{ 'totalFees' | translate }} ({{currType}})</th>
                                <th>{{ 'discountAmount' | translate }} ({{currType}})</th>
                                <th>{{ 'collectedAmount' | translate }} ({{currType}})</th>
                                <th>{{ 'pendingAmount' | translate }} ({{currType}})</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let f of standardFeeDetails"
                                (click)="viewStudentFees(f)" data-toggle="modal" data-target="#studentFeeDetail">
                                <td>{{f.classNumber}}</td>
                                <td>{{f.classDivision}}</td>
                                <td>{{f.totalFee | number}}</td>
                                <td>{{f.discountFee | number}}</td>
                                <td>{{f.collectedFee | number}}</td>
                                <td>{{f.pendingFee | number}}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="fm-standards-pager" *ngIf="classWiseFeesMaxPage > 1">
                            <button type="button" class="fm-pager-btn"
                              [disabled]="classWiseFeesCurrentPage <= 1"
                              (click)="previousClassWiseFeesPage()">{{ 'dataTables.paginate.previous' | translate }}</button>
                            <span class="fm-standards-pager-label">{{classWiseFeesCurrentPage}} / {{classWiseFeesMaxPage}}</span>
                            <button type="button" class="fm-pager-btn"
                              [disabled]="classWiseFeesCurrentPage >= classWiseFeesMaxPage"
                              (click)="nextClassWiseFeesPage()">{{ 'dataTables.paginate.next' | translate }}</button>
                          </div>
                        </div>

                        <p class="fm-details-note"><b>{{ 'note' | translate }}</b> {{ 'allTheAmountsAreIn' | translate }} <b>{{currType}}</b> {{'currency' | translate}}</p>
                      </div>
                    </div>

                  </div>
                </div>

                <!-- fees board -->
                <div class="tab-pane" id="feeboard">
                  <div class="card-head" style="font-size: 12px;">
                    <ul class="nav nav-tabs" data-toggle="tabs">
                      <li class="active"><a style="cursor: pointer;" data-target="#view-fees-board"
                          data-toggle="tab">{{ 'viewEditFeesBoard' | translate }}</a></li>
                      <li class=""><a style="cursor: pointer;" data-target="#fee-structures" data-toggle="tab"
                          (click)="getFeeStructure()">{{ 'feeStructure' | translate }}</a></li>
                      <li class=""><a style="cursor: pointer;" data-target="#student-categories" data-toggle="tab"
                          (click)="getStudentCategoryList(null,null)">{{ 'studentCategories' | translate }}</a></li>
                      <li class=""><a style="cursor: pointer;" data-target="#fees-components" data-toggle="tab"
                          (click)="openFeeComponentTab()">{{ 'feesComponents' | translate }}</a></li>
                      <li class=""><a style="cursor: pointer;" data-target="#term-component" data-toggle="tab"
                          (click)="openTermsTab()">{{ 'termComponent' | translate }}</a></li>
                      <li *ngIf="academicPermissions.LATE_FEE_COLLECTION == 'ENABLED'" class="">
                         <a
                          style="cursor: pointer;" data-target="#late-fee-component" data-toggle="tab"
                          (click)="openLateFeeTab()">{{ 'lateFee' | translate }} </a>
                        </li>
                      <li *ngIf="academicPermissions.OTHER_FEES == 'ENABLED'" class=""><a style="cursor: pointer;"
                          data-target="#school-other-fee" data-toggle="tab" (click)="getOtherFeeList()">{{ 'otherFees' | translate }}</a>
                      </li>
                    </ul>
                  </div><!--end .card-head -->
                  <div class="card-body tab-content">

                    <!-- Standards -->
                    <div class="tab-pane active" id="view-fees-board">
                      <div class="text-center text-primary hide">
                        <a class="cursor-pointer" data-toggle="modal" data-target="#group_class_fee_configuration">{{ 'mergeClassesInToGroups' | translate }}</a>
                      </div>
                      <div class="card-body">
                        <table id="fees-board-tab-table" class="table table-striped">
                          <thead>
                            <tr *ngIf="isShowFeeBoard">
                              <th>{{ 'editAdd' | translate }}</th>
                              <th>{{ 'class' | translate }}</th>
                              <th *ngFor="let str of feesBoardDataAllClassesStrList">{{str.Name}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <h4><app-loader loadingStyle="Dots"
                                *ngIf="isShowFeeBoard && feesBoardDataAllClasses.length==0"></app-loader></h4>
                            <div *ngIf="!isShowFeeBoard">
                              <span>{{ 'toView/editFeeConfigPlease' | translate }} </span>
                              <button (click)="showFeeBoardDetailView()">{{ 'clickHere' | translate }}</button>
                            </div>
                            <tr *ngFor="let fee of feesBoardDataAllClasses">
                              <td><a style="cursor: pointer;text-decoration: underline"><i
                                    (click)="feeBoardDetails(fee)" data-toggle="modal" data-target="#assignFeeBoard"
                                    class="fa fa-pencil-square-o" aria-hidden="true"></i></a></td>
                              <td>{{fee.classNumber}} - {{fee.classDivision}}</td>
                              <td *ngFor="let s of fee.structures ">
                                <i *ngIf="s.isConfigured =='YES'" style="color: #008000;" class="fa fa-check"
                                  aria-hidden="true"></i>
                                <i *ngIf="!s.isConfigured || s.isConfigured =='NO'" style="color:#ff0000"
                                  class="fa fa-times" aria-hidden="true"></i>
                              </td>

                            </tr>
                            <!--<tr *ngIf="dataFetching"><td colspan="{{feesBoardDataAllClassesStrList.length + 2}}">Please wait</td></tr>-->
                          </tbody>
                        </table>
                        <button *ngIf="currentPage < maxPage && !dataFetching && isShowFeeBoard "
                          (click)="loadMore()">{{ 'loadMore' | translate }}</button>
                        <p *ngIf="currentPage >= maxPage && isShowFeeBoard">{{ 'noMoreDataToLoad' | translate }}</p>
                      </div>
                    </div>

                    <!-- Student categories tab -->
                    <div class="tab-pane" id="student-categories">
                      <div class="row" style="    margin: 0;    padding: 10px 15px;">
                        <table id="student-category-list" class="table table-striped ">
                          <thead>
                            <tr>
                              <th>{{ 'name' | translate }}</th>
                              <th>{{ 'numberOfStudents' | translate }}</th>
                              <th>{{ 'addMoreStudents' | translate }}</th>
                              <th>{{ 'manage' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let g of studentCategoryList">
                              <td>{{g.Name}}</td>
                              <td>{{g.totalStudents}}</td>
                              <td>
                                <a class="btn btn-flat ink-reaction" (click)="openAssignStudentsToStudentCategory(g)"
                                  data-toggle="modal" data-target="#assign-students-to-category">
                                  <i class="md md-assignment"></i></a>
                              </td>
                              <td>
                                <a (click)="openEditStudentCategory(g)" class="btn btn-flat ink-reaction btn-default"
                                  data-toggle="modal" data-target="#add-student-category"><i class="fa fa-edit"></i></a>
                                <a *ngIf="!(g.collectedAmount > 0)" (click)="openDeleteStudentCategory(g)"
                                  data-toggle="modal" data-target="#delete-student-category"
                                  class="btn btn-flat ink-reaction"><i class="fa fa-trash"></i></a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 text-right">
                        <button data-toggle="modal" (click)="openCreateStudentCategory()"
                          data-target="#add-student-category" type="button"
                          class="btn ink-reaction btn-floating-action btn-primary"
                          style="background: #E91E63;border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"><i
                            class="fa fa-plus"></i></button>
                      </div>
                    </div>
                    <!-- Student categories tab end-->

                    <!-- Fee structures tab -->
                    <div class="tab-pane" id="fee-structures">
                      <div class="card-body">
                        <div class="col-md-12 text-center" style="margin-top: -3em;">
                          <p class="lead" style="font-size: 17px;color: grey;margin: 0;">{{ 'feesStructure' | translate }}</p>
                          <p style="font-size: 12px;color: grey;margin: 0;">{{ 'viewAndManageFeesStructureDetails' | translate }}</p>
                          <p style="font-size: 12px;color: grey;margin: 0;">{{ 'addNewStructure' | translate }}</p>
                          <p style="font-size: 12px;color: grey;margin: 0;">{{ 'toCreateFeeStructurePlease' | translate }} <a
                              data-toggle="modal" (click)="openCreateStudentCategory()"
                              data-target="#add-student-category"
                              style="cursor: pointer;text-decoration: underline;color:var(--brand-primary-color)">{{ 'createStudentCategories' | translate }}</a> {{ 'first' | translate }}</p>
                          <a>
                            <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="modal"
                              (click)="openCreateFeeStructure()" data-target="#add-fee-structure" aria-expanded="true"
                              style="padding: 0px 30px;margin-top: 5px;">{{ 'add' | translate }}</button>
                          </a>
                        </div>
                        <div class="col-md-12 table-responsive">
                          <div class="row" style="    margin: 0;    padding: 10px 15px;">
                            <table id="fee-structure-list" class="table table-striped ">
                              <thead>
                                <tr>
                                  <th>{{ 'name' | translate }}</th>
                                  <th>{{ 'appliesTo' | translate }}</th>
                                  <th>{{ 'manage' | translate }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let st of structureList">
                                  <td>{{st.Name}}</td>
                                  <td>{{st.appliesTo}}</td>
                                  <td>
                                    <a *ngIf="st.isEditable != false" (click)="openEditFeeStructure(st)"
                                      class="btn btn-flat ink-reaction btn-default" data-toggle="modal"
                                      data-target="#add-fee-structure"><i class="fa fa-edit"></i></a>
                                    <a *ngIf="false" (click)="openDeleteFeeStructure(st.pkFeeStructuresId)"
                                      data-toggle="modal" data-target="#deleteFeeStructure"
                                      class="btn btn-flat ink-reaction"><i class="fa fa-trash"></i></a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--<div class="col-md-12 text-right">
                            <button data-toggle="modal" (click)="openCreateFeeStructure()" data-target="#add-fee-structure" type="button" class="btn ink-reaction btn-floating-action btn-primary" style="background: #E91E63;border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 3em -1em;"><i class="fa fa-plus"></i></button>
                          </div>-->
                        </div><!--end .table-responsive -->
                      </div>
                    </div>
                    <!-- Fee structures tab end-->

                    <!-- Category -->
                    <div class="tab-pane" id="fees-components">
                      <table id="components-fee" class="table table-striped ">
                        <thead>
                          <tr>
                            <th>{{ 'feesName' | translate }}</th>
                            <th>{{ 'dueDate' | translate }}</th>
                            <th>{{ 'includeInTerm' | translate }}</th>
                            <th>{{ 'appliesTo' | translate }}</th>
                            <th>{{ 'manage' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>

                        </tbody>
                      </table>
                      <div class="col-md-12 text-right">
                        <button (click)="getAcademicList()" data-toggle="modal" data-target="#add-new-fee-component"
                          type="button" class="btn ink-reaction btn-floating-action btn-primary"
                          style="background: #E91E63;border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em 0em;"><i
                            class="fa fa-plus"></i></button>
                      </div>
                    </div>

                    <div class="tab-pane" id="term-component">
                      <div class="table-responsive" style="padding: 0px 15px;">
                        <div id="offcanvas-manage-termFee_open" href="#offcanvas-manage-termFee"
                          data-toggle="offcanvas"></div>
                        <div data-toggle="modal" class="hidden" data-target="#delete-routes" id="delete_data_popup">
                        </div>
                        <table id="term-component-table" class="table table-striped ">
                          <thead>
                            <tr>
                              <th>{{ 'termName' | translate }}</th>
                              <th>{{ 'dueDate' | translate }}</th>
                              <th>{{ 'manage' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>

                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 text-right">
                        <button data-toggle="modal" data-target="#add-new-term-fee" (click)="openCreateTerm()"
                          type="button" class="btn ink-reaction btn-floating-action btn-primary"
                          style="background: #E91E63;border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em 0em;"><i
                            class="fa fa-plus"></i></button>
                      </div>
                    </div>

                    <div class="tab-pane" id="late-fee-component">
                      <div >
                        <div style="display: flex; align-items: center; justify-content: end;">
                          <span class="toggle-text">{{ 'includeLateFeeInCurrentMonth' | translate }}</span>
                          <div *ngIf="academicPermissions.LATE_FEE_COLLECTION === 'ENABLED'" class="toggle-container-late-fee">
                            <label class="switch-late-fee">
                              <input 
                                type="checkbox" 
                                id="lateFeeForMonth"  
                                (change)="onLateFeeToggleChange()"
                              />
                              <span class="slider-late-fee"></span>
                            </label>
                          </div>
                        </div>
                        <div data-toggle="modal" class="hidden" data-target="#delete-late-fee"
                          id="delete_lateFeeData_popup"></div>
<p-table 
    [value]="lateFeeList" 
    [paginator]="true" 
    [rows]="10" 
    [rowsPerPageOptions]="[10,20,30,40,50]" 
    [tableStyle]="{ 'min-width': '50rem' }" 
    class="late-fees-table"
    [sortMode]="'single'">

    <!-- Header -->
    <ng-template pTemplate="header">
        <tr class="late-fees-header-data">
            <th pSortableColumn="lateDays">{{allLateFees.days}}<p-sortIcon field="lateDays"></p-sortIcon></th>
            <th pSortableColumn="lateFees">{{allLateFees.lateFees}}<p-sortIcon field="lateFees"></p-sortIcon></th>
            <th>{{allLateFees.manage}}</th>
        </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-product>
        <tr class="late-fees-body-data">
            <td>{{product.lateDays}}</td>
            <td>{{product.lateFees}}</td>
            <td class="action-icons">
                <i (click)="openCreateLateFee(product)" class="ri-pencil-line edit-icon" title="Edit"></i>
                <i (click)="selectLateFee(product.pkLateFeesId)" data-toggle="modal" data-target="#delete-late-fee"  class="ri-delete-bin-7-line delete-icon" title="Delete"></i>
            </td>
        </tr>
    </ng-template>

    <!-- Footer (optional page info) -->
    <ng-template pTemplate="paginatorleft">
        <div class="p-m-2">Total Records: {{lateFeeList.length}}</div>
    </ng-template>
</p-table>



                        <!-- <table id="late-fee-component-table" class="table table-striped ">
                          <thead>
                            <tr>
                              <th>{{ 'days' | translate }}</th>
                              <th>{{ 'lateFee' | translate }}</th>
                              <th>{{ 'manage' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>

                          </tbody>
                        </table> -->
                        <div class="deleted-late-fee-list-div">
                          <a class="deleted-late-fee-list-link" data-toggle="modal"
                            data-target="#waivedOff-late-fee-popup" (click)="getWaivedOffLateFeeList()">{{ 'checkLateFeeWaivedOffList' | translate }}</a>
                          <a class="deleted-late-fee-list-link" data-toggle="modal"
                            data-target="#deleted-late-fee-popup" (click)="getDeletedLateFeeList()">{{ 'checkDeletedLateFeeList' | translate }}</a>
                        </div>
                      </div>

                      <div class="col-md-12 text-right">
                        <button data-toggle="modal" data-target="#add-new-late-fee" (click)="openCreateLateFee('')"
                          type="button" class="btn ink-reaction btn-floating-action btn-primary"
                          style="background: #E91E63;border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em 0em;"><i
                            class="fa fa-plus"></i></button>
                      </div>
                    </div>

                    <div class="tab-pane" id="term-fee-configuration">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="text-center">
                            <form class="form-inline text-center search-groups" autocomplete="off">
                              <div class="form-group" style="padding: 0;">
                                <select id="selectclassStandard" name="select13" class="form-control">
                                  <option value="">{{ 'selectClass' | translate }}</option>
                                  <option value="{{std.pkClassStandardsId}}" *ngFor="let std of classStanderds">
                                    {{std.ClassStandard}}</option>
                                </select>
                                <div class="form-control-line"></div>
                              </div>
                              <div class="form-group" style="padding: 0;">
                                <button type="button" (click)="getClassTermConfig(null, null, {})"
                                  class="btn btn-raised ink-reaction btn-info" style="margin-top: -3px;">{{ 'viewFeeDetails' | translate }}</button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="table-responsive" style="padding: 0em 2em;">
                          <table id="termfeeconfiguration_new" class="table table-striped ">
                            <thead>
                              <tr>
                                <th>{{ 'class' | translate }}</th>
                                <th>{{ 'section' | translate }}</th>
                                <th>{{ 'feesCategory' | translate }}</th>
                                <th>{{ 'totalAmount' | translate }}</th>
                                <th *ngFor="let t of termList">{{t.TermName}}</th>
                                <th>{{ 'manage' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="gradeX" *ngFor="let fee of termFeeConfigurations; let i = index">
                                <td rowspan="5" *ngIf="i == 0">{{fee.classNumber}}</td>
                                <td rowspan="5" *ngIf="i == 0">{{fee.classDivision}}</td>
                                <td>{{fee.Name}}</td>
                                <td>{{fee.Amount || 0}}</td>
                                <td *ngFor="let ter of fee.termFees">{{ter.PaymentAmount || 0}}</td>
                                <td><a (click)="openEditTermConfig(fee)" class="section-manage"
                                    style="cursor: pointer"><i
                                      class="fa fa-edit fa-lg manage-termConfiguration"></i></a></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- Other fees tab -->
                    <div class="tab-pane" id="school-other-fee">
                      <div class="row" style="    margin: 0;    padding: 10px 15px;">
                        <table id="school-other-fee-list" class="table table-striped ">
                          <thead>
                            <tr>
                              <th>{{ 'name' | translate }}</th>
                              <th>{{ 'fee' | translate }} ({{currType}})</th>
                              <th>{{ 'noStudents' | translate }}</th>
                              <th>{{ 'noTerms' | translate }}</th>
                              <th>{{ 'manage' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let o of otherFeeList">
                              <td>{{o.Name}}</td>
                              <td>{{o.amount}}</td>
                              <td>{{o.studentsCount}}</td>
                              <td>{{o.numberOfTerms}}</td>
                              <td>

                                <i (click)="initiateEditOtherFee(o)" *ngIf="o.collectedAmount == 0" data-toggle="modal"
                                  data-target="#add-other-fees" class="fa fa-pencil-square-o cursor-pointer"
                                  title="Edit {{o.Name}}" aria-hidden="true"></i>
                                <span *ngIf="o.collectedAmount == 0">&nbsp;&nbsp;|&nbsp;&nbsp;</span>


                                <i (click)="initiateDeleteOtherFee(o)" class="fa fa-trash-o cursor-pointer"
                                  title="delete {{o.Name}}" aria-hidden="true" data-toggle="modal"
                                  data-target="#delete-other-fee" *ngIf="o.collectedAmount == 0"></i>
                                <span *ngIf="o.collectedAmount == 0">&nbsp;&nbsp;|&nbsp;&nbsp;</span>

                                <i class="fa fa-users cursor-pointer" title="assign/ remove students from {{o.Name}}"
                                  aria-hidden="true" data-toggle="modal" data-target="#assign-students-to-otherfees"
                                  (click)="openAssignStudentsToOtherFee(o)"></i>
                                &nbsp;&nbsp;|&nbsp;&nbsp;
                                <a class="action-link" data-toggle="modal" data-target="#manage-other-fee-term"
                                  (click)="openManageOtherFeeTerms(o)">{{ 'terms' | translate }}</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 text-right">
                        <button data-toggle="modal" data-target="#add-other-fees" (click)="initiateAddOtherFees()"
                          type="button" class="btn ink-reaction btn-floating-action btn-primary"
                          style="background: #E91E63;border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"><i
                            class="fa fa-plus"></i></button>
                      </div>
                    </div>
                    <!-- Other fees tab end-->

                  </div><!--end .card-body -->
                </div>

                <!-- Fee Collection Tab-->
                <div class="tab-pane" id="fee-collections">
                  <div class="card-head">
                    <ul class="nav nav-tabs" data-toggle="tabs" style="    text-align: center;">
                      <li class="active" style="width: 33.3%"
                        [style.display]="academicPermissions.FEES_COLLECTION == 'ENABLED' ? '' : 'none'"
                        id="collect_fee_tab_1"><a (click)="showSelectedAmountFloating()" style="cursor: pointer;"
                          data-target="#fee-collection" data-toggle="tab">{{ 'collect' | translate }}</a></li>
                      <li class="" style="width: 33.3%"
                        [style.display]="academicPermissions.SCHOOL_ADMIN_FEE_COLLECTION_VIEW == 'ENABLED' ? '' : 'none'"
                        id="collect_fee_tab_2"><a style="cursor: pointer;" data-target="#fee-collection-history"
                          data-toggle="tab" (click)="feeHistorydataHide();totalSelectedAmount = 0">{{ 'history' | translate }}</a></li>
                      <li class="" style="width: 33.3%"
                        [style.display]="academicPermissions.SCHOOL_ADMIN_FEE_COLLECTION_VIEW == 'ENABLED' ? '' : 'none'"
                        id="collect_fee_tab_3"><a style="cursor: pointer;" data-target="#fee-collection-report"
                          data-toggle="tab" (click)="feeHistorydataHide();totalSelectedAmount = 0">{{ 'reports' | translate }}</a></li>
                    </ul>
                  </div><!--end .card-head -->
                  <div class="card-body tab-content">
                    <!-- Fee Collection sub tab -->
                    <div class="status-container-button" *ngIf="this.isActivateDeactivateButtonVisible">
                      <div class="toggle-student-container">
                        <input type="checkbox" [(ngModel)]="isStudentDeactiveStatusChecked"
                          (change)="toggleStudentStatus()" />
                        <div class="slider-student-status"></div>
                      </div>
                    </div>
                    <div class="tab-pane active" id="fee-collection" style="padding: 0px 15px; margin-top: 32px;">
                      <div class="row col-md-4">
                        <img src="images_ext/money.png" style="padding: 0px 15px;">
                        <h4 style="margin-top: -40px;margin-left: 6em;font-weight: 700;">{{ 'feesCollection' | translate }}</h4>
                      </div>
                      <div class="col-md-8">
                        <form class="form">
                          <div class="form-group ">
                            <div class="btn-group" style="    margin-bottom: 3px;">
                              <button title="Search Student By Registration Number" id="search-reg-id"
                                style="border: var(--brand-primary-color) solid 1px;background-color: white;"
                                class="btn ink-reaction filter-active" type="button"><i class="fa fa-file-text-o"
                                  aria-hidden="true"></i></button>
                              <button title="Search Student By Student Name" id="search-by-name"
                                style="border: var(--brand-primary-color) solid 1px;background-color: white;" class="btn ink-reaction "
                                type="button"><i class="fa fa-user" aria-hidden="true"></i></button>
                              <button title="Search Student By Mobile Number" id="search-by-mobile"
                                style="border: var(--brand-primary-color) solid 1px;background-color: white;" class="btn ink-reaction "
                                type="button"><i class="fa fa-phone" aria-hidden="true"></i></button>
                            </div>
                            <div class="input-group zed-index-0">
                              <div class="input-group-content">
                                <input type="text" class="form-control" autocomplete="off" id="groupbutton10"
                                    [placeholder]="'searchStudentByRegNo' | translate"
                                  style="border: 1px solid #e6e6e6;padding: 0px 15px;font-weight: 100;font-size: 12px;">
                              </div>
                              <div class="input-group-btn" style="    padding-left: 0;">
                                <button (click)="searchStudent('YES')" class="btn btn-default" type="button"
                                  style="background: var(--brand-primary-color);    color: white;"><i class="fa fa-search"></i></button>
                              </div>
                            </div>
                          </div>
                        </form>
                        <div *ngIf="isSearchActive" class="search-input-container"
                          style="    margin-bottom: 10px;display: block;border: 1px #f2f3f3 solid;padding:20px">
                          <div *ngIf="studentList.length > 0">
                            <div id="select-student-name-in-search" (click)="fetchFeeCollectionInfo(s)"
                              *ngFor="let s of studentList" style=" padding: 5px;cursor: pointer;">
                              <i class="fa fa-user"></i>&nbsp;
                              <span>{{s.studentName}}({{s.parentName}}) <span class="class-highl">{{ 'class' | translate }}
                                  {{s.classNumber}} {{s.classDivision}}</span>, {{s.mobileNumber}}<span
                                  style="font-weight: 600" *ngIf="s.BusStopName">,{{
                                  s.BusStopName}}</span></span>&nbsp;<i *ngIf="s.isLoading"
                                class="fa fa-spinner fa-spin"></i>
                            </div>
                          </div>
                          <div id="select-student-name-in-search-msg" *ngIf="studentList.length == 0"
                            style=" padding: 5px;">
                            <span>{{ 'thereAreNoSearchResults' | translate }}</span>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="!isSearchActive" class="row col-md-12">
                        <div class="card col-md-3 text-center"
                          style="margin-left: 1%;width: 35%;background-color: var(--brand-primary-color);color: white;">

                          <h4 style="background: green; line-height: 1.5;"
                            *ngIf="(academicInfo.current_academic_state == 'RUNNING' || academicInfo.current_academic_state == 'NOT_STARTED')">
                            <a [style.cursor]="isStudentDeactivated ? 'default' : 'pointer'"
                              [style.textDecoration]="isStudentDeactivated ? 'none' : 'underline'" style="color: white;"
                              (click)="!isStudentDeactivated && openEditStudentPopupFunction(studentFeeDashDetails.student.studentId)">
                              {{studentFeeDashDetails.student.studentName}}
                            </a>
                            <div class="hide btn-group dropleft student-edit-icon">
                              <i class="fas fa-user-edit cursor-pointer" data-toggle="dropdown"
                                aria-expanded="true"></i>
                              <ul class="dropdown-menu animation-expand dropdown-menu-down" role="menu">
                                <li class="cursor-pointer" (click)="openStudentBasicInfoPopup = true">
                                  <a><i class="fas fa-user-edit" aria-hidden="true"></i>&nbsp;&nbsp;{{ 'basicInfo' | translate }}</a>
                                </li>
                                <li (click)="openStudentContactInfoPopup = true" class="cursor-pointer">
                                  <a><i class="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;{{ 'contactDetails' | translate }}</a>
                                </li>
                                <li class="divider"></li>
                                <li class="cursor-pointer">
                                  <a data-dismiss="modal" aria-hidden="true"><i
                                      class="fa fa-fw fa-times text-danger"></i> {{ 'cancel' | translate }}</a>
                                </li>
                              </ul>
                            </div>
                          </h4>
                          <h4 style="background: green;line-height: 1.5;"
                            *ngIf="academicInfo.current_academic_state != 'RUNNING' && academicInfo.current_academic_state != 'NOT_STARTED'">
                            {{studentFeeDashDetails.student.studentName}}</h4>
                          <!--<h4><span style="cursor:pointer;">{{studentFeeDashDetails.student.studentName}}</span></h4>-->
                          <h4>{{studentFeeDashDetails.student.parentName}}</h4>
                          <span>{{ 'class' | translate }}
                            {{studentFeeDashDetails.student.classNumber}}-{{studentFeeDashDetails.student.classDivision}},
                            Roll No.{{studentFeeDashDetails.student.rollNumber}}, </span>
                          <!-- <p>Student Category: {{studentFeeDashDetails.student.studentCategoryName}}</p>-->
                          <span>{{ 'fees' | translate }} {{studentFeeDashDetails.student.feeStructureName || 'Default'}}</span>
                          <div><span><i class="fa fa-mobile" aria-hidden="true"></i> :
                              {{lastSelectedStudent.mobileNumber}} </span> &nbsp;
                            <span *ngIf="academicPermissions.EDIT_STUDENT == 'ENABLED'">
                              <span *ngIf="lastSelectedStudent.BusStopName"><i class="fa fa-bus" aria-hidden="true"></i>
                                : <span style="cursor: pointer;text-decoration: underline"
                                  (click)="openStudentTransportOptionSettingsPopup = true">{{lastSelectedStudent.BusStopName}}</span></span>
                              <span *ngIf="!lastSelectedStudent.BusStopName"><i class="fa fa-bus"
                                  aria-hidden="true"></i> : <span style="cursor: pointer;text-decoration: underline"
                                  (click)="openStudentTransportOptionSettingsPopup = true">{{ 'setTransport' | translate }}</span></span>
                            </span>
                            <span *ngIf="academicPermissions.EDIT_STUDENT != 'ENABLED'">
                              <span *ngIf="lastSelectedStudent.BusStopName"><i class="fa fa-bus" aria-hidden="true"></i>
                                : <span>{{lastSelectedStudent.BusStopName}}</span></span>
                              <span *ngIf="!lastSelectedStudent.BusStopName"><i class="fa fa-bus"
                                  aria-hidden="true"></i> : <span>&nbsp; -</span></span>
                            </span>
                          </div>
                          <div *ngIf="studentFeeDashDetails.student.siblingsCount > 0"
                            (click)="fetchStudentSiblings(studentFeeDashDetails.student)" style="cursor: pointer;"><i
                              class="fas fa-user-friends"></i> &nbsp; <span style="text-decoration: underline;">{{ 'view' | translate }}
                              {{studentFeeDashDetails.student.siblingsCount}}
                              {{studentFeeDashDetails.student.siblingsCount > 1 ? 'siblings' : 'sibling'}} of
                              {{studentFeeDashDetails.student.studentName}}</span> &nbsp;<i
                              *ngIf="studentAllSiblingsLoading" class="fa fa-spinner fa-spin"></i><span
                              *ngIf="!studentAllSiblingsLoading" class="badge badge-danger">{{ 'new' | translate }}</span></div>
                        </div>

                        <!-- <div class="card col-md-3 text-center" style="margin-left: 1%;width: 35%;background-color: var(--brand-primary-color);color: white;">
                      <h4 style="background: green;line-height: 1.5;">
                        <span>{{studentFeeDashDetails.student.studentName}}</span>
                      </h4>
                      <h4>{{studentFeeDashDetails.student.parentName}}</h4>
                      <span>Class: {{studentFeeDashDetails.student.classNumber}}
                        -{{studentFeeDashDetails.student.classDivision}}
                        , Roll No.{{studentFeeDashDetails.student.rollNumber}}</span>
                      <span>Fees: {{studentFeeDashDetails.student.feeStructureName || 'Default'}}</span>
                      <p>
                        <span><i class="fa fa-mobile" aria-hidden="true"></i> : {{lastSelectedStudent.mobileNumber}} </span> &nbsp;
                        <span *ngIf="lastSelectedStudent.BusStopName"><i class="fa fa-bus" aria-hidden="true"></i> : <span>{{lastSelectedStudent.BusStopName}}</span></span>
                      </p>
                      <div class="btn-group dropleft student-edit-icon">
                        <i class="fas fa-user-edit cursor-pointer" data-toggle="dropdown" aria-expanded="true"></i>
                        <ul class="dropdown-menu animation-expand dropdown-menu-down" role="menu">
                          <li class="cursor-pointer" (click)="openStudentBasicInfoPopup = true">
                            <a><i class="fas fa-user-edit" aria-hidden="true"></i>&nbsp;&nbsp;Basic Info</a>
                          </li>
                          <li (click)="openStudentContactInfoPopup = true" class="cursor-pointer">
                            <a><i class="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;Contact Details</a>
                          </li>
                          <li (click)="openStudentTransportOptionSettingsPopup = (academicInfo.current_academic_state == 'RUNNING')" [ngClass]="(academicInfo.current_academic_state == 'RUNNING') ? '' : 'disabled'" class="cursor-pointer">
                            <a><i class="fa fa-bus" aria-hidden="true"></i>&nbsp;&nbsp;Transport Options</a>
                          </li>
                          <li class="cursor-pointer disabled">
                            <a><i class="fas fa-user-times" aria-hidden="true"></i>&nbsp;&nbsp;Deactivate</a>
                          </li>
                          <li class="divider"></li>
                          <li class="cursor-pointer">
                            <a data-dismiss="modal" aria-hidden="true"><i class="fa fa-fw fa-times text-danger"></i> Cancel</a>
                          </li>
                        </ul>
                      </div>
                    </div> -->
                        <div class="card col-md-3 text-center"
                          style="margin-left: 10px;width: 30%;background-color: var(--brand-primary-color);color: white;">
                          <h3 style="margin-top: 10px;">{{ 'termFees' | translate }}</h3>
                          <div>
                            <div><b>{{ 'totalTermFees' | translate }}</b> <span>{{currType}}</span>
                              {{studentFeeDashDetails.TermFees.TermAmount || 0}}</div>
                            <div><b>{{ 'paid' | translate }}</b> <span>{{currType}}</span> {{studentFeeDashDetails.TermFees.Paid || 0}}
                            </div>
                            <div><b>{{ 'discount' | translate }}</b> <span>{{currType}}</span> {{studentFeeDashDetails.TermFees.Discount ||
                              0}} </div>
                            <div><b>{{ 'balance' | translate }}</b> <span>{{currType}}</span> {{studentFeeDashDetails.TermFees.Balance ||
                              0}} </div>
                          </div>
                        </div>
                        <div class="card col-md-3 text-center"
                          style="margin-left: 10px;width: 30%;background-color: var(--brand-primary-color);color: white;">
                          <h3 style="margin-top: 10px;">{{ 'otherFees' | translate }}</h3>
                          <div>
                            <div><b>{{ 'totalOtherFees' | translate }}</b> <span>{{currType}}</span>
                              {{studentFeeDashDetails.TypeFees.FeeTypeAmount || 0}}</div>
                            <div><b>{{ 'paid' | translate }}</b> <span>{{currType}}</span> {{studentFeeDashDetails.TypeFees.Paid || 0}}
                            </div>
                            <div><b>{{ 'discount' | translate }}</b> <span>{{currType}}</span> {{studentFeeDashDetails.TypeFees.Discount ||
                              0}} </div>
                            <div><b>{{ 'balance' | translate }}</b> <span>{{currType}}</span> {{studentFeeDashDetails.TypeFees.Balance ||
                              0}} </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="!isSearchActive" class="row">
                        <div class="col-lg-12" style="padding: 0px 20px;">
                          <div class="card">
                            <div class="card-body" style="padding-left: 0; padding-right: 0;">
                              <div id="rootwizard11" class="form-wizard form-wizard-horizontal">
                                <form class="form ">
                                  <div class="form-wizard-nav">
                                    <div class="progress p3" style="height: 2px;margin-top: 5px;">
                                      <div class="progress-bar progress-bar-primary"></div>
                                    </div>
                                    <ul class="nav nav-justified">
                                      <li class="active"><a id="collectFee" (click)="showSelectedAmountFloating()"
                                          data-target="#tab1" data-toggle="tab"><span class="step">1</span> <span
                                            class="title">{{ 'feesCollection' | translate }}</span></a></li>
                                      <li id="transection"><a (click)="totalSelectedAmount = 0" data-target="#tab2"
                                          data-toggle="tab"><span class="step">2</span> <span class="title">{{ 'paymentTransaction' | translate }}</span></a></li>
                                      <li id="collectiontab"><a
                                          (click)="getFeeCollectionHistory(studentFeeDashDetails.student.studentId,studentFeeDashDetails.student.classId,'YES');totalSelectedAmount = 0"
                                          data-target="#tab3" data-toggle="tab"><span class="step">3</span> <span
                                            class="title">{{ 'paymentHistory' | translate }}</span></a></li>
                                      <li id="fee-update-history"><a
                                          (click)="getFeeCollectionUpdateHistory(studentFeeDashDetails.student.studentId,studentFeeDashDetails.student.classId,'YES');totalSelectedAmount = 0"
                                          data-target="#tab4" data-toggle="tab"><span class="step">4</span> <span
                                            class="title">{{ 'paymentUpdateHistory' | translate }}</span></a></li>
                                    </ul>
                                  </div><!--end .form-wizard-nav -->
                                  <div class="tab-content clearfix">
                                    <div class="tab-pane active" id="tab1">
                                      <br /><br />
                                      <div class="table-responsive">
                                        <table class="table table-striped">
                                          <thead style="background-color: var(--brand-primary-color);color: white;">
                                            <tr>
                                              <th>{{ 'select' | translate }}</th>
                                              <th *ngIf="academicPermissions.OLD_FEE_COLLECTION == 'ENABLED'">{{ 'isOldFee' | translate }}
                                              </th>
                                              <th>{{ 'feesFor' | translate }}</th>
                                              <th>{{ 'type' | translate }}</th>
                                              <th>{{ 'dueDate' | translate }}</th>
                                              <th>{{ 'fees' | translate }}({{currType}})</th>
                                              <th>{{ 'paid' | translate }}({{currType}})</th>
                                              <th>{{ 'discount' | translate }}({{currType}})</th>
                                              <th>{{ 'balance' | translate }}({{currType}})</th>
                                              <th>{{ 'late-fee' | translate }}({{currType}})</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr
                                              *ngIf="studentFeeDashDetails.old_fee && ((studentFeeDashDetails.old_fee.TermFees.Balance + studentFeeDashDetails.old_fee.TypeFees.Balance) != 0)">
                                              <td colspan="10" style="text-align: center;"><span
                                                  style="color:red">{{ 'previousAcademic' | translate }}
                                                  <b>({{studentFeeDashDetails.old_fee.old_year}})</b> {{ 'pendingFeeIs' | translate }}
                                                  <b><span>{{currType}}</span>
                                                    {{studentFeeDashDetails.old_fee.TermFees.Balance +
                                                    studentFeeDashDetails.old_fee.TypeFees.Balance}}</b> {{ 'pleaseClick' | translate }} <a
                                                    style="text-decoration: underline;font-weight: bold;cursor: pointer;color: var(--brand-primary-color);"
                                                    (click)="academicInfo.current_academic = studentFeeDashDetails.old_fee.old_ac_id;academicChanged()">{{ 'here' | translate }}</a>
                                                  {{ 'toCollect' | translate }}</span></td>
                                            </tr>
                                            <tr>
                                              <td colspan="10" style="text-align: center;"><span style="color:red">{{ 'click' | translate }}
                                                  <a style="text-decoration: underline;font-weight: bold;cursor: pointer;color: var(--brand-primary-color);"
                                                    (click)="fetchStudentPreviousAcademicFees()">{{ 'here' | translate }} <i
                                                      *ngIf="studentAllAcademicFeeLoading"
                                                      class="fa fa-spinner fa-spin"></i></a> {{ 'toSeeAllAcademicPendingFeeToCollect' | translate }}</span></td>
                                            </tr>
                                            <tr *ngFor="let t of feeCollectionAllFeeList;let i = index">
                                              <td>
                                                <div class="checkbox">
                                                  <label>
                                                    <input
                                                      (change)="checkDisableState(i,feeCollectionAllFeeList.length,t.selected,'terms','feeCollectionAllFeeList')"
                                                      [disabled]="t.disabled" *ngIf="t.Balance != 0" type="checkbox"
                                                      name="{{i}}" [(ngModel)]="t.selected"
                                                      style="zoom: 1.5;margin: 0px;">
                                                    </label>
                                                </div>
                                              </td>
                                              <td *ngIf="academicPermissions.OLD_FEE_COLLECTION == 'ENABLED'">
                                                <div class="checkbox">
                                                  <label><input type="checkbox" [disabled]="!t.selected"
                                                      *ngIf="t.Balance != 0" [(ngModel)]="t.isOldFee" name="{{'11'+i}}"
                                                      style="zoom: 1.5;margin: 0px;"></label>
                                                </div>
                                              </td>
                                              <td>
                                                <div *ngIf="studentFeeList.feeSetting.isFeesModuleEnable == 'ENABLED'">
                                                  <span *ngIf="t.TermName" (click)="showTermFeeBreakup(t)"
                                                    data-target="#term-fee-breakup-popup" data-toggle="modal"
                                                    style="text-decoration: underline;"
                                                    class="text-primary cursor-pointer">{{t.isBusFee ? (t.termName+'
                                                    ('+t.Name+')') : (t.Name || t.TermName)}}</span>
                                                  <span *ngIf="!t.TermName">{{t.isBusFee ? (t.termName+' ('+t.Name+')')
                                                    : (t.Name || t.TermName)}}</span>
                                                </div>
                                                <div *ngIf="studentFeeList.feeSetting.isFeesModuleEnable != 'ENABLED'">
                                                  <span>{{t.isBusFee ? (t.termName+' ('+t.Name+')') : (t.Name ||
                                                    t.TermName)}}</span>
                                                </div>
                                              </td>
                                              <td>{{t.isBusFee ? 'Transport' : t.TermName ? 'Term' : 'Other'}}</td>
                                              <td>{{parseDatewww(t.DueDate)}}</td>
                                              <td>{{t.feesTermAmount || t.feesTypeAmount}}</td>
                                              <td>{{t.Paid || 0}}&nbsp;<span *ngIf="t.feeFault"
                                                  (click)="errorDisplayInTerm(t)" class="fa fa-info-circle"
                                                  style="color: red; cursor:pointer"></span></td>
                                              <td>{{t.discount || t.Discount || 0}}</td>
                                              <td>{{t.Balance || 0}}</td>
                                              <td>{{t.lateFee || 0}}</td>
                                            </tr>
                                            <tr *ngIf="feeCollectionAllFeeList.length == 0">
                                              <td colspan="10" style="    text-align: center;">{{ 'thereAreNoFeesWhichAreApplicableTo' | translate }}<b>{{studentFeeDashDetails.student.studentName}}</b>
                                                {{ 'in' | translate }} <b>{{academicInfo.year}}</b> {{ 'academic' | translate }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div *ngIf="academicPermissions.OTHER_FEES == 'ENABLED'">
                                          <h3>{{ 'otherFeeList' | translate }}</h3>
                                          <table class="table table-striped">
                                            <thead style="background-color: var(--brand-primary-color);color: white;">
                                              <tr>
                                                <th>{{ 'select' | translate }}</th>
                                                <th>{{ 'isOldFee' | translate }}</th>
                                                <th>{{ 'feesFor' | translate }}</th>
                                                <th>{{ 'type' | translate }}</th>
                                                <th>{{ 'dueDate' | translate }}</th>
                                                <th>{{ 'fees' | translate }}({{currType}})</th>
                                                <th>{{ 'paid' | translate }}({{currType}})</th>
                                                <th>{{ 'discount' | translate }}({{currType}})</th>
                                                <th>{{ 'balance' | translate }}({{currType}})</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr *ngFor="let t of feeCollectionOtherFeeTermFeeList;let i = index">
                                                <td>
                                                  <div class="checkbox">
                                                    <label><input
                                                        (change)="checkDisableState(i,feeCollectionOtherFeeTermFeeList.length,t.selected,'terms','feeCollectionOtherFeeTermFeeList')"
                                                        [disabled]="t.disabled" *ngIf="t.Balance != 0" type="checkbox"
                                                        name="{{'sel'+i}}" [(ngModel)]="t.selected"
                                                        style="zoom: 1.5;margin: 0px;"></label>
                                                  </div>
                                                </td>
                                                <td>
                                                  <div class="checkbox">
                                                    <label><input type="checkbox" [disabled]="!t.selected"
                                                        *ngIf="t.Balance != 0" [(ngModel)]="t.isOldFee"
                                                        name="{{'sel11'+i}}" style="zoom: 1.5;margin: 0px;"></label>
                                                  </div>
                                                </td>
                                                <td>
                                                  <div>
                                                    <span>{{t.Name+' ('+t.termName+')'}}</span>
                                                  </div>
                                                </td>
                                                <td>{{'Other-Term'}}</td>
                                                <td>{{parseDatewww(t.termDueDate)}}</td>
                                                <td>{{t.termAmount}}</td>
                                                <td>{{t.Paid || 0}}</td>
                                                <td>{{t.discount || t.Discount || 0}}</td>
                                                <td>{{t.Balance || 0}}</td>
                                              </tr>
                                              <tr *ngIf="feeCollectionOtherFeeTermFeeList.length == 0">
                                                <td colspan="9" style="    text-align: center;">{{ 'thereAreNoOtherFeeTermsWhichAreApplicableTo' | translate }}
                                                  <b>{{studentFeeDashDetails.student.studentName}}</b> {{ 'in' | translate }}
                                                  <b>{{academicInfo.year}}</b> {{ 'academic' | translate }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      <div class="row text-right" style="margin-bottom: 10px;">
                                        <button (click)="makePayment('ANY')" type="button"
                                          class="btn btn-raised ink-reaction btn-info" id="makepayment1">{{ 'makePayment' | translate }}</button>
                                      </div>
                                    </div><!--end #tab1 -->
                                    <div class="tab-pane" id="tab2">
                                      <br /><br />
                                      <div class="card-head col-md-12">
                                        <ul class="nav nav-tabs" data-toggle="tabs">
                                          <li class="active paymentdetail" id="paymentDetailTabHeader"><a>{{ 'paymentDetails' | translate }}</a></li>
                                          <li id="payment-mode"><a>{{ 'modeOfPayment' | translate }}</a></li>
                                        </ul>
                                      </div>
                                      <div class="card-body tab-content col-md-12">
                                        <div class="tab-pane active" id="payment-details">
                                          <div class="col-md-8">
                                            <div class="table-responsive">
                                              <table class="table table-striped">
                                                <thead>
                                                  <tr>
                                                    <th>{{ 'name' | translate }}</th>
                                                    <th>{{ 'amount' | translate }}({{currType}})</th>
                                                    <th>{{ 'paid' | translate }}({{currType}})</th>
                                                    <th>{{ 'discount' | translate }}({{currType}})</th>
                                                    <th>{{ 'balance' | translate }}({{currType}})</th>
                                                    <th>{{ 'late-fee' | translate }}({{currType}})</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr *ngFor="let fee of selectedPayment">
                                                    <td>{{fee.Name}}</td>
                                                    <td>{{fee.Amount}}</td>
                                                    <td>{{fee.Paid}}</td>
                                                    <td>{{fee.Discount}}</td>
                                                    <td>{{fee.Balance}}</td>
                                                    <td>{{fee.lateFee}}</td>
                                                  </tr>
                                                  <tr style="background: #ffffff">
                                                    <td colspan="6" style="background: #ffffff; border-width:0"></td>
                                                  </tr>
                                                  <tr style="background: #f9f9f9;">
                                                    <td colspan='4'>{{ 'payableAmount' | translate }}({{currType}})</td>
                                                    <td id="calculatePayableAmount"></td>
                                                    <td id="calculateLateFeeAmount"></td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                            <div class="table-responsive">
                                              <table class="table table-striped" style="background: #f9f9f9;">
                                                <tbody>
                                                  <tr [style.display]="isOldFee ? '' : 'none'">
                                                    <td style="width: 25%">{{ 'paidOn' | translate }}</td>
                                                    <td style="width: 40%">
                                                      <input format="dd/mm/yyyy" placeholder="Select date" type="text"
                                                        class="form-control" id="paidOnDateOldFee_date" />
                                                    </td>
                                                    <td style="width: 30%">
                                                      <input format="dd/mm/yyyy" placeholder="Select time" type="text"
                                                        class="form-control" id="paidOnDateOldFee_time" />
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                          <div class="col-md-4">
                                            <div class="card" style="margin-top: 3em;">
                                              <div class="card-body">
                                                <form class="form" role="form">
                                                  <div class="form-group " style="margin-top: -30px;">
                                                    <div style="display: flex;justify-content: space-between;">
                                                      <span
                                                        style="color: var(--filter-dropdown-color);margin-top: 7px;font-size: 14px;">{{ 'totalFee' | translate }}({{currType}})</span>
                                                      <div style="display: flex;width: 40%;">
                                                        <input name="payable" type="text" class="form-control"
                                                          id="payableAmount" style="float: right;margin-left: 20px;"
                                                          (keyup)="calculateTotalToDisplay()" />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="form-group " style="margin-top: -30px;">
                                                    <div style="display: flex;justify-content: space-between;">
                                                      <div style="display: flex">
                                                        <div class="checkbox">
                                                          <input id="waiveOffLateFeeCheckbox" type="checkbox"
                                                            [disabled]="payableLateFee <= 0" [checked]="applyLateFee"
                                                            (change)="checkWaiveOffLateFee()">
                                                        </div>
                                                        <span
                                                          style="color: var(--filter-dropdown-color);margin-top: 7px;font-size: 14px;">{{ 'totalLate-fee' | translate }}({{currType}})</span>
                                                      </div>
                                                      <div style="display: flex;width: 40%;">
                                                        <span style="display: flex;align-items: center;">+ </span>
                                                        <input disabled name="payable2" type="text" class="form-control"
                                                          id="payableLateFeeAmount"
                                                          style="float: right;margin-left: 10px;border-bottom-style: solid" />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div data-toggle="modal" class="hidden" style="height: 100px"
                                                    data-target="#confirm-waive-off-late-fee-popup"
                                                    id="confirm-waive-off-late-fee"></div>
                                                  <div class="form-group " style="margin-top: -30px;">
                                                    <div style="display: flex;justify-content: space-between;">
                                                      <span style="color: var(--filter-dropdown-color);margin-top: 7px;font-size: 14px;">{{ 'payNow' | translate }}({{currType}})</span>
                                                      <div style="display: flex;width: 40%;">
                                                        <span style="display: flex;align-items: center;">= </span>
                                                        <input disabled name="payable3" type="text" class="form-control"
                                                          id="totalAmount"
                                                          style="float: right;margin-left: 10px;border-bottom-style: solid" />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </form>
                                                <div class="text-center">
                                                  <button (click)="proceedToPaymentMode()" type="button" id="proceed"
                                                    class="btn btn-raised ink-reaction btn-info"
                                                    style="float: right;margin-top: 20px;">{{ 'proceed' | translate }}</button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div id="mode-of-payment" class="tab-pane col-md-12">
                                          <div class="radio radio-styled text-center">
                                            <label>
                                              <input id="mode-of-payment-cash" (change)="changePaymentMode('Cash')"
                                                type="radio" name="optionsRadios" class="cash" checked>
                                              <span style="display: inline;padding-top: 4px">{{ 'cash' | translate }}</span>
                                            </label>
                                            <label style="margin-left: 10px">
                                              <input (change)="changePaymentMode('Card')" type="radio"
                                                name="optionsRadios">
                                              <span style="display: inline;padding-top: 4px">{{ 'card' | translate }}</span>
                                            </label>
                                            <label id="card-cash-mode" style="margin-left: 10px">
                                              <input (change)="changePaymentMode('Card&Cash')" type="radio"
                                                name="optionsRadios">
                                              <span style="display: inline;padding-top: 4px">{{ 'cardCash' | translate }}</span>
                                            </label>
                                            <label style="margin-left: 10px">
                                              <input (change)="changePaymentMode('QRCode')" type="radio"
                                                name="optionsRadios">
                                              <span style="display: inline;padding-top: 4px">{{ 'qrCode' | translate }}</span>
                                            </label>
                                            <label style="margin-left: 10px">
                                              <input (change)="changePaymentMode('Bank-transfer')" type="radio"
                                                name="optionsRadios">
                                              <span style="display: inline;padding-top: 4px">{{ 'bankTransfer' | translate }}</span>
                                            </label>
                                            <label style="margin-left: 10px;">
                                              <input type="radio" name="optionsRadios"
                                                (change)="changePaymentMode('DD')" class="DD">
                                              <span style="display: inline;padding-top: 4px">{{ 'dd' | translate }}</span>
                                            </label>
                                            <label style="margin-left: 10px;">
                                              <input type="radio" name="optionsRadios"
                                                (change)="changePaymentMode('Cheque')" class="cheque">
                                              <span style="display: inline;padding-top: 4px">{{ 'cheque' | translate }}</span>
                                            </label>
                                          </div>

                                          <div id="payByCard" class="col-md-10 col-md-offset-1" style="display: none;">
                                            <div class="card">
                                              <div class="card-body">
                                                <h3 class="text-center" style="margin-top: 0px;">{{ 'addReferenceNo' | translate }}</h3>
                                                <form class="form" role="form">
                                                  <div class="form-group">
                                                    <input type="text" class="form-control" id="card_invoice">
                                                    <label for="card_invoice">{{ 'invoiceReferenceNo' | translate }}</label>
                                                  </div>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                          <div id="payByQRCode" class="col-md-10 col-md-offset-1"
                                            style="display: none;">
                                            <div class="card">
                                              <div class="card-body">
                                                <h3 class="text-center" style="margin-top: 0px;">{{ 'addReferenceNo' | translate }}</h3>
                                                <form class="form" role="form">
                                                  <div class="form-group">
                                                    <input type="text" class="form-control" id="qr_invoice">
                                                    <label for="qr_invoice">{{ 'invoiceReferenceNo' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input data-date-format="dd/mm/yyyy" type="text" id="qr_date"
                                                      class="form-control datepicker1"><i
                                                      class="glyphicon glyphicon-calendar"
                                                      style="float: right;margin-top: -15px;"></i>
                                                    <label>{{ 'creditedDate' | translate }}</label>
                                                  </div>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                          <div id="payByCard_Cash" class="col-md-10 col-md-offset-1"
                                            style="display: none;">
                                            <div class="card">
                                              <div class="card-body">
                                                <h3 class="text-center" style="margin-top: 0px;">{{ 'addReferenceNoPayDetail' | translate }}</h3>
                                                <form class="form" role="form">
                                                  <div class="form-group text-center">
                                                    <h4><span style="color: #2E7D32">{{ 'payableAmount' | translate }}
                                                      </span><span>{{currType}} {{totalPayableAmount +
                                                        payableLateFee}}/-</span></h4>
                                                  </div>
                                                  <div class="form-group">
                                                    <input type="text" class="form-control" id="card_cash_invoice">
                                                    <label for="card_cash_invoice">{{ 'invoiceReferenceNo' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input type="text" class="form-control" id="card_Amount">
                                                    <label for="card_Amount">{{ 'cardAmount' | translate }}({{currType}})</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input type="text" class="form-control" id="cash_Amount">
                                                    <!-- <label for="cash_Amount">Cash amount({{currType}})</label> -->
                                                    <label for="cash_Amount">{{ 'cashAmount' | translate }} ({{currType}}) (<span
                                                        style="color: red;"><strong>{{ 'lateFeesShouldBeIncludedInTheCashAmountOnly' | translate }}</strong></span>)</label>
                                                  </div>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                          <div id="bank-transfer" class="col-md-10 col-md-offset-1"
                                            style="display: none;">
                                            <div class="card">
                                              <div class="card-body">
                                                <h3 class="text-center" style="margin-top: 0px;">{{ 'bankTransferInformation' | translate }}</h3>
                                                <form class="form" role="form">
                                                  <div class="form-group">
                                                    <input type="text" class="form-control"
                                                      id="bank_transfer_bankandbranch">
                                                    <label for="dd_bankandbranch">{{ 'bankNameBranch' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input data-date-format="dd/mm/yyyy" type="text"
                                                      id="bank_transfer_date" class="form-control datepicker1"><i
                                                      class="glyphicon glyphicon-calendar"
                                                      style="float: right;margin-top: -15px;"></i>
                                                    <label>{{ 'creditedDate' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input id="bank_transfer_number" type="text" class="form-control">
                                                    <label>{{ 'invoiceReferenceNo' | translate }}</label>
                                                  </div>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                          <div id="payByDD" class="col-md-10 col-md-offset-1" style="display: none;">
                                            <div class="card">
                                              <div class="card-body">
                                                <h3 class="text-center" style="margin-top: 0px;">{{ 'demandDraftInformation' | translate }}</h3>
                                                <form class="form" role="form">
                                                  <div class="form-group">
                                                    <input type="text" class="form-control" id="dd_bankandbranch">
                                                    <label for="dd_bankandbranch">{{ 'bankNameBranch' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input data-date-format="dd/mm/yyyy" type="text" id="dd_date"
                                                      class="form-control datepicker1"><i
                                                      class="glyphicon glyphicon-calendar"
                                                      style="float: right;margin-top: -15px;"></i>
                                                    <label>{{ 'date' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input id="dd_number" type="text" class="form-control">
                                                    <label>{{ 'ddNumber' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input id="dd_micrcode" type="text" class="form-control">
                                                    <label>{{ 'micrCode' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input id="dd_amount" type="number" class="form-control"
                                                      [ngModel]="">
                                                    <label>{{ 'ddAmount' | translate }}</label>
                                                  </div>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                          <div id="payBycheque" class="col-md-10 col-md-offset-1"
                                            style="display: none;">
                                            <div class="card">
                                              <div class="card-body">
                                                <h3 class="text-center" style="margin-top: 0px;">{{ 'chequeInformation' | translate }}</h3>
                                                <form class="form" role="form">
                                                  <div class="form-group">
                                                    <input type="text" class="form-control" id="cheque_bankandbranch">
                                                    <label for="cheque_bankandbranch">{{ 'bankNameBranch' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input data-date-format="dd/mm/yyyy" id="cheque_date" type="text"
                                                      class="form-control datepicker1"><i
                                                      class="glyphicon glyphicon-calendar"
                                                      style="float: right;margin-top: -15px;"></i>
                                                    <label>{{ 'date' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input id="cheque_number" type="text" class="form-control">
                                                    <label>{{ 'chequeNumber' | translate }}</label>
                                                  </div>
                                                  <div class="form-group">
                                                    <input id="cheque_amount" type="number" class="form-control">
                                                    <label>{{ 'chequeAmount' | translate }}</label>
                                                  </div>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="text-right">
                                            <button type="button" id="back" (click)="backToPaymentDetails()"
                                              class="btn btn-raised ink-reaction btn-info disable_buttons">{{ 'back' | translate }}</button>
                                            <button type="button" id="payment"
                                              (click)="proceedToPayment(finalPaymentList)"
                                              class="btn btn-raised ink-reaction btn-info disable_buttons">{{feePaymentProceedText}}</button>
                                            <button type="button" id="openFeeReceipt"
                                              class="btn btn-raised ink-reaction btn-info invisible" data-toggle="modal"
                                              data-target=".view-receipt" style="width: 1px;height:1px">{{ 'hiddenButton' | translate }}</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div><!--end #tab2 -->
                                    <div class="tab-pane" id="tab3">
                                      <br /><br />
                                      <div class="table-responsive">
                                        <table id="feeHistoryTable" class="table table-striped">
                                          <thead style="background-color: var(--brand-primary-color);color: white;">
                                            <tr>
                                              <th>{{ 'receiptNo' | translate }}</th>
                                              <th>{{ 'fees' | translate }}<br>{{ 'name' | translate }}</th>
                                              <th>{{ 'discount' | translate }}<br>({{currType}})</th>
                                              <th>{{ 'due' | translate }}<br>{{ 'date' | translate }}</th>
                                              <th>{{ 'paid' | translate }}<br>{{ 'amount' | translate }}<br>({{currType}})</th>
                                              <th>{{ 'paid' | translate }}<br>{{ 'lateFee' | translate }}<br>({{currType}})</th>
                                              <th>{{ 'paid' | translate }}<br>{{ 'date' | translate }}</th>
                                              <th>{{ 'actual' | translate }}<br>{{ 'collection' | translate }}<br>{{ 'date' | translate }}</th>
                                              <th>{{ 'mode' | translate }}</th>
                                              <th>{{ 'collected' | translate }}<br>{{ 'by' | translate }}</th>
                                              <th>{{ 'action' | translate }}</th>
                                            </tr>
                                          </thead>
                                          <tbody class="text-center">
                                            <tr *ngFor="let h of feeCollectionHistoy">
                                              <td>{{h.ReceiptNumber}}</td>
                                              <td>{{h.isBusFee == 1 ? 'Transport ('+h.Name+')' : h.Name}}</td>
                                              <td>{{h.DiscountAmount || 0}}</td>
                                              <td>{{(h.DueDate || h.DueDate != '0000-00-00 00:00:00') ? (h.DueDate |
                                                date: 'dd-MMM-yyyy') : ''}}</td>
                                              <td>{{h.Amount}}</td>
                                              <td>{{h.lateFees}}</td>
                                              <td>{{h.CreatedDate | date: 'dd-MMM-yyyy'}}</td>
                                              <td>{{h.ActualCollectionDate ? (h.ActualCollectionDate | date:
                                                'dd-MMM-yyyy') : '-'}}</td>
                                              <td>{{h.ModeOfPayment || 'Discount'}}</td>
                                              <td>{{h.username || '-'}}</td>
                                              <td>
                                                <a (click)="showFeeReceipt(h.ReceiptNumber,h)"
                                                  class="btn btn-flat ink-reaction" *ngIf="!h.isLoading">
                                                  <i class="md md-assignment" aria-hidden="true"></i>
                                                </a>
                                                <a (click)="openDeleteFeePopup(h,undefined,undefined)"
                                                  data-toggle="modal" data-target="#delete-fees_1"
                                                  class="btn btn-flat ink-reaction"
                                                  *ngIf="!h.isLoading && academicPermissions.DELETE_COLLECTED_FEE == 'ENABLED'">
                                                  <i class="fa fa-trash" aria-hidden="true"></i>
                                                </a>
                                                <i *ngIf="h.isLoading" class="fa fa-spinner fa-spin"></i>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <ul class="pager wizard hide">
                                        <!--<li class="previous first hide"><a class="btn-raised" href="javascript:void(0);">First</a></li>-->
                                        <li class="previous fees_history_prev" (click)="previousPage()"><a
                                            class="btn-raised fees_history_prev" href="javascript:void(0);">{{ 'previous' | translate }}</a>
                                        </li>
                                        <!-- <li class="next last hide"><a class="btn-raised" href="javascript:void(0);">Last</a></li>-->
                                        <li class="next fees_history_next" (click)="nextPage()"><a
                                            class="btn-raised fees_history_next" href="javascript:void(0);">{{ 'next' | translate }}</a>
                                        </li>
                                      </ul>
                                    </div><!--end #tab3 -->
                                    <div class="tab-pane" id="tab4">
                                      <br /><br />
                                      <div class="table-responsive">
                                        <table id="feeUpdateHistoryTable" class="table table-striped">
                                          <thead style="background-color: var(--brand-primary-color);color: white;">
                                            <tr>
                                              <th>{{ 'receiptNo' | translate }}</th>
                                              <th>{{ 'feesName' | translate }}</th>
                                              <th>{{ 'paidAmount' | translate }}({{currType}})</th>
                                              <th>{{ 'discount' | translate }}({{currType}})</th>
                                              <th>{{ 'paymentMode' | translate }}</th>
                                              <th>{{ 'paidDate' | translate }}</th>
                                              <th>{{ 'action' | translate }}</th>
                                              <th>{{ 'doneBy' | translate }}</th>
                                              <th>{{ 'dateOfAction' | translate }}</th>
                                              <th>{{ 'reason' | translate }}</th>
                                            </tr>
                                          </thead>
                                          <tbody class="text-center">
                                            <tr *ngFor="let h of feeCollectionUpdateHistoy">
                                              <td>{{h.ReceiptNumber}}</td>
                                              <td>{{h.isBusFee == 1 ? 'Transport ('+h.Name+')' : h.Name}}</td>
                                              <td>{{h.Amount}}</td>
                                              <td>{{h.DiscountAmount}}</td>
                                              <td>{{h.ModeOfPayment}}</td>
                                              <td>{{h.CreatedDate | date: 'dd-MMM-yyyy'}}</td>
                                              <td>{{'cancelled' | translate}}</td>
                                              <td>{{h.username}}</td>
                                              <td>{{h.UpdatedOn}}</td>
                                              <td>{{h.Reason}}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <ul class="pager wizard hide">
                                        <!--<li class="previous first hide"><a class="btn-raised" href="javascript:void(0);">First</a></li>-->
                                        <li class="previous fees_history_prev" (click)="previousPage()"><a
                                            class="btn-raised fees_history_prev" href="javascript:void(0);">{{ 'previous' | translate }}</a>
                                        </li>
                                        <!-- <li class="next last hide"><a class="btn-raised" href="javascript:void(0);">Last</a></li>-->
                                        <li class="next fees_history_next" (click)="nextPage()"><a
                                            class="btn-raised fees_history_next" href="javascript:void(0);">{{ 'next' | translate }}</a>
                                        </li>
                                      </ul>
                                    </div><!--end #tab3 -->
                                  </div><!--end .tab-content -->

                                </form>
                              </div><!--end #rootwizard -->
                            </div><!--end .card-body -->
                          </div><!--end .card -->
                        </div><!--end .col -->
                      </div>
                    </div>
                    <div class="tab-pane" id="fee-collection-history" style="padding: 0px 15px; margin-top: 32px;">

                      <form class="form">
                        <div class="form-group " style="display: inline-block;">
                          <h5 style="font-size: 13px;font-weight: 400;color: #8e8e8e;">{{ 'from' | translate }} &nbsp;&nbsp;</h5>
                        </div>
                        <div class="form-group " style="display: inline-block;">
                          <input type="text" class="form-control applyPicker" id="startdate"
                            style="text-transform: initial;border: none;color: #868686;border-bottom: 1px solid gainsboro;"
                            data-provide="datepicker" data-date-format="dd/mm/yyyy">
                        </div>
                        <div class="form-group " style="display: inline-block;">
                          <h5 style="color: #a7a7a7;"> {{ 'to' | translate }} &nbsp;&nbsp;</h5>
                        </div>
                        <div class="form-group " style="display: inline-block;">
                          <input type="text" class="form-control applyPicker" id="enddate"
                            style="text-transform: initial;border: none;color: #868686;border-bottom: 1px solid gainsboro;"
                            data-provide="datepicker" data-date-format="dd/mm/yyyy">
                        </div>
                        <div *ngIf="academicPermissions.LATE_FEE_COLLECTION == 'ENABLED'" class="toggle-container">
                          <input type="checkbox" id="lateFeeCheckbox" (change)="toggleLateFee()">
                          <span class="slider"></span>
                        </div>
                        <div class="" style="display: inline-block; vertical-align: middle;">
                          <button *ngIf="!processingNwCall" (click)="getFeeCollectionHistoryForStudent()" type="button"
                            class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false"
                            style="background: var(--select-bg-color);border: none;margin-top: 5px;padding: 3px 15px;font-size: 12px;">
                            {{ 'viewDetails' | translate }}
                          </button>
                          <button [disabled]="1+1" *ngIf="processingNwCall" type="button"
                            class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false"
                            style="background: var(--select-bg-color);border: none;margin-top: 5px;padding: 3px 15px;font-size: 12px;">
                           {{ 'pleaseWait' | translate }}
                          </button>
                        </div>

                        <div id="feeColl" class="" style="margin-top: 2em;">
                          <h3
                            style="    text-decoration: underline;margin-left:3%;font-weight: 100;margin: 7px;color: #777777;">
                            {{ 'feesCollectionByModeOfPayment' | translate }}</h3>
                          <div class="row" style="    margin: 0;    padding: 10px 15px;">
                            <table class="table table-striped ">
                              <tbody>
                                <tr>
                                  <td>{{ 'modeOfPayment' | translate }}</td>
                                  <td>{{ 'cash' | translate }}</td>
                                  <td>{{ 'card' | translate }}</td>
                                  <td>{{ 'qrCode' | translate }}</td>
                                  <td>{{ 'bankTransfer' | translate }}</td>
                                  <td>{{ 'dd' | translate }}</td>
                                  <td>{{ 'cheque' | translate }}</td>
                                  <td>{{ 'online' | translate }}</td>
                                  <td>{{ 'total' | translate }}"</td>
                                </tr>
                                <tr>
                                  <td>{{ 'amount' | translate }}({{currType}})</td>
                                  <td>{{feesCollectionModesWise?.totalCashAmount || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalCardAmount || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalQRCodeAmount || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalBankTransferAmount || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalDDAmount || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalChequeAmount || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalOnlineAmount || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalAmount || 0}}</td>
                                </tr>
                                <tr>
                                  <td>{{ 'stundentsUniqueCount' | translate }}</td>
                                  <td>{{feesCollectionModesWise?.totalCashPaidStudents || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalCardPaidStudents || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalQRCodePaidStudents || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalBankTransferStudents || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalDDStudents || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalChequeStudents || 0}}</td>
                                  <td>{{feesCollectionModesWise?.totalOnlinePaidStudents || 0}}</td>
                                  <td>{{feesCollectionModesWise?.studentsPaid || 0}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--                           
                          <div class="col-md-3">
                            <div class="col-md-12 card overview-data">
                              <div class="col-md-3 text-center" style="    background: #E91E63;">
                                <i class="fa fa-money"></i>
                              </div>
                              <div class="col-md-9">
                                <h4><app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="processingNwCall"></app-loader></h4>
                                <h4 *ngIf="!processingNwCall">{{currType}} {{feesCollectionModesWise?.totalAmount || 0}}</h4>
                                <p>Total</p>
                                <p style="margin-left: -10px;">{{feesCollectionModesWise?.studentsPaid || 0}} students</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="col-md-12 card overview-data">
                              <div class="col-md-3 text-center" style="    background: #8BC34A;">
                                <i class="fa fa-money"></i>
                              </div>
                              <div class="col-md-9">
                                <h4><app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="processingNwCall"></app-loader></h4>
                                <h4 *ngIf="!processingNwCall">{{currType}} {{feesCollectionModesWise?.totalCashAmount || 0}}</h4>
                                <p>Cash</p>
                                <p style="margin-left: -10px;">{{feesCollectionModesWise?.totalCashPaidStudents || 0}} students</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="col-md-12 card overview-data">
                              <div class="col-md-3 text-center" style="    background: #FF9800;">
                                <i class="fa fa-credit-card"></i>
                              </div>
                              <div class="col-md-9">
                                <h4><app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="processingNwCall"></app-loader></h4>
                                <h4 *ngIf="!processingNwCall">{{currType}} {{feesCollectionModesWise?.totalCardAmount || 0}}</h4>
                                <p>Card</p>
                                <p style="margin-left: -10px;">{{feesCollectionModesWise?.totalCardPaidStudents || 0}} students</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="col-md-12 card overview-data">
                              <div class="col-md-3 text-center" style="    background: #FF9800;">
                                <i class="fa fa-credit-card"></i>
                              </div>
                              <div class="col-md-9">
                                <h4><app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="processingNwCall"></app-loader></h4>
                                <h4 *ngIf="!processingNwCall">{{currType}} {{feesCollectionModesWise?.totalCardAmount || 0}}</h4>
                                <p>Bank transfer</p>
                                <p style="margin-left: -10px;">{{feesCollectionModesWise?.totalCardPaidStudents || 0}} students</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="col-md-12 card overview-data">
                              <div class="col-md-3 text-center" style="background: #607D8B;">
                                <i class="fa fa-newspaper-o" aria-hidden="true"></i>
                              </div>
                              <div class="col-md-9">
                                <h4><app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="processingNwCall"></app-loader></h4>
                                <h4 *ngIf="!processingNwCall">{{currType}} {{feesCollectionModesWise?.totalOnlineAmount || 0}}</h4>
                                <p>DD</p>
                                <p style="margin-left: -10px;">{{feesCollectionModesWise?.totalOnlinePaidStudents || 0}} students</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="col-md-12 card overview-data">
                              <div class="col-md-3 text-center" style="background: #607D8B;">
                                <i class="fa fa-newspaper-o" aria-hidden="true"></i>
                              </div>
                              <div class="col-md-9">
                                <h4><app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="processingNwCall"></app-loader></h4>
                                <h4 *ngIf="!processingNwCall">{{currType}} {{feesCollectionModesWise?.totalOnlineAmount || 0}}</h4>
                                <p>Cheque</p>
                                <p style="margin-left: -10px;">{{feesCollectionModesWise?.totalOnlinePaidStudents || 0}} students</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="col-md-12 card overview-data">
                              <div class="col-md-3 text-center" style="background: #607D8B;">
                                <i class="fa fa-cc-visa"></i>
                              </div>
                              <div class="col-md-9">
                                <h4><app-loader data="{{currType}}" loadingStyle="Dots" *ngIf="processingNwCall"></app-loader></h4>
                                <h4 *ngIf="!processingNwCall">{{currType}} {{feesCollectionModesWise?.totalOnlineAmount || 0}}</h4>
                                <p>Online</p>
                                <p style="margin-left: -10px;">{{feesCollectionModesWise?.totalOnlinePaidStudents || 0}} students</p>
                              </div>
                            </div>
                          </div> -->
                        </div>

                        <div class="" *ngIf="collectionByAdmin.length > 0">
                          <h3
                            style="    text-decoration: underline;margin-left:3%;font-weight: 100;margin: 7px;color: #777777;">
                            {{ 'feesCollectedByEachAdmin' | translate }}</h3>
                          <div class="row" style="    margin: 0;    padding: 10px 15px;">
                            <table class="table table-striped ">
                              <thead>
                                <tr>
                                  <th>{{ 'admin' | translate }}</th>
                                  <th>{{ 'cash' | translate }}({{currType}})</th>
                                  <th>{{ 'card' | translate }}({{currType}})</th>
                                  <th>{{ 'qrCode' | translate }}({{currType}})</th>
                                  <th>{{ 'bankTransfer' | translate }}({{currType}})</th>
                                  <th>{{ 'dd' | translate }}({{currType}})</th>
                                  <th>{{ 'cheque' | translate }}({{currType}})</th>
                                  <th>{{ 'totalCollected' | translate }}({{currType}})</th>
                                  <th>{{ 'lateFee' | translate }}({{currType}})</th>
                                  <th>{{ 'viewMore' | translate }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let col of collectionByAdmin">
                                  <td>{{col.collectedBy}}</td>
                                  <td>{{col.collectedAsCash}}</td>
                                  <td>{{col.collectedAsCard}}</td>
                                  <td>{{col?.collectedQRCodeAmount || 0}}</td>
                                  <td>{{col.collectedAsBankTransfer}}</td>
                                  <td>{{col.collectedAsDD}}</td>
                                  <td>{{col.collectedAsCheque}}</td>
                                  <td>{{col.collectedAmount}}</td>
                                  <td>{{col.collectedLateFee}}</td>
                                  <td>
                                    <a class="text-primary cursor-pointer"
                                      (click)="fetchAdminCollectedFeeHeadwise(col.CreatedBy,col.collectedBy,'ADMIN_WISE','')"
                                      data-toggle="modal" data-target="#admin_collection_headwise">{{ 'feeWise' | translate }}</a> &nbsp; |
                                    &nbsp; <a (click)="fetchAdminCancelledFee(col.CreatedBy,col.collectedBy)"
                                      data-toggle="modal" data-target="#admin_deleted-fee"
                                      class="text-primary cursor-pointer">{{ 'deletedFee' | translate }}</a>
                                  </td>
                                </tr>

                              </tbody>
                            </table>
                          </div>
                        </div>



                      </form>
                      <div style="display: flex;justify-content: space-between;align-items: center;">
                        <h3
                          style="margin-left:3%;font-weight: 100;margin: 7px;color: #777777;    text-decoration: underline;">
                          {{ 'feesCollectionByStudent' | translate }}</h3>
                        <a id="lateFeeCollectionHistory"
                          style="font-size: 15px;color: var(--filter-dropdown-color);text-decoration: underline;cursor: pointer"
                          data-toggle="modal" data-target="#paid-late-fee-popup" (click)="getPaidLateFeeList()">
                          {{ 'lateFeeCollectionByStudent' | translate }}
                        </a>
                      </div>
                      <div class="tab-pane" id="fee-collection-history1">
                        <div class="row" style="    margin: 0;    padding: 10px 15px;">
                          <table id="fee-collection-history-table" class="table table-striped ">
                            <thead>
                              <tr>
                                <th>{{ 'studentName' | translate }}</th>
                                <th>{{ 'parentName' | translate }}</th>
                                <th>{{ 'mobile' | translate }}</th>
                                <th>{{ 'amount' | translate }}({{currType}})</th>
                                <th>{{ 'lateFees' | translate }}({{currType}})</th>
                                <th>{{ 'class' | translate }}</th>
                                <th>{{ 'feeName' | translate }}</th>
                                <th>{{ 'feeType' | translate }}</th>
                                <th style="width: 100px">{{ 'date' | translate }}</th>
                                <th style="width: 100px">{{ 'creditDate' | translate }}</th>
                                <th>{{ 'paymentMode' | translate }}</th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="fee-collection-report" style="padding: 0px 15px; margin-top: 32px;">

                      <form class="form">
                        <div class="form-group " style="display: inline-block;">
                          <h5 style="font-size: 13px;font-weight: 400;color: #8e8e8e;">{{ 'from' | translate }} &nbsp;&nbsp;</h5>
                        </div>
                        <div class="form-group " style="display: inline-block;">
                          <input type="text" class="form-control applyPicker" id="rstartdate"
                            style="text-transform: initial;border: none;color: #868686;border-bottom: 1px solid gainsboro;"
                            data-provide="datepicker" data-date-format="dd/mm/yyyy">
                        </div>
                        <div class="form-group " style="display: inline-block;">
                          <h5 style="color: #a7a7a7;"> {{ 'to' | translate }} &nbsp;&nbsp;</h5>
                        </div>
                        <div class="form-group " style="display: inline-block;">
                          <input type="text" class="form-control applyPicker" id="renddate"
                            style="text-transform: initial;border: none;color: #868686;border-bottom: 1px solid gainsboro;"
                            data-provide="datepicker" data-date-format="dd/mm/yyyy">
                        </div>
                        <div *ngIf="academicPermissions.LATE_FEE_COLLECTION == 'ENABLED'" class="toggle-container">
                          <input type="checkbox" id="lateFeeCheckboxForReport" (change)="toggleLateFeeForReport()">
                          <span class="slider"></span>
                        </div>
                      </form>

                      <div class="">
                        <h3
                          style="    text-decoration: underline;margin-left:3%;font-weight: 100;margin: 7px;color: #777777;">
                        </h3>
                        <div class="row" style="    margin: 0;    padding: 10px 15px;">
                          <table class="table table-striped ">
                            <tbody>
                              <tr>
                                <td>
                                  <a [ngClass]="checkDateRangeSelected() ? '' : 'disabled'"
                                    class="text-primary cursor-pointer"
                                    (click)="fetchAdminCollectedFeeHeadwise(null,'','SINGLE_ACADEMIC',$event.target.innerText)"
                                    data-toggle="modal" data-target="#admin_collection_headwise">{{ 'dayWiseHeadFees' | translate }}({{academicInfo.year}})</a>
                                </td>
                                <td>
                                  <a [ngClass]="checkDateRangeSelected() ? '' : 'disabled'"
                                    class="text-primary cursor-pointer"
                                    (click)="fetchAdminCollectedFeeHeadwise(null,'','ALL_ACADEMICS',$event.target.innerText)"
                                    data-toggle="modal" data-target="#admin_collection_headwise">{{ 'dayWiseHeadFeesAllAcademics' | translate }}</a>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a [ngClass]="checkDateRangeSelected() ? '' : 'disabled'"
                                    class="text-primary cursor-pointer"
                                    (click)="fetchAdminCollectedFeeHeadwise(null,'','ACADEMIC_WISE',$event.target.innerText)"
                                    data-toggle="modal" data-target="#admin_collection_headwise">{{ 'academicWiseHeadFeesAllAcademics' | translate }}</a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div><!--end .card-body -->
                  <div class="col-md-12" style="text-align: left">
                    <button *ngIf="totalSelectedAmount > 0" class="btn ink-reaction btn-floating-action btn-primary"
                      style="background: var(--brand-primary-color);border: none;width: 160px;height: 65px;position:fixed;bottom:0;margin: 10em -5em;text-transform: initial;"
                      type="button">{{studentFeeDashDetails.student.studentName}}{{ 'sFee' | translate }}<br> {{currType}}
                      {{totalSelectedAmount}}</button>
                  </div>
                </div>
                <!-- End of Fee Collection -->

                <!-- Get List of Paid late fee -->
                <div class="modal fade" id="paid-late-fee-popup" tabindex="-1" role="dialog" aria-hidden="true">
                  <div class="modal-dialog" style="padding: 5em 0 0 0;width: 65vw">
                    <div class="modal-content" style="padding: 0 1.5em 1em 1.5em;border: 2px solid;width: 80vw">
                      <button
                        style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1.5em;float: right;border: none;"
                        type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                        aria-hidden="true">&times;</button>
                      <h3 style="text-align: center;color: var(--brand-primary-color);">{{ 'paidLateFeeList' | translate }}</h3>
                      <table id="paid-late-fee-component-table" class="table table-striped ">
                        <thead>
                          <tr>
                            <th>{{ 'studentName' | translate }}</th>
                            <th>{{ 'parentName' | translate }}</th>
                            <th>{{ 'registrationNumber' | translate }}</th>
                            <th>{{ 'class' | translate }}</th>
                            <th>{{ 'feeName' | translate }}</th>
                            <th>{{ 'feeType' | translate }}</th>
                            <th>{{ 'feeType' | translate }}</th>
                            <th>{{ 'collectedDate' | translate }}</th>
                            <th>{{ 'collectedBy' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- End of Get List of Paid late fee  -->

                <!-- confirm-waive-off-late-fee-popup -->
                <div class="modal fade" id="confirm-waive-off-late-fee-popup" tabindex="-1" role="dialog"
                  aria-hidden="true">
                  <div class="modal-dialog" style="padding: 10em 0em;">
                    <div class="modal-content" style="padding: 1em 0em;border: 2px solid;">
                      <div class="row text-center">
                        <span>{{ 'areYouSureYouWantToWaiveOffTheLateFee' | translate }}</span>
                        <br>
                        <span>{{ 'thisActionCannotBeUndone' | translate }}</span>
                      </div>
                      <div class="text-center" style="padding: 8px 0px;">
                        <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                          (click)="confirmWaiveOffLateFee()">{{ 'waiveOff' | translate }}</button>
                        <button id="close-confirm-waive-off-late-fee-popup" type="button"
                          class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal"
                          aria-hidden="true">{{ 'cancel' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End of confirm-waive-off-late-fee-popup  -->

                <!-- discount tab -->
                <div class="tab-pane" id="discount">
                  <div class="row" style="margin: 0;padding: 10px 15px;">
                    <div class="col-md-5 col-md-offset-3" style="margin-top:2em">
                      <p style="margin-left:3em"><b>{{ 'note' | translate }}</b> {{ 'allTheAmountsAreIn' | translate }} <b>{{currType}}</b> {{ 'currency' | translate }}</p>
                    </div>
                    <div class="row" style="    margin: 0;    padding: 10px 15px;">
                      <table id="fee-discounts-table" class="table table-striped ">
                        <thead>
                          <tr>
                            <th>{{ 'discountName' | translate }}</th>
                            <th>{{ 'feeStructure' | translate }}</th>
                            <th>{{ 'amountPercent' | translate }}</th>
                            <th>{{ 'appliedToStudents' | translate }}</th>
                            <th>{{ 'applyDiscount' | translate }}</th>
                            <th>{{ 'delete' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let discount of discountlist">
                            <td>{{discount.discountName}}</td>
                            <td>{{discount.FeeStructureName || 'Default'}}</td>
                            <td>{{discount.DiscountAmountType == 'AMOUNT' ? ' '+discount.discountAmount :
                              discount.discountPercentage+'%'}}<span class="hide">{{discount.DiscountAmountType}}</span>
                            </td>
                            <td *ngIf="discount.appliedTo == 0">{{discount.appliedTo}}</td>
                            <td *ngIf="discount.appliedTo != 0"><a
                                (click)="appliedStudentDiscount(discount.pkSchoolDiscountId,discount)"
                                data-toggle="modal" data-target="#appliedDiscountStudent"
                                style="cursor: pointer;text-decoration: underline;color: blue;">{{discount.appliedTo}}</a>
                            </td>
                            <td>
                              <a (click)="openApplyDiscount(discount)" class="btn btn-flat ink-reaction"
                                data-toggle="modal" data-target="#apply-discount" *ngIf="!discount.isLoading">
                                <i class="md md-assignment" aria-hidden="true"></i>
                              </a>

                              <i *ngIf="discount.isLoading" class="fa fa-spinner fa-spin"></i>
                            </td>
                            <td>
                              <button [disabled]="discount.appliedTo != 0" (click)="openDeleteDiscount(discount)"
                                data-toggle="modal" data-target="#delete_discount" class="btn btn-flat ink-reaction">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-12 text-right">
                    <button data-toggle="modal" data-target="#add-discount" (click)="addDiscountpopup()"
                      id="discountpopup" type="button" class="btn ink-reaction btn-floating-action btn-primary"
                      style="background: #E91E63;border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"><i
                        class="fa fa-plus"></i></button>
                  </div>
                </div>
                <!--End Of Discount tab-->

                <!-- Fees Setting -->
                <div class="tab-pane" id="fees-settings">
                  <!-- <div class="col-md-12 card" style="padding: 0px 13px;"> -->

                  <div class="card-head"
                    style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                    <h3>{{ 'feesSettingEnableOrDisable' | translate }}</h3>
                  </div>
                  <!-- <app-loader data="" loadingStyle="Dots" *ngIf="feesSettingsInfo.length == 0"></app-loader> -->
                  <div class="card-body" style="margin-top: 10px;">
                    <div class="col-md-6 card-wrapper" style="padding: 0px 10px;">
                      <div class="card">
                        <div class="col-md-6 text-center" style="padding: 0px 0px;">
                          <h5>{{ 'feesManagementInParentApp' | translate }}</h5>
                          <p style="font-size: 11px;">{{ 'followsFeesConfiguration' | translate }}</p>
                        </div>
                        <div class="col-md-6 text-center" style="padding: 0px 0px;margin-top: 14px;">
                          <div class=" payment-setting-group" data-toggle="buttons">
                            <label id="mobileFeesModule_enable" (click)="changeSetting('MOBILE_FEES_MODULE','ENABLED')"
                              class="btn ink-reaction btn-primary">
                              <input type="radio" name="options"> {{ 'enable' | translate }}
                            </label>
                            <label id="mobileFeesModule_disable"
                              (click)="changeSetting('MOBILE_FEES_MODULE','DISABLED')"
                              class="btn ink-reaction btn-primary active">
                              <input type="radio" name="options"> {{ 'disable' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 card-wrapper hidden-card" style="padding: 0px 10px; display:none">
                      <div class="card">
                        <div class="col-md-6 text-center" style="padding: 0px 0px;">
                          <h5>{{ 'feesManagementInParentApp' | translate }}</h5>
                          <p style="font-size: 11px;">{{ 'doesn'tFollowsFeesConfiguration' | translate }}</p>
                        </div>
                        <div class="col-md-6 text-center" style="padding: 0px 5px;margin-top: 14px;">
                          <div class=" payment-setting-group" data-toggle="buttons">
                            <label id="onlinePaymentIndependentTo_enable"
                              (click)="changeSetting('ONLINE_PAYMENT_INDEPENDENT_TO_FEES_STRUCTURE','ENABLED')"
                              class="btn ink-reaction btn-primary">
                              <input type="radio" name="options"> {{ 'enable' | translate }}
                            </label>
                            <label id="onlinePaymentIndependentTo_disable"
                              (click)="changeSetting('ONLINE_PAYMENT_INDEPENDENT_TO_FEES_STRUCTURE','DISABLED')"
                              class="btn ink-reaction btn-primary active">
                              <input type="radio" name="options"> {{ 'disable' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 card-wrapper" style="padding: 0px 10px;" id="mobileFeesPaymentdiv">
                      <div class="card" style="padding: 8px 0px;">
                        <div class="col-md-6 text-center" style="padding: 0px 0px;">
                          <h5>{{ 'allowOnlineFeesPaymentFromParentApp' | translate }}</h5>
                        </div>
                        <div class="col-md-6 text-center" style="padding: 0px 0px;margin-top: 8px;">
                          <div class=" payment-setting-group" data-toggle="buttons">
                            <label id="mobileFeesPayment_enable"
                              (click)="changeSetting('MOBILE_FEES_PAYMENT','ENABLED')"
                              class="btn ink-reaction btn-primary">
                              <input type="radio" name="options"> {{ 'enable' | translate }}
                            </label>
                            <label id="mobileFeesPayment_disable"
                              (click)="changeSetting('MOBILE_FEES_PAYMENT','DISABLED')"
                              class="btn ink-reaction btn-primary active">
                              <input type="radio" name="options" id="option3"> {{ 'disable' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 card-wrapper" style="padding: 0px 10px;" id="class_online_paymentdiv">
                      <div class="card" style="padding: 12px 0px;">
                        <div class="col-md-6 text-center" style="padding: 0px 0px;">
                          <h5>{{ 'enableOnlinePaymentForEachClassSection' | translate }}</h5>
                        </div>
                        <div class="col-md-6 text-center" style="padding: 0px 0px;margin-top: 8px;">
                          <button type="button" (click)="getClassFeesSettings()" id="add-class-setting-online-button"
                            class="btn btn-raised ink-reaction btn-info">{{ 'addRemove' | translate }}</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 card-wrapper" style="padding: 0px 10px;" id="term_fee_breakup">
                      <div class="card" style="padding: 2px 0px;">
                        <div class="col-md-6 text-center" style="padding: 0px 0px;">
                          <h5>{{ 'showBreakupFeeInTermFee' | translate }}</h5>
                          <p style="font-size: 11px;">{{ 'feesCollectionAndFeeReceipt' | translate }}</p>
                        </div>
                        <div class="col-md-6 text-center" style="padding: 0px 0px;margin-top: 8px;">
                          <div class="" data-toggle="buttons">
                            <label id="term_fee_breakup_enable"
                              (click)="changeSetting('SHOW_TERM_FEE_BREAKUP','ENABLED')"
                              class="btn ink-reaction btn-primary">
                              <input type="radio" name="term_fee_breakup_options"> {{ 'enable' | translate }}
                            </label>
                            <label id="term_fee_breakup_disable"
                              (click)="changeSetting('SHOW_TERM_FEE_BREAKUP','DISABLED')"
                              class="btn ink-reaction btn-primary active">
                              <input type="radio" name="term_fee_breakup_options" id="option4"> {{ 'disable' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                  <div id="add-class-setting-online-div" style="display: none;">
                    <div class="col-md-12 card" style="padding: 0px 13px;">
                      <div class="card-head"
                        style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                        <h3>{{ 'onlinePaymentInClassSections' | translate }}</h3>
                      </div>
                      <div class="card-body" style="margin-top: 10px;">
                        <div class="form-group">
                          <label class="col-md-2 checkbox-styled" *ngFor="let s of classFeesSettings">
                            <input type="checkbox" [(ngModel)]="s.selected"><span>{{s.classNumber}} -
                              {{s.classDivision}}</span>
                          </label>
                        </div>
                        <div class="col-md-12 text-right">
                          <button type="button" id="add-class-setting-online-cancel" (click)="originalFeeBoardConfig = []; originalFeeTermConfig =[]; this.selectedClassIdForFeeCopy = null"
                            class="btn btn-raised ink-reaction btn-info">{{ 'cancel' | translate }}</button>
                          <button type="button" id="add-class-setting-online-save" (click)="updateClassFeeSettings()"
                            class="btn btn-raised ink-reaction btn-info">{{ 'save' | translate }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="showOldMerchantAccountPayment" id="online_payment_setting_tabs">
                    <div class="col-md-12 card">
                      <div class="card-head">
                        <ul class="nav nav-tabs" data-toggle="tabs">
                          <li class="active"><a style="cursor: pointer;" data-target="#merchant-account"
                              data-toggle="tab">{{ 'merchantAccount' | translate }}</a></li>
                          <li class=""><a style="cursor: pointer;" data-target="#payment-purpose" data-toggle="tab"
                              (click)="getPaymentPurposes()">{{ 'onlinePaymentPurpose' | translate }}</a></li>
                          <li><a style="cursor: pointer;" data-target="#payment-limit" data-toggle="tab"
                              (click)="getPaymentLimits()">{{ 'paymentLimits' | translate }}</a></li>
                        </ul>
                      </div>
                      <div class="card-body tab-content">
                        <div class="tab-pane active" id="merchant-account">
                          <div [style.display]="(merchantAcccSts == 'CREATE') ? 'block' : 'none' " id="createmerchant"
                            class="col-md-12 card" style="padding: 0px 13px">
                            <div class="card-head"
                              style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                              <h3>{{ 'createMerchantAccountForSchool' | translate }}</h3>
                            </div>
                            <div class="card-body" style="padding: 4em 0em;">
                              <div class="col-md-7 col-md-offset-2 card">
                                <div class="card-head text-center">
                                  <h4>{{ 'createAMerchant' | translate }}</h4>
                                  <p>{{ 'parentsWillPayOnlineFeeThroughThisMerchantAccount' | translate }}</p>
                                </div>
                                <div class="card-body">
                                  <form class="form">
                                    <div class="form-group">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-user"
                                            aria-hidden="true"></i></span>
                                        <div class="input-group-content">
                                          <input [(ngModel)]="createMerchant.username" type="text" class="form-control"
                                            id="username" name="username">
                                          <label for="username">{{ 'username' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope-o"
                                            aria-hidden="true"></i></span>
                                        <div class="input-group-content">
                                          <input type="text" class="form-control" id="email" name="email"
                                            [(ngModel)]="createMerchant.email">
                                          <label for="email">{{ 'emailAddress' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-mobile"
                                            aria-hidden="true"></i></span>
                                        <div class="input-group-content">
                                          <input type="text" class="form-control" id="phone" name="phone"
                                            [(ngModel)]="createMerchant.phone">
                                          <label for="phone">{{ 'phone' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-lock"
                                            aria-hidden="true"></i></span>
                                        <div class="input-group-content">
                                          <input type="password" class="form-control" id="password" name="password"
                                            [(ngModel)]="createMerchant.password">
                                          <label for="password">{{ 'password' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-lock"
                                            aria-hidden="true"></i></span>
                                        <div class="input-group-content">
                                          <input type="password" class="form-control" id="confirmpassword"
                                            name="confirmpassword" [(ngModel)]="createMerchant.confirmPassword">
                                          <label for="confirmpassword">{{ 'confirmPassword' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="text-center" style="padding: 0px 20px;">
                                      <button id="create-merchant-button" type="button"
                                        (click)="createInstamojoMerchantAccount(createMerchant.username,createMerchant.email,createMerchant.phone,createMerchant.password,createMerchant.confirmPassword)"
                                        class="btn btn-block ink-reaction btn-info" style="margin: 2em 0em;">{{ 'createAnAccount' | translate }}</button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="merchantAcccSts == 'SHOW_ACCOUNT'" id="merchantaccountStatus"
                            class="col-md-12 card" style="padding: 0px 13px">
                            <div class="card-head"
                              style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                              <h3>{{ 'merchantAccount' | translate }}</h3>
                            </div>
                            <div class="card-body" style="padding: 4em 0em;">
                              <div class="col-md-7 col-md-offset-2 card">
                                <div class="card-head text-center">
                                  <h3>{{ 'schoolMerchantAccountInformation' | translate }}</h3>
                                  <p style="margin-top: -20px;">{{ 'parentsWillPayOnlineFeeThroughThisMerchantAccount' | translate }}</p>
                                </div>
                                <div class="card-body">
                                  <div class="user-images-info text-center" style="margin-top: -30px;"><img
                                      src="{{ instamojoUser ? instamojoUser.schoolImage : ''}}"
                                      style="width:110px;height:110px;border-radius: 1em;" class="text-center"></div>
                                  <div class="col-md-12" style="    margin-top: 10px;">
                                    <div class="col-md-4 col-md-offset-1">
                                      <h5>{{ 'username' | translate }}</h5>
                                    </div>
                                    <div class="col-md-6 col-md-offset-1">
                                      <p>{{instamojoUser.username}}</p>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="col-md-4 col-md-offset-1">
                                      <h5>{{ 'emailAddress' | translate }}</h5>
                                    </div>
                                    <div class="col-md-6 col-md-offset-1">
                                      <p>{{instamojoUser.emailId}}</p>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="col-md-4 col-md-offset-1">
                                      <h5>{{ 'phoneNumber' | translate }}</h5>
                                    </div>
                                    <div class="col-md-6 col-md-offset-1">
                                      <p>{{instamojoUser.phoneNumber}}</p>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="col-md-4 col-md-offset-1">
                                      <h5>{{ 'applicantName' | translate }}</h5>
                                    </div>
                                    <div class="col-md-6 col-md-offset-1">
                                      <p>{{instamojoUser.bankHolderName || '--'}}</p>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="col-md-4 col-md-offset-1">
                                      <h5>{{ 'bankAccount' | translate }}</h5>
                                    </div>
                                    <div class="col-md-6 col-md-offset-1">
                                      <p>{{instamojoUser.bankAccountNumber || '--'}}</p>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="col-md-4 col-md-offset-1">
                                      <h5>{{ 'ifscCode' | translate }}</h5>
                                    </div>
                                    <div class="col-md-6 col-md-offset-1">
                                      <p>{{instamojoUser.bankIFSCCode || '--'}}</p>
                                    </div>
                                  </div>
                                  <div class="text-center" style="    padding: 0em 4em;">
                                    <button id="singinforUpdate" (click)="merchantAcccSts = 'SIGN_IN'" type="button"
                                      class="btn btn-block ink-reaction btn-info" style="margin: 1em 0em;">{{ 'updateBankAccount' | translate }}</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div [style.display]="(merchantAcccSts == 'SIGN_IN') ? 'block' : 'none' " id="signinToAccount"
                            class="col-md-12 card" style="display: none;">
                            <div class="card-head"
                              style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                              <h3>{{ 'signInToMerchantAccount' | translate }}</h3>
                            </div>
                            <div class="card-body" style="padding: 4em 0em;">
                              <div class="col-md-7 col-md-offset-2 card">
                                <div class="card-head text-center" style="padding: 2em 0em;">
                                  <img src="images_ext/bank11.png">
                                  <h4>{{ 'signInToMakeChanges' | translate }}</h4>
                                  <p style="margin-top: -15px;">{{ 'enterYourMerchantAccountUsernamePasswordToLogin' | translate }}</p>
                                </div>
                                <div class="card-body" style="margin-top: -2em;">
                                  <form class="form">
                                    <div class="form-group floating-label">
                                      <div class="input-group">
                                        <span class="input-group-addon"><span
                                            class="glyphicon glyphicon-user fa-lg"></span></span>
                                        <div class="input-group-content">
                                          <input type="text" class="form-control" name="username_l"
                                            [(ngModel)]="loginInstamojo.username" id="username_l">
                                          <label for="username_l"
                                            [ngClass]="{'highlight-label': loginInstamojo.username !== ''}">{{ 'username' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group floating-label">
                                      <div class="input-group">
                                        <span class="input-group-addon"><span
                                            class="glyphicon glyphicon-lock fa-lg"></span></span>
                                        <div class="input-group-content">
                                          <input type="password" class="form-control" name="password_l" id="password_l"
                                            [(ngModel)]="loginInstamojo.password">
                                          <label for="password_l"
                                            [ngClass]="{'highlight-label': loginInstamojo.password !== ''}">{{ 'password' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="text-center" style="padding: 0px 20px;">
                                      <button type="button" id="instamojoSignIn"
                                        (click)="logIntoMerchantAccount(loginInstamojo.username,loginInstamojo.password)"
                                        class="btn btn-block ink-reaction btn-info" style="margin: 2em 0em;">{{ 'signIn' | translate }}</button>
                                    </div>
                                  </form>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div [style.display]="(merchantAcccSts == 'BANK_INFO') ? 'block' : 'none' "
                            id="updatebankinfo" class="col-md-12 card">
                            <div class="card-head"
                              style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                              <h3>{{ 'updateYourBankInformation' | translate }}</h3>
                            </div>
                            <div class="card-body" style="padding: 4em 0em;">
                              <div class="col-md-7 col-md-offset-2 card">
                                <div class="card-head text-center" style="padding: 2em 0em;">
                                  <img src="images_ext/bank11.png">
                                  <h4>{{ 'provideYourBankInformation' | translate }}</h4>
                                  <p style="margin-top: -15px;">{{ 'enterYourBankDetails' | translate }}</p>
                                </div>
                                <div class="card-body" style="margin-top: -2em;">
                                  <form class="form">
                                    <div class="form-group floating-label">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-user-secret fa-2x"></i></span>
                                        <div class="input-group-content">
                                          <input type="text" class="form-control"
                                            [(ngModel)]="bankDetailsUpdate.bankHolderName" name="bankHolderName"
                                            id="bankHolderName">
                                          <label for="bankHolderName"
                                            [ngClass]="{'highlight-label': bankDetailsUpdate.bankHolderName !== ''}">{{ 'bankHolderName' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group floating-label">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-university fa-2x"
                                            aria-hidden="true"></i></span>
                                        <div class="input-group-content">
                                          <input type="text" [(ngModel)]="bankDetailsUpdate.accountNumber"
                                            class="form-control" name="accountNumber" id="accountNumber">
                                          <label for="accountNumber"
                                            [ngClass]="{'highlight-label': bankDetailsUpdate.accountNumber !== ''}">{{ 'bankAccountNumber' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group floating-label">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-code-fork fa-2x"
                                            aria-hidden="true"></i></span>
                                        <div class="input-group-content">
                                          <input type="text" class="form-control"
                                            [(ngModel)]="bankDetailsUpdate.iFSCCode" name="iFSCCode" id="iFSCCode">
                                          <label for="iFSCCode"
                                            [ngClass]="{'highlight-label': bankDetailsUpdate.iFSCCode !== ''}">{{ 'ifscCode' | translate }}</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="text-center" style="padding: 0px 20px;">
                                      <button id="saveBnakInfo"
                                        (click)="updateBankDetails(bankDetailsUpdate.bankHolderName,bankDetailsUpdate.accountNumber,bankDetailsUpdate.iFSCCode,bankDetailsUpdate.userId)"
                                        type="button" class="btn btn-block ink-reaction btn-info"
                                        style="margin: 2em 0em;">{{ 'saveInformation' | translate }}</button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="payment-purpose">
                          <div class="col-md-12 card">
                            <div class="card-head"
                              style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                              <h3>{{ 'onlinePaymentPurpose' | translate }}</h3>
                            </div>
                            <div class="card-body">
                              <div class="col-md-12" style="padding: 2em 0em;">
                                <div class="col-md-10">
                                  <form class="form" role="form">
                                    <div class="form-group">
                                      <input type="text" name="createPurpose" [(ngModel)]="createPurpose"
                                        class="form-control" id="createPurpose"
                                        placeholder="Enter purpose (max 200 characters)">
                                    </div>
                                  </form>
                                </div>
                                <div class="col-md-2" style="    margin-top: 15px;">
                                  <button type="button" id="createPurpose"
                                    (click)="addOnlinePaymentPurpose(createPurpose)"
                                    class="btn btn-raised ink-reaction btn-info">{{ 'savePurpose' | translate }}</button>
                                </div>
                              </div>
                              <div class="" style="padding: 2em 0em;">
                                <div *ngFor="let p of onlinePaymentPurposes;  let i = index;">
                                  <div class="col-md-5 col-md-offset-1"
                                    style="    display: flex;background-color: gainsboro;height: 25px;margin-top: 5px;">
                                    <div class="col-md-1">
                                      <p>{{i + 1}}.</p>
                                    </div>
                                    <div class="col-md-10">
                                      <p>{{p.Purpose}}</p>
                                    </div>
                                    <div (click)="deletePurpose_openPopup(p)" class="col-md-1"
                                      style="color: red;cursor: pointer;" data-target="#remove-paymentpurpose"
                                      data-toggle="modal">
                                      <i class="fa fa-times" aria-hidden="true"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="payment-limit">
                          <div class="col-md-12 card">
                            <div class="card-head"
                              style="background-color: var(--select-bg-color);margin: -13px;padding: 0px 20px;color: white;">
                              <h3>{{ 'onlinePaymentLimits' | translate }}</h3>
                            </div>
                            <div class="card-body">
                              <div class="col-md-12" style="padding: 2em 0em;">
                                <p>- {{ 'maximumAmount' | translate }}" <b>{{currType}}</b>.{{paymentLimits.miniumumAmount}} {{ 'maximumAmount' | translate }} <b>{{currType}}</b>.{{paymentLimits.maximumAmount}}</p>
                              </div>
                              <div class="col-md-12">
                                <div class="col-md-6">
                                  <div class="col-md-5">
                                    <h4>{{ 'minimum' | translate }} <b>{{currType}}</b>.</h4>
                                  </div>
                                  <div class="col-md-7" style="    margin-top: -20px;">
                                    <form class="form" role="form">
                                      <div class="form-group">
                                        <input type="number" name="minimum"
                                          [(ngModel)]="paymentLimits.onlineFeePaymentMinimum" class="form-control">
                                      </div>
                                    </form>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="col-md-5">
                                    <h4>{{ 'maximum' | translate }} <b>{{currType}}</b>.</h4>
                                  </div>
                                  <div class="col-md-7" style="    margin-top: -20px;">
                                    <form class="form" role="form">
                                      <div class="form-group">
                                        <input type="number" name="maximum"
                                          [(ngModel)]="paymentLimits.onlineFeePaymentMaximum" class="form-control">
                                      </div>
                                    </form>
                                  </div>
                                </div>
                                <div class="col-md-12 text-right" style="padding: 2em 0em;">
                                  <button type="button" id="save_payment_limits"
                                    (click)="updatePaymentLimits(paymentLimits.onlineFeePaymentMinimum,paymentLimits.onlineFeePaymentMaximum)"
                                    class="btn btn-raised ink-reaction btn-info">{{ 'saveLimits' | translate }}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="supported-currency-configuration" *ngIf="supportedCurrencyList.length > 0">
                    <div class="payment-gateway-heading">
                      {{'gatewaySelection' | translate}}
                    </div>
                    <div class="card-container">
                      <div class="supported-currency-card" *ngFor="let supportedCurrency of supportedCurrencyList">
                        <label class="container-radio">
                          <input type="radio" class="payment-radio" id="myRadioButton"
                            [checked]="supportedCurrency.isCurrentCurrency === 1"
                            (change)="handleSupportedCurrencyChange(supportedCurrency)">
                          <span class="currency-type ">{{supportedCurrency.currencyType}}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <app-loader data="" loadingStyle="Dots" *ngIf="paymentLoader"></app-loader>
                  <div *ngIf="!paymentLoader && isGatewayEnable && paymentGateways.length > 0"
                    class="payment-gateway-main-container">
                    <div class="payment-gateway-heading">
                         {{'gatewaySelection' | translate}}
                    </div>
                    <div class="card-container">
                      <div class="gateway-card" *ngFor="let gateway of paymentGateways">
                        <div class="content-horizontal">
                          <label class="container-checkbox">
                            <input type="checkbox" class="payment-checkbox" id="myCheckbox"
                              [checked]="gateway.isActive === 1"
                              [disabled]="gateway.isConfigured !== 1 || gateway.loader"
                              (change)="onCheckboxChange(gateway)" id="myCheckbox">
                            <span class="checkmark"></span>
                          </label>
                          <button *ngIf="gateway.isConfigured !== 1" class="request-btn" (click)="openPopup(gateway)"
                            data-toggle="modal" data-target="#requestConfirm">
                            {{ feesStrings.request }}
                          </button>
                          <span *ngIf="gateway.isConfigured === 1"
                            class="configured-style">{{'Configured' | translate}}</span>
                        </div>
                        <div class="gateway-info">
                          <img [src]="gateway.paymentGatewayLogo" alt="gateway-image" />
                          <p>{{gateway.paymentGatewayName}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="requestConfirm" tabindex="-1" role="dialog"
                      aria-labelledby="simpleModalLabel" aria-hidden="true" #requestConfirmModal>
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content gate-way-modal-content">
                          <div class="modal-body popup-content">
                            {{feesStrings.configureRequest}}
                          </div>
                          <div class="modal-footer gate-way-modal-footer">
                            <button class="btn-cancel" data-dismiss="modal">{{strings.cancel}}</button>
                            <button class="popup-request-btn" (click)="sendRequest(selectedGateway)" [disabled]="
                            gateWayRequestLoader
                              ">
                              <ng-container *ngIf="gateWayRequestLoader; else notLoading">
                                <app-button-loader></app-button-loader>
                              </ng-container>
                              <ng-template #notLoading>
                                {{feesStrings.SendRequest}}
                              </ng-template>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End of Fees Setting -->


                <!-- due fees -->
                <div class="tab-pane" id="duefee">
                  <div class="col-md-12" style="padding: 30px 30px;">
                    <form class="form-inline text-center search-groups" autocomplete="off">
                      <div class="form-group">
                        <label for="select13" class="control-label">{{ 'selectClass' | translate }}</label>

                        <select id="select13" name="select13" class="form-control">
                          <option value="">{{ 'selectOption' | translate }}</option>
                          <option value="class A">{{ 'classA' | translate }}</option>
                          <option value="class B">{{ 'classB' | translate }}</option>
                          <option value="class C">{{ 'classC' | translate }}</option>
                          <option value="class D">{{ 'classD' | translate }}</option>
                          <option value="class E">{{ 'classE' | translate }}</option>
                        </select>
                        <div class="form-control-line"></div>
                      </div>
                      <div class="form-group">
                        <label for="select133" class="control-label">{{ 'selectSection' | translate }}</label>

                        <select id="select133" name="select133" class="form-control">
                          <option value="">{{ 'selectOption' | translate }}</option>
                          <option value="section A">{{ 'sectionA' | translate }}</option>
                          <option value="section B">{{ 'sectionB' | translate }}</option>
                          <option value="section C">{{ 'sectionC' | translate }}</option>
                          <option value="section D">{{ 'sectionD' | translate }}</option>
                        </select>
                        <div class="form-control-line"></div>
                      </div>
                      <div class="form-group">
                        <label for="select1333" class="control-label">{{ 'status' | translate }}</label>

                        <select id="select1333" name="select1333" class="form-control">
                          <option value="">{{ 'selectOption' | translate }}</option>
                          <option value="active">{{ 'active' | translate }}</option>
                          <option value="deactive">{{ 'deactive' | translate }}</option>
                        </select>
                        <div class="form-control-line"></div>
                      </div>
                      <!-- <button type="submit" class="btn btn-raised btn-default-light ink-reaction">View Students</button> -->
                      <button type="button" class="btn btn-raised ink-reaction btn-info">{{ 'viewDueFees' | translate }}</button>
                      <!-- <button type="button" class="btn btn-raised ink-reaction btn-default-bright">Add Students</button> -->

                    </form>

                    <table id="example" class="display due-fees table-condensed" width="100%">
                      <thead>
                        <tr>
                          <th>{{ 'studentName' | translate }}</th>
                          <th>{{ 'guardian' | translate }}</th>
                          <th>{{ 'contact' | translate }}</th>
                          <th>{{ 'dueFeeComponents' | translate }}</th>
                          <th>{{ 'dueAmount' | translate }}</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>{{ 'shafeequeS' | translate }}</td>
                          <td>{{ 's' | translate }}</td>
                          <td>+91 9961177369</td>
                          <td>
                            <div class="bootstrap-tagsinput">
                              <span class="tag label label-info">{{ 'exam' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'transportation' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'tution' | translate }}<span data-role="remove"></span></span>
                            </div>
                          </td>
                          <td>{{currType}} 14,000</td>
                        </tr>

                        <tr>
                          <td>{{ 'shafeequeS' | translate }}</td>
                          <td>{{ 's' | translate }}</td>
                          <td>+91 9961177369</td>
                          <td>
                            <div class="bootstrap-tagsinput">
                              <span class="tag label label-info">{{ 'exam' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'transportation' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'tution' | translate }}<span data-role="remove"></span></span>
                            </div>
                          </td>
                          <td>{{currType}} 14,000</td>
                        </tr>

                        <tr>
                          <td>{{ 'shafeequeS' | translate }}</td>
                          <td>{{ 's' | translate }}</td>
                          <td>+91 9961177369</td>
                          <td>
                            <div class="bootstrap-tagsinput">
                              <span class="tag label label-info">{{ 'exam' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'transportation' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'tution' | translate }}<span data-role="remove"></span></span>
                            </div>
                          </td>
                          <td>{{currType}} 14,000</td>
                        </tr>

                        <tr>
                          <td>{{ 'shafeequeS' | translate }}</td>
                          <td>{{ 's' | translate }}</td>
                          <td>+91 9961177369</td>
                          <td>
                            <div class="bootstrap-tagsinput">
                              <span class="tag label label-info">{{ 'exam' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'transportation' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'tution' | translate }}<span data-role="remove"></span></span>
                            </div>
                          </td>
                          <td>{{currType}} 14,000</td>
                        </tr>

                        <tr>
                          <td>{{ 'shafeequeS' | translate }}</td>
                          <td>{{ 's' | translate }}</td>
                          <td>+91 9961177369</td>
                          <td>
                            <div class="bootstrap-tagsinput">
                              <span class="tag label label-info">{{ 'exam' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'transportation' | translate }}<span data-role="remove"></span></span>
                              <span class="tag label label-info">{{ 'tution' | translate }}<span data-role="remove"></span></span>
                            </div>
                          </td>
                          <td>{{currType}} 14,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>


              </div><!--end .card-body -->
            </div><!--end .card -->
          </div><!--end .col -->
          <!-- END LAYOUT LEFT SIDEBAR -->
        </div>

        <!-- layout hidden -->
        <div class="row hidden">
          <div class="col-md-12 card">
            <div class="row fees-details">
              <div class="col-md-3">
                <div class="col-md-12 card" style="padding: 15px 5px 5px 5px;">
                  <div class="col-md-4">
                    <i class="fa fa-area-chart fa-2x" style="background: #66BB6A;"></i>
                  </div>
                  <div class="col-md-8">
                    <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">51,34,000</h2>
                    <p>{{ 'totalFees' | translate }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="col-md-12 card" style="padding: 15px 5px 5px 5px;">
                  <div class="col-md-4">
                    <i class="fa fa-code-fork fa-2x" style="background: #FF9800;"></i>
                  </div>
                  <div class="col-md-8">
                    <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">20,430</h2>
                    <p>{{ 'discountMade' | translate }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="col-md-12 card" style="padding: 15px 5px 5px 5px;">
                  <div class="col-md-4">
                    <i class="fa fa-credit-card fa-2x" style="background: #E91E63;"></i>
                  </div>
                  <div class="col-md-8">
                    <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">{{currType}} 41,000</h2>
                    <p>{{ 'collectedFees' | translate }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="col-md-12 card" style="padding: 15px 5px 5px 5px;">
                  <div class="col-md-4">
                    <i class="fa fa-edit fa-2x" style="background: #00BCD4;"></i>
                  </div>
                  <div class="col-md-8">
                    <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">{{currType}} 51,09,470
                    </h2>
                    <p>{{ 'pendingFees' | translate }}</p>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-12 card" style="padding: 15px 5px;">
              <div class="col-md-4" style="padding-top: 15px;">
                <div class="col-md-6 text-right" style="padding: 0;">
                  <p class="lead" style="font-size: 15px; margin:0">
                    <i class="fa fa-circle" style="color: #00BCD4; margin-right: 10px;"></i> {{ 'feesCollections' | translate }}
                  </p>
                </div>
                <div class="col-md-6" style="padding: 0;">
                  <form>
                    <div class="form-group">
                      <select id="select1" name="select1" class="form-control"
                        style="color: var(--select-bg-color);height: 20px;border: none;text-decoration: underline;font-size: 15px;cursor: pointer;">
                        <option value="30">{{ 'byToday' | translate }}</option>
                        <option value="40">{{ 'byThisWeek' | translate }}</option>
                        <option value="50">{{ 'byThisMonth' | translate }}</option>
                      </select>
                    </div>
                  </form>
                </div>

              </div>


              <div class="col-md-6 day-week" style="    margin-top: 5px;">
                <button type="button"
                  class="btn ink-reaction btn-floating-action btn-sm btn-primary disabled">M</button>
                <button type="button"
                  class="btn ink-reaction btn-floating-action btn-sm btn-primary disabled">T</button>
                <button type="button"
                  class="btn ink-reaction btn-floating-action btn-sm btn-primary disabled">W</button>
                <button type="button" class="btn ink-reaction btn-floating-action btn-sm btn-primary">T</button>
                <button type="button"
                  class="btn ink-reaction btn-floating-action btn-sm btn-primary disabled">F</button>
                <button type="button"
                  class="btn ink-reaction btn-floating-action btn-sm btn-primary disabled">S</button>
                <button type="button"
                  class="btn ink-reaction btn-floating-action btn-sm btn-primary disabled">S</button>
                <button type="button" class="btn ink-reaction btn-info"
                  style="padding: 0px 35px;border-radius: 15px;float: right;margin-top: 5px;">{{ 'viewInDetail' | translate }}</button>
              </div>

              <div class="col-md-2">
                <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">{{currType}} 51,09,470</h2>
                <p class="text-left" style="    font-size: 10px;">{{ 'collected' | translate }}</p>
              </div>
            </div>



            <div class="col-md-12 card fees-details-by hidden">
              <div class="col-md-2" style="padding-top: 10px;">
                <p class="lead" style="font-size: 15px; margin:0">
                  <i class="fa fa-circle" style="color: #00BCD4;"></i>{{ 'feesCollected' | translate }}
                </p>
              </div>

              <div class="col-md-5">
                <div class="col-md-5">
                  <button type="button" class="btn btn-block ink-reaction btn-default-dark">{{ 'thisWeek' | translate }}</button>
                </div>
                <div class="col-md-7 text-center">
                  <div class="col-md-6">

                    <p><b>{{currType}} </b><b>79009</b></p>
                    <p class="title-by">{{ 'collected' | translate }}</p>
                  </div>
                  <div class="col-md-6">

                    <p><b>{{currType}} </b><b>79009</b></p>
                    <p class="title-by">{{ 'discount' | translate }}</p>
                  </div>
                </div>
              </div>

              <div class="col-md-5">
                <div class="col-md-5">
                  <button type="button" class="btn btn-block ink-reaction btn-default-dark">{{'thisMonth' | translate}}</button>
                </div>
                <div class="col-md-7 text-center">
                  <div class="col-md-6">
                    <p class="title-by">{{ 'collected' | translate }}</p>
                    <p><b>{{currType}} </b><b>79009</b></p>
                  </div>
                  <div class="col-md-6">
                    <p class="title-by">{{ 'discount' | translate }}</p>
                    <p><b>{{currType}} </b><b>79009</b></p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 card">{{ 'viewFeeDetails' | translate }}
              <div class="col-md-12 text-center"
                style=" background: #efefef;padding-bottom: 15px;border: 1px solid #e5e5e5;">
                <h3 class="lead" style="margin-bottom: 0;">{{ 'feesDetailsByClass' | translate }}</h3>

                <form class="form-inline text-center search-groups" autocomplete="off">
                  <div class="form-group" style="padding: 0;">
                    <!-- <label for="select14" class="control-label">Select Section</label> -->
                    <select id="select14" name="select14" class="form-control">
                      <option value="">{{ 'selectClass' | translate }}</option>
                      <option value="section A">{{ 'classI' | translate }}</option>
                      <option value="section B">{{ 'classIi' | translate }}</option>
                      <option value="section C">{{ 'classIii' | translate }}</option>
                      <option value="section D">{{ 'classIv' | translate }}</option>
                    </select>
                    <div class="form-control-line"></div>
                  </div>
                  <div class="form-group" style="padding: 0;">
                    <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="viewFeeDeails()"
                      style="    margin-top: -3px;">{{ 'viewFeeDetails' | translate }}</button>
                  </div>
                </form>
              </div>

              <table id="datatable01" class="table table-striped">
                <thead>
                  <tr>
                    <th>{{ 'className' | translate }}</th>
                    <th>{{ 'section' | translate }}</th>
                    <th>{{ 'totalFees' | translate }}</th>
                    <th>{{ 'discountAmount' | translate }}</th>
                    <th>{{ 'collectedAmount' | translate }}</th>
                    <th>{{ 'pendingAmount' | translate }}</th>

                  </tr>
                </thead>
                <tbody>
                  <tr class="gradeX class-fee">
                    <td>{{ 'lkg' | translate }}</td>
                    <td>{{ 'sectionA' | translate }}</td>
                    <td>
                      <p><b> </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                  </tr>
                  <tr class="gradeX class-fee">
                    <td>{{ 'ukg' | translate }}</td>
                    <td>{{ 'sectionA' | translate }}</td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                  </tr>
                  <tr class="gradeX class-fee">
                    <td>{{ 'classI' | translate }}</td>
                    <td>{{ 'sectionA' | translate }}</td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                  </tr>
                  <tr class="gradeX class-fee">
                    <td>{{ 'classI' | translate }}</td>
                    <td>{{ 'sectionB' | translate }}</td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                    <td>
                      <p><b>{{currType}} </b>1087277</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End layout hidden -->

        <!-- Admin fees collection headwise -->
        <div class="modal fade bd-example-modal-lg" id="admin_collection_headwise" tabindex="-1" role="dialog"
          aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div *ngIf="feeReportType == 'ADMIN_WISE'" class="modal-header"
                style="display: flex;background: var(--brand-primary-color);color: white;">
                <span>{{ 'feeCollectedBy' | translate }} &nbsp;</span>
                <h5 class="modal-title" id="exampleModalLabel"> {{selectedAdminName}}</h5>
              </div>
              <div *ngIf="feeReportType != 'ADMIN_WISE'" class="modal-header"
                style="display: flex;background: var(--brand-primary-color);color: white;">
                <span>{{headwiseReportsTableTitle}}</span>
              </div>
              <div class="modal-body" style="overflow-y: auto;">
                <div class="text-center" *ngIf="fetchAdminCollectedFeeisLoading">
                  <i class="fa fa-spinner fa-spin"></i>
                </div>
                <div >
                    <button *ngIf="adminCollectedFees.data && adminCollectedFees.data.length>0" (click)="exportHeadwiseToExcel(headwiseReportsTableTitle)" class="export-btn">{{ 'export' | translate }}</button>
                </div>
                <table id="admin_collection_headwise-table" class="table table-striped fee-report"
                  *ngIf="!fetchAdminCollectedFeeisLoading">
                  <thead>
                    <tr>
                      <th *ngIf="feeReportType != 'ACADEMIC_WISE'">{{ 'date' | translate }}</th>
                      <th *ngIf="feeReportType == 'ACADEMIC_WISE'">{{ 'academicYear' | translate }}</th>
                      <th *ngIf="feeReportType == 'ALL_ACADEMICS'">{{ 'academic' | translate }}</th>
                      <th *ngFor="let name of adminCollectedFees.allFeeNames; let last = last; let first = first"
                        class="top-bottom-border {{first ? 'left-border' : last ? 'right-border' : ''}}">{{name}}</th>
                      <th>{{ 'totalCash' | translate }}({{currType}})</th>
                      <th>{{ 'totalCard' | translate }}({{currType}})</th>
                      <th>{{ 'totalQrCode' | translate }}({{currType}})</th>
                      <th>{{ 'totalBank' | translate }}<br>{{ 'transfer' | translate }}({{currType}})</th>
                      <th>{{ 'total' | translate }}<br>{{ 'dd' | translate }}({{currType}})</th>
                      <th>{{ 'total' | translate }}<br>{{ 'cheque' | translate }}({{currType}})</th>
                      <th>{{ 'total' | translate }}<br>{{ 'online' | translate }}({{currType}})</th>
                      <th>{{ 'total' | translate }}<br>{{ 'fee' | translate }}({{currType}})</th>
                      <th>{{ 'total' | translate }}<br>{{ 'latefees' | translate }}"({{currType}})</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let f of adminCollectedFees.data">
                      <td>{{f.date || f.year}}</td>
                      <td *ngIf="feeReportType == 'ALL_ACADEMICS'">{{f.academics.join(' ')}}</td>
                      <td *ngFor="let _name of adminCollectedFees.allFeeNames; let last = last; let first = first"
                        class=" {{first ? 'left-border' : last ? 'right-border' : ''}}">{{f[_name] || 0}}</td>
                      <td>{{f.totalCash || 0}}</td>
                      <td>{{f.totalCard || 0}}</td>
                      <td>{{f.collectedAsQRCode || 0}}</td>
                      <td>{{f.collectedAsBankTransfer || 0}}</td>
                      <td>{{f.collectedAsDD || 0}}</td>
                      <td>{{f.collectedAsCheque || 0}}</td>
                      <td>{{f.collectedAsOnline || 0}}</td>
                      <td>{{(f.totalFee)}}</td>
                      <td>{{f.lateFees || 0}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer">
                <button style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary"
                  data-dismiss="modal">{{ 'close' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Admin fees collection headwise -->


        <!-- Deleted fees by admin -->
        <div class="modal fade bd-example-modal-lg" id="admin_deleted-fee" tabindex="-1" role="dialog"
          aria-labelledby="exampleModalLabel2" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header" style="display: flex;background: var(--brand-primary-color);color: white;">
                <span>{{ 'feeDeletedBy' | translate }} &nbsp;</span>
                <h5 class="modal-title" id="exampleModalLabel2"> {{selectedAdminName}}</h5>
              </div>
              <div class="modal-body">
                <div class="text-center" *ngIf="fetchAdminCollectedFeeisLoading">
                  <i class="fa fa-spinner fa-spin"></i>
                </div>

                <table id="admin_deleted-fee-table" class="table table-striped"
                  *ngIf="!fetchAdminCollectedFeeisLoading">
                  <thead>
                    <tr>
                      <th>{{ 'studentName' | translate }}</th>
                      <th>{{ 'fatherName' | translate }}</th>
                      <th>{{ 'registrationId' | translate }}</th>
                      <th>{{ 'feeName' | translate }}</th>
                      <th>{{ 'feeType' | translate }}</th>
                      <th>{{ 'mode' | translate }}</th>
                      <th>{{ 'amount' | translate }}({{currType}})</th>
                      <th>{{ 'reason' | translate }}</th>
                      <th>{{ 'deletedOn' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let f of adminCancelledFees">
                      <td>{{f.studentName}}</td>
                      <td>{{f.parentName}}</td>
                      <td>{{f.registrationId}}</td>
                      <td>{{f.Name}}</td>
                      <td>{{f.feeType}}</td>
                      <td>{{f.ModeOfPayment}}</td>
                      <td>{{f.Amount}}</td>
                      <td>{{f.Reason}}</td>
                      <td>{{f.UpdatedOn}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer">
                <button style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary"
                  data-dismiss="modal">{{ 'close' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Deleted fees by admin -->


        <!-- Admin fees collection headwise -->
        <div class="modal fade bd-example-modal-lg" id="group_class_fee_configuration" tabindex="-1" role="dialog"
          aria-labelledby="group_class_fee_configuration_1" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header" style="display: flex;background: var(--brand-primary-color);color: white;">
                <span>{{ 'mergeClassFeeConfiguration' | translate }}</span>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="text-center">
                    <i *ngIf="feeConfigGroupListLoading" class="fa fa-spinner fa-spin"></i>
                  </div>

                  <div *ngIf="!feeConfigGroupListLoading">
                    <div *ngIf="!createGroupFormState" class="text-center">
                      <div>{{ 'thereAreNoClassConfigurationGroupsCreatedPleaseUseBelowLinkToCreateThem' | translate }}</div>
                      <span class="btn btn-primary fa fa-plus-circle"
                        (click)="createGroupFormState = true">&nbsp;&nbsp;{{ 'createConfigurationGroup' | translate }}</span>
                    </div>

                    <div class="form-group" *ngIf="createGroupFormState" style="padding: 50px;">
                      <label for="configuration_group_name">{{ 'groupName' | translate }}</label>
                      <input [(ngModel)]="newConfigurationGroupName" type="text" class="form-control"
                        id="configuration_group_name" placeholder="Type group name here">
                      <div style="margin-top: 10px">
                        <span class="btn btn-primary" style="background: var(--brand-primary-color);color: white;float: right"
                          (click)="createNewFeeConfigurationGroup()">{{ 'create' | translate }}</span>
                        <span class="btn btn-primary" style="background: var(--brand-primary-color);color: white;float: right"
                          (click)="createGroupFormState = false">{{ 'cancel' | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!feeConfigGroupListLoading">
                    <div class="col-sm-3">
                      <div class="text-center" *ngIf="fetchAdminCollectedFeeisLoading">
                        <i class="fa fa-spinner fa-spin"></i>
                      </div>
                      <ul class="list-group">
                        <li class="list-group-item bw-menu-selected-item">Cras justo odio <i aria-hidden="true"
                            class="fa fa-chevron-right"></i></li>
                        <li class="list-group-item bw-menu-un-selected-item">Dapibus ac facilisis in</li>
                        <li class="list-group-item bw-menu-un-selected-item">Morbi leo risus</li>
                        <li class="list-group-item bw-menu-un-selected-item">Porta ac consectetur ac</li>
                        <li class="list-group-item bw-menu-un-selected-item">Vestibulum at eros</li>
                      </ul>
                    </div>
                    <div class="col-sm-9">
                      <div class="text-center" *ngIf="fetchAdminCollectedFeeisLoading">
                        <i class="fa fa-spinner fa-spin"></i>
                      </div>
                      <div class="col-md-2 cursor-pointer bw-selected-item">LKG-A <i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-selected-item">LKG-A <i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-un-selected-item">LKG-B<i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-un-selected-item">LKG-B<i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-selected-item">LKG-A <i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-selected-item">LKG-A <i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-selected-item">LKG-A <i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-selected-item">LKG-A <i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-un-selected-item">LKG-B<i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-un-selected-item">LKG-B<i aria-hidden="true"
                          class="fa fa-check"></i></div>
                      <div class="col-md-2 cursor-pointer bw-un-selected-item">LKG-B<i aria-hidden="true"
                          class="fa fa-check"></i></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary"
                  data-dismiss="modal">{{ 'close' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Admin fees collection headwise -->

        <!-- Remove payment purpose -->
        <div class="modal fade" id="remove-paymentpurpose" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="padding: 10em 0em;">
            <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
              <div class="row text-center">
                <h4>{{ 'areYouConfirmToRemovePaymentPurpose' | translate }}</h4>
              </div>
              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="savemovepurposepopup" (click)="deleteOnlinePaymentPurpose()"
                  class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'delete' | translate }}</button>
                <button type="button" id="closeremovepurposepopup" class="btn btn-raised ink-reaction btn-info"
                  style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- End of remove payment purpose -->

        <!-- Delete Bus -->
        <div class="modal fade" id="delete-student-category" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="padding: 10em 0em;">
            <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
              <div class="row text-center">
                <span>{{ 'areYouConfirmToDelete' | translate }} <b>{{addNewStudentCategory.name}}</b> {{ 'studentCategory' | translate }}</span>
              </div>
              <div class="text-center" style="padding: 8px 0px;">
                <button *ngIf="!isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                  style="padding: 3px 20px;"
                  (click)="deleteStudentCategory(deleteStudentCategoryDetails.pkStudentsCategoryId)">{{ 'delete' | translate }}</button>
                <button *ngIf="isProcessing" [disabled]="isProcessing" type="button"
                  class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'pleaseWait' | translate }}</button>
                <button id="deletebuspopup" type="button" class="btn btn-raised ink-reaction btn-info"
                  data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Delete Bus -->

        <!-- Fees collection term fee breakup -->
        <div class="modal fade" id="term-fee-breakup-popup" tabindex="-1" role="dialog"
          aria-labelledby="exampleModalLabel2" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header" style="display: flex;background: var(--brand-primary-color);color: white;">
                <span><b>{{breakupFeeTermName}}</b> {{ 'feeBreakup' | translate }}&nbsp;</span>
                <h5 class="modal-title" id="term-fee-breakup-popup12"></h5>
              </div>
              <div class="modal-body">
                <div class="text-center" *ngIf="fetchTermFeeBreakupisLoading">
                  <i class="fa fa-spinner fa-spin"></i>
                </div>

                <table id="term-fee-breakup-popup-table" class="table table-striped"
                  *ngIf="!fetchTermFeeBreakupisLoading">
                  <thead>
                    <tr>
                      <th>{{ 'feeComponent' | translate }}</th>
                      <th>{{ 'fees' | translate }}({{currType}})</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let f of termFeeBreakups">
                      <td>{{f.Name}}</td>
                      <td>{{f.Amount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer">
                <button style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary"
                  data-dismiss="modal">{{ 'close' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Fees collection term fee breakup -->

        <div class="modal fade" id="add-new-fee-board" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-12" style="background-color: white;padding: 3em 1em;">
                <div id="rootwizard1" class="form-wizard form-wizard-horizontal">
                  <button
                    style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3.6em;float: right;border: none;"
                    type="button" class="btn ink-reaction btn-floating-action btn-primary disable_buttons"
                    data-dismiss="modal" aria-hidden="true">&times;</button>
                  <div class="col-md-6" style="color: var(--brand-primary-color);margin-top: -27px;">
                    <div style="margin-top: -20px;">
                      <h3><span>{{currType}}</span>
                        <span style="font-size: initial;">{{ 'addFeeStructure' | translate }}</span>
                      </h3>
                    </div>
                  </div>
                  <br>
                  <form class="form" style="display: flex">
                    <div class="form-group" style="width: 48%;margin-left: 2%">
                      <select id="select-section-add-fee" name="select-section-add-fee" class="form-control">
                        <option value="">{{ 'selectClass' | translate }}</option>
                        <option value="{{c.classId}}" *ngFor="let c of classStandards">{{c.classNumber}}
                          {{c.classDivision}}</option>
                      </select>
                      <div class="form-control-line"></div>
                    </div>
                    <div class="form-group" style="width: 48%;margin-left: 2%">
                      <input [(ngModel)]="feeStructureName" id="fee-structure-name" type="text" name="123"
                        class="form-control">
                      <label for="fee-structure-name" style="margin-left: 15px;">{{ 'feeStructureName' | translate }}</label>
                    </div>
                  </form>
                  <form class="col-md-12 form"
                    style="height: 350px;overflow: overlay;border: 1px solid #f1f1f1;margin-bottom: 15px; margin-top: 10px;">
                    <div class="tab-pane" id="fee-section" style="padding: 0px 25px;margin-top: 15px;">
                      <form class="form">
                        <div class="form-group col-md-6" *ngFor="let com of feeComponentListAddFeeBoard">
                          <input [(ngModel)]="com.Amount" type="text" name="123" class="form-control"
                            id="{{com.pkFeesTypeId}}">
                          <label for="{{com.pkFeesTypeId}}" style="margin-left: 15px;">{{com.Name}}</label>
                        </div>
                      </form>
                      <br>
                    </div>
                  </form>
                  <br>
                  <div class="pager wizard text-center">
                    <button (click)="addFeeBoard()" type="button"
                      class="btn btn-raised ink-reaction btn-info disable_buttons"
                      style="padding: 3px 20px;">{{submitText}}</button>
                    <button id="close_add_fee_board" type="button" data-dismiss="modal"
                      class="btn btn-raised ink-reaction btn-info disable_buttons"
                      style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
                  </div>
                </div><!--end #rootwizard -->
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div>

        <!-- Add Other fee -->
        <div class="modal fade" id="add-other-fees" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-12" style="background-color: white;padding: 0px 20px;">
                <div class="row" style="padding: 10px 10px;">
                  <img src="images_ext/discount.png">
                  <h3 style="margin-top: -27px;margin-left: 2em;color: var(--brand-primary-color);">{{addNewOtherFee.pkOtherFeesId ? 'Edit
                    Other fee' : 'Add other fee'}}</h3>
                </div>
                <button
                  style="background-color: var(--brand-primary-color);margin-right: -2.3em;margin-top: -4.7em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form">
                  <div class="form-group">
                    <input type="text" class="form-control" [(ngModel)]="addNewOtherFee.name" name="othrFeeName">
                    <label style="font-size: small;">{{ 'name' | translate }}</label>
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" [(ngModel)]="addNewOtherFee.amount" name="othrFeeAmount">
                    <label style="font-size: small;">{{ 'amount' | translate }} ({{currType}})</label>
                  </div>
                </form>
                <div class="row text-center" style="padding: 15px 0px;">
                  <button *ngIf="!isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" (click)="addOtherFees(addNewOtherFee)">{{addNewOtherFee.pkOtherFeesId ?
                    ('save' | translate) : ('createText' | translate)}}</button>
                  <button *ngIf="isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" [disabled]="isProcessing">{{ 'pleaseWait' | translate }}</button>
                  <button id="close-add-otherfee" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" data-dismiss="modal">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!-- End of Add Other fee -->

        <!-- Delete other fee -->
        <div class="modal fade" id="delete-other-fee" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="padding: 10em 0em;">
            <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
              <div class="row text-center">
                <span>{{ 'areYouConfirmToDelete' | translate }} <b>{{selectedOtherFee.Name}}</b></span>
              </div>
              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                  (click)="deleteOtherFee()" [disabled]="isProcessing">{{isProcessing ? ('pleaseWait' | translate) :('delete' | translate)}}</button>
                <button id="close-delete-other-fee-popup" type="button" class="btn btn-raised ink-reaction btn-info"
                  style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Delete other fee  -->

        <!-- Add Other Term Fee -->
        <div class="modal fade" id="manage-other-fee-term" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal"
                  id="otherFeeTermsManagePopupClose">&times;</button>
                <h4 class="modal-title">{{ 'manage' | translate }} {{selectedOtherFee.Name}} {{ 'terms' | translate }}</h4>
                <span>{{ 'fee' | translate }} <b>{{selectedOtherFee.amount}} ({{currType}})</b></span>
              </div>
              <div *ngIf="fetchOtherFeesTermsProgress" class="text-center">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
              <div *ngIf="!fetchOtherFeesTermsProgress" style="background-color: white;padding: 2em 1em;">
                <form class="form" role="form" style="padding: 20px;" id="otherFeeTermManagement">
                  <div class="row" *ngFor="let trs of otherFeeTermsList; let i=index">
                    <div class="card">
                      <div class="card-body">
                        <div class="col-sm-3 form-group">
                          <input type="text" class="form-control" (change)="otherFeeTermChanged(i,'termName',trs)"
                            [(ngModel)]="trs.termName" [attr.value]="trs.termName" name="{{'termName_'+i}}"
                            id="{{'termName_'+i}}">
                          <label for="{{'termName_'+i}}" style="font-size: small;">{{ 'termName' | translate }}</label>
                        </div>
                        <div class="col-sm-3 form-group">
                          <input type="number" class="form-control" (change)="otherFeeTermChanged(i,'termAmount',trs)"
                            [(ngModel)]="trs.termAmount" [attr.value]="trs.termAmount" name="{{'termAmount_'+i}}"
                            id="{{'termAmount_'+i}}" [disabled]="trs.paidAmount > 0">
                          <label for="{{'termAmount_'+i}}" style="font-size: small;">{{ 'termAmount' | translate }} ({{currType}})</label>
                        </div>
                        <div class="col-sm-3 form-group">
                          <input data-date-format="dd/mm/yyyy" (change)="otherFeeTermChanged(i,'termDueDate',trs)"
                            [(ngModel)]="trs.termDueDate" [attr.value]="trs.termDueDate" name="{{'termDueDate_'+i}}"
                            type="text" id="{{'termDueDate_'+i}}" class="form-control datepicker1 otherFeeTermDueDate"
                            style="font-size: small;color: rgba(49, 53, 52, 0.51);"><i
                            class="glyphicon glyphicon-calendar" style="float: right;margin-top: -15px;"></i>
                          <label for="{{'termDueDate_'+i}}" style="font-size: small;">{{ 'dueDate' | translate }}</label>
                        </div>
                        <div class="col-sm-3 form-group text-center">
                          <a class="btn btn-flat ink-reaction" (click)="addAnotherTermToOtherFee()"
                            *ngIf="i == (otherFeeTermsList.length - 1)">
                            <i class="fa fa-plus cursor-pointer" aria-hidden="true"></i>
                          </a>
                          <a class="btn btn-flat ink-reaction" (click)="removeOtherFee(trs,i)"
                            *ngIf="(i != (otherFeeTermsList.length - 1)) && trs.paidAmount == 0">
                            <i class="fa fa-trash cursor-pointer" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-right">
                    <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                      (click)="addOtherFeeTerm(otherFeeTermsList)" [disabled]="isProcessing">{{isProcessing ? ('pleaseWait' | translate) : ('addOrUpdate' | translate)}}</button>
                    <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                      data-dismiss="modal">{{ 'cancel' | translate }}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Other Term Fee -->

        <!--  -->
        <!--Add Fee Component -->
        <div class="modal fade" id="add-new-fee-component" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-6 text-center"
                style="background-color:var(--brand-primary-color);color: white;padding: 10.7em 0em;height: 30em;">
                <i class="fa fa-cubes fa-4x" aria-hidden="true"></i>
                <h3>{{ 'addNewFeeComponent' | translate }}</h3>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="col-md-6" style="background-color: white;padding: 2em 1em;height: 30em;">
                <button id="add-new-fee-component-close"
                  style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form">
                  <div class="form-group">
                    <input name="name" type="text" class="form-control" [(ngModel)]="createFeeComponent.Name">
                    <label style="font-size: small;">{{ 'feeName' | translate }}</label>
                  </div>
                  <div class="form-group" style="margin-top: -10px;">
                    <div class="checkbox checkbox-styled">
                      <label>
                        <input class="termType" name="includeinterm" type="checkbox"
                          [(ngModel)]="createFeeComponent.includeInTerm">
                        <span style="font-size: small;color: rgba(49, 53, 52, 0.51);">{{ 'includeInTerm' | translate }}</span>
                      </label>
                    </div>
                    <div [hidden]="createFeeComponent.includeInTerm" class="form-group date1"
                      style="margin-top: -10px;">
                      <input data-date-format="dd/mm/yyyy" autoclose="true" id="duedateDatePicker" name="duedate"
                        [(ngModel)]="createFeeComponent.duedate" type="text" class="form-control datepicker1"
                        style="font-size: small;color: rgba(49, 53, 52, 0.51);"><i class="glyphicon glyphicon-calendar"
                        style="float: right;margin-top: -15px;"></i>
                      <label for="duedateDatePicker" style="font-size: small;">{{ 'dueDate' | translate }}</label>
                    </div>

                  </div>
                  <div class="form-group ">
                    <select id="selectAppliesTo" [(ngModel)]="createFeeComponent.AppliesTo" name="selectAppliesTo"
                      class="form-control" style="color: rgba(49, 53, 52, 0.51);font-size: small;">
                      <option value=""></option>
                      <option value="ALL_STUDENTS">{{ 'allStudents' | translate }}</option>
                      <option value="NEW_STUDENTS">{{ 'newStudents' | translate }}</option>
                      <option value="OLD_STUDENTS">{{ 'oldStudents' | translate }}</option>
                      <option value="BUS_FACILITY_STUDENTS">{{ 'studentsUsingBusFacility' | translate }}</option>
                    </select>
                    <label for="selectAppliesTo" style="font-size: small;">{{ 'studentType' | translate }}</label>
                  </div>
                  <div class="text-right">
                    <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                      (click)="addFeeType(createFeeComponent)">{{ 'add' | translate }}</button>
                    <button type="button" data-toggle="modal" data-target="#add-new-fee-component"
                      class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                      id="close_create_feetype_box">{{ 'cancel' | translate }}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- End of fee component -->
        <!-- Add New Term Fee -->
        <div class="modal fade" id="add-new-term-fee" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 4.5em 4em;">
                <i class="fa fa-cubes fa-4x" aria-hidden="true"></i>
                <h3>{{ 'addNewTermFee' | translate }}</h3>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="col-md-6" style="background-color: white;padding: 2em 1em;">
                <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form">
                  <div class="form-group">
                    <input type="text" class="form-control" [(ngModel)]="createFeeTerm.TermName" id="createFeeTermName"
                      name="termName">
                    <label for="createFeeTermName" style="font-size: small;">{{ 'termName' | translate }}</label>
                  </div>
                  <div class="form-group" style="margin-top: -15px;">
                    <div class="form-group">
                      <input data-date-format="dd/mm/yyyy" [(ngModel)]="createFeeTerm.DueDate" name="duedate"
                        type="text" id="termDueDate" class="form-control datepicker1"
                        style="font-size: small;color: rgba(49, 53, 52, 0.51);"><i class="glyphicon glyphicon-calendar"
                        style="float: right;margin-top: -15px;"></i>
                      <label for="termDueDate" style="font-size: small;">{{ 'dueDate' | translate }}</label>
                    </div>
                  </div>
                  <div class="text-right">
                    <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                      (click)="createTerm(createFeeTerm)">{{ 'add' | translate }}</button>
                    <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                      data-toggle="modal" data-target="#add-new-term-fee">{{ 'cancel' | translate }}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Term Fee -->

<p-dialog [(visible)]="showLateFeeAddComponent" [modal]="true" [style]="{ width: '570px' , height: '570px'}"
  [draggable]="false" [resizable]="false" [closable]="true" [dismissableMask]="true">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <img src="../../assets/img/late_fees_icon.png" alt="late-fee-icon" class="late-fee-icon-new" />
      <span class="late-fees-title">{{!selectedLateFeesId ? allLateFees.add : allLateFees.update}} {{allLateFees.lateFeesLabel}}</span>
    </div>
  </ng-template>

  <div *ngIf="!isLoadingLateFees" class="input-box-late-fees">
    <label class="lable-for-late-fees" for="days">{{allLateFees.days}} <span>*</span></label>
    <input [(ngModel)]="lateFeesDays" (keydown)="blockInvalidKeys($event)" (input)="sanitizeDaysInput($event)"
      type="number" [placeholder]='allLateFees.enterLateFeesDays' pInputText id="on_label" autocomplete="off" />
    <label class="lable-for-late-fees" for="days">{{allLateFees.feesAmount}}<span>*</span></label>
    <input [(ngModel)]="lateFeesAmount" (keydown)="blockInvalidKeys($event)" (input)="sanitizeAmountInput($event)"
      type="number" [placeholder]='allLateFees.enterAmount' pInputText id="on_label" autocomplete="off" />


      <div class="fee-selection-component">
        <div class="selection-label-checkbox-container">
          <p-checkbox [inputId]="'selectAllFees'" binary="true" [(ngModel)]="selectAllFees"
            (onChange)="onSelectAllFeesChange()" (click)="$event.stopPropagation()"></p-checkbox>
          <label [for]="'selectAllFees'" class="select-all-label">{{allLateFees.selectAllFee}}</label>
        </div>
      </div>


    <div *ngIf="feesList.length>0" class="fee-selection-component" style="margin-left: 24px;">
      <label class="lable-for-late-fees select-fees-label" for="days">{{allLateFees.selectTerm}}</label>

      <div class="selection-label-checkbox-container" style = "margin-bottom: 16px;">
      <p-checkbox [inputId]="'selectAllTermFees'" binary="true" [(ngModel)]="selectAllTermFees"
        (onChange)="onSelectAllTermFeesChange()" (click)="$event.stopPropagation()"></p-checkbox>
      <label [for]="'selectAllTermFees'" class="select-all-category-label">{{allLateFees.selectAllTermFee}}</label>
    </div>


      <div style="margin-left: 20px;">
      <div *ngFor="let key of feesList; let i = index">
        <div class="selection-label-checkbox-container" [class.expanded]="expandedItems[i]">
          
          <p-checkbox [inputId]="'feeTerm_' + key.feeTermId + '_' + i" binary="true" [(ngModel)]="key.isFeeSelected"
           (onChange)="checkSelectAllStatus()"
            (click)="$event.stopPropagation()"></p-checkbox>
          <label [for]="'feeTerm_' + key.feeTermId + '_' + i">{{ key.feeTermName }}</label>

          <i *ngIf="key.termFeeList?.length > 0" class="arrow-for-fee-details"
            [ngClass]="expandedItems[i] ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"
            (click)="expandItem(i); $event.stopPropagation()">
          </i>
        </div>
        <div class="selection-sub-label-checkbox-container" *ngIf="expandedItems[i]">
          <div class="sub-list-item-late-fees" *ngFor="let data of key.termFeeList; let j = index">
            <p-checkbox [(ngModel)]="key.isFeeSelected" (onChange)="onFeeTermChange(key, data)"
              (click)="$event.stopPropagation()" binary="true" class="sub-late-fees-check-box"></p-checkbox>
            <label>{{ data.feeTypeName }}</label>

          </div>
        </div>
      </div>
      </div>
    </div>

    <div *ngIf="termFeeList.length>0" class="fee-selection-component" style="margin-left: 24px;">
      <label class="lable-for-late-fees select-fees-label" for="days">{{allLateFees.selectFees}}</label>

            <div class="selection-label-checkbox-container" style = "margin-bottom: 16px;">
              <p-checkbox [inputId]="'selectAllTypeFees'" binary="true" [(ngModel)]="selectAllTypeFees"
                (onChange)="onSelectAllTypeFeesChange()" (click)="$event.stopPropagation()"></p-checkbox>
              <label [for]="'selectAllTypeFees'" class="select-all-category-label">{{allLateFees.selectAllTypeFee}}</label>
            </div>

        <div style="margin-left: 20px;">
      <div *ngFor="let key of termFeeList; let i = index" class="selection-transport-label-checkbox-container">
        <p-checkbox [inputId]="key.feeTypeId" binary="true" [(ngModel)]="key.isFeeSelected"
        (onChange)="onFeeTermListChange(key.feeTypeId);  checkSelectAllStatus()"(click)="$event.stopPropagation()"></p-checkbox>
        <label class="transport-fees-label" [for]="key.feeTypeId">{{ key.feeTypeName }}</label>

      </div>
      </div>
    </div>

  <div *ngIf="transportList.length > 0" class="fee-selection-component" style="margin-left: 24px;">
  <label class="lable-for-late-fees select-fees-label" for="days" [ngClass]="{'disabled-text': includeLateFeeInTransportFee === 0}">{{allLateFees.selectTransportFees}}</label>

  <div *ngIf="includeLateFeeInTransportFee === 0" class="disabled-info-message">
    <i class="ri-information-line"></i>
    <span>{{ 'transportFeeSelectionDisabled' | translate}}</span>
  </div>

  <div class="selection-label-checkbox-container" style="margin-bottom: 16px;">
    <p-checkbox 
       [inputId]="'selectAllTransportFees'" 
       binary="true" 
       [ngModel]="includeLateFeeInTransportFee === 0 ? false : selectAllTransportFees"
       (ngModelChange)="selectAllTransportFees = $event"
       [disabled]="includeLateFeeInTransportFee === 0"
       (onChange)="onSelectAllTransportFeesChange()" 
       (click)="$event.stopPropagation()">
    </p-checkbox>
    <label [for]="'selectAllTransportFees'" class="select-all-category-label" [ngClass]="{'disabled-text': includeLateFeeInTransportFee === 0}">{{allLateFees.selectAllTransportFee}}</label>
  </div>


  <div style="margin-left: 20px;" [ngClass]="{'disabled-transport-list': includeLateFeeInTransportFee === 0}">
    <div *ngFor="let key of transportList; let i = index" class="selection-transport-label-checkbox-container">
      <p-checkbox [inputId]="key.busStopTermId" binary="true" 
         [ngModel]="includeLateFeeInTransportFee === 0 ? false : key.isFeeSelected"
         (ngModelChange)="key.isFeeSelected = $event"
         [disabled]="includeLateFeeInTransportFee === 0"
         (onChange)="onFeeTransportFeeChange(key.busStopTermId); checkSelectAllStatus()"
         (click)="$event.stopPropagation()">
      </p-checkbox>
      <label class="transport-fees-label" [for]="key.busStopTermId">{{ key.busStopTermName }}</label>
    </div>
  </div>
  </div>


    <div class="buttons-for-add-late-fees">
      <button (click)="openCreateLateFee('')" class="cancel-button-late-add-fees">{{allLateFees.cancel}}</button>
      <button *ngIf="!isAddingLateFees" (click)="selectedLateFeesId ?updateLateFees():addLateFees()"
        class="add-button-late-add-fees">{{selectedLateFeesId ?allLateFees.update :allLateFees.add}}</button>
      <button *ngIf="isAddingLateFees" class="add-button-late-add-fees"><app-button-loader></app-button-loader></button>
    </div>


  </div>
  <div *ngIf="isLoadingLateFees" class="loading-late-fees-loader">
    <app-button-loader borderStyle="3px solid #3B82F6"></app-button-loader>
  </div>
</p-dialog>


   

        <!-- Add New Late Fee -->
        <!-- <div class="modal fade" id="add-new-late-fee" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 4.5em 4em;">
                <i class="fa fa-cubes fa-4x" aria-hidden="true"></i>
                <h3>{{ 'addNewLateFee' | translate }}</h3>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="col-md-6" style="background-color: white;padding: 2em 1em;">
                <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form">
                  <div class="form-group">
                    <input type="text" class="form-control" [(ngModel)]="createLateFee.lateDays" id="createLateFeeDays"
                      name="createLateFeeDays" type="number">
                    <label for="createLateFeeDays" style="font-size: small;">{{ 'days' | translate }}</label>
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" [(ngModel)]="createLateFee.lateFees"
                      id="createLateFeeAmount" name="createLateFeeAmount" type="number">
                    <label for="createLateFeeAmount" style="font-size: small;">{{ 'feeAmount' | translate }}</label>
                  </div>
                  <div class="text-right">
                    <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                      (click)="createLateFeeFunction(createLateFee)" [disabled]="isProcessing">{{isProcessing ? 'Please
                      wait...' : 'ADD'}}</button>
                    <button type="button" id="close-add-late-fee-popup" class="btn btn-raised ink-reaction btn-info"
                      style="padding: 3px 20px;" data-toggle="modal" data-target="#add-new-late-fee">{{ 'cancel' | translate }}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div> -->
        <!-- End of Add New Late Fee -->
        <!-- Delete late fee -->
        <div class="modal fade" id="delete-late-fee" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="padding: 10em 0em;">
            <div class="modal-content" style="padding: 1em 0em;border: 2px solid;">
              <div class="row text-center">
                <span>{{ 'areYouSureYouWantToDelete' | translate }} <b #delete_late_text id="delete_late_text"></b>?</span>
              </div>
              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                  (click)="deleteLateFee()" [disabled]="isProcessing">{{isProcessing ? ('pleaseWait' | translate) :
                  ('delete' | translate)}}</button>
                <button id="close-delete-late-fee-popup" type="button" class="btn btn-raised ink-reaction btn-info"
                  style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Delete late fee  -->
        <!-- Get List of Deleted late fee -->
        <div class="modal fade" id="deleted-late-fee-popup" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="padding: 5em 0 0 0;">
            <div class="modal-content" style="padding: 0 1.5em 1em 1.5em;border: 2px solid;">
              <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1.5em;float: right;border: none;"
                type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                aria-hidden="true">&times;</button>
              <h3 style="text-align: center;color: var(--brand-primary-color);">{{ 'deletedLateFeeList' | translate }}</h3>
              <table id="deleted-late-fee-component-table" class="table table-striped ">
                <thead>
                  <tr>
                    <th>{{ 'days' | translate }}</th>
                    <th>{{ 'lateFee' | translate }}</th>
                    <th>{{ 'deletedOn' | translate }}</th>
                    <th>{{ 'deletedBy' | translate }}</th>
                  </tr>
                </thead>
                <tbody>

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End of Get List of Deleted late fee  -->
        <!-- Get List of Waived Off late fee -->
        <div class="modal fade" id="waivedOff-late-fee-popup" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="padding: 5em 0 0 0;width: 65vw">
            <div class="modal-content" style="padding: 0 1.5em 1em 1.5em;border: 2px solid;width: 80vw">
              <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1.5em;float: right;border: none;"
                type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                aria-hidden="true">&times;</button>
              <h3 style="text-align: center;color: var(--brand-primary-color);">{{ 'waivedOffLateFeeList' | translate }}</h3>
              <table id="waivedOff-late-fee-component-table" class="table table-striped ">
                <thead>
                  <tr>
                    <th>{{ 'studentName' | translate }}</th>
                    <th>{{ 'parentName' | translate }}</th>
                    <th>{{ 'registrationNumber' | translate }}</th>
                    <th>{{ 'class' | translate }}</th>
                    <th>{{ 'feeName' | translate }}</th>
                    <th>{{ 'feeType' | translate }}</th>
                    <th>{{ 'amount' | translate }}</th>
                    <th>{{ 'waivedOfDate' | translate }}</th>
                    <th>{{ 'waivedOfBy' | translate }}</th>
                  </tr>
                </thead>
                <tbody>

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End of Get List of Waived Off late fee  -->

        <!-- View Receipt -->
        <div class="modal fade view-receipt" id="view-receipt" tabindex="-1" role="dialog" aria-hidden="true"
          data-backdrop="static" data-keyboard="false">
          <div class="modal-dialog">
            <div class="modal-content"
              style="background-color: white;min-height: 50em;    padding: 15px 20px;width: 47em;">
              <div id="fee-receipt-print-container" class="row"
                style="padding: 0px 30px;margin-left: -12px;margin-right: -12px;">
                <title>{{feeReceiptStd?.schoolName}}</title>
                <button
                  style="background-color: var(--brand-primary-color);margin-right: -3.7em;margin-top: -2em;float: right;border: none;"
                  type="button" id="close-fees-receipt" (click)="feeReceiptClosed()"
                  class="btn ink-reaction btn-floating-action btn-primary hide-while-print" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <div class="col-md-12"
                  style="width: 100%;float: left;position: relative;min-height: 1px;padding-left: 12px;padding-right: 12px;">
                  <div class="text-center" style="text-align: center;">
                    <img style="width:40px;height:40px;display: none"
                      src="https://bluewingsfilestorage.s3.amazonaws.com/BluewingsEnterprise/20@LOCAL/ProfileImages/School/3ef50faca324edc9eedadfbb5fe8d7124822c8bf3aeb2c558646db1ff599bd3b.jpg">
                    <h3 style="margin-bottom: 0px;text-transform: uppercase;font-weight: 900;">
                      {{feeReceiptStd?.schoolName}}</h3>
                    <p style="text-transform: uppercase;font-weight: 900;">{{feeReceiptStd?.locality}}
                      {{feeReceiptStd?.locality && feeReceiptStd?.address ? '-' : ''}} {{feeReceiptStd?.address}}</p>
                  </div>
                  <div style="font-weight: 900;text-decoration: underline;font-family: monospace;text-align: center;">
                    {{ 'feeReceipt' | translate }}</div>
                  <br>
                  <div class="col-md-6"
                    style="margin-top: -15px;    width: 50%;float: left;position: relative;min-height: 1px;padding-left: 12px;padding-right: 12px;">
                    <div>{{ 'receiptNo' | translate }} <span style="font-weight: 600;text-transform: uppercase;"
                        id="receipt-id-receipt">{{feeReceiptStd?.ReceiptNumber}}</span></div>
                    <div>{{ 'name' | translate }} <span id="receipt-student-name"
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.studentName}}</span></div>
                    <div>{{ 'parentName' | translate }} :<span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.parentName}}</span></div>
                    <div>{{ 'class' | translate }} : <span id="receipt-student-class"
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.classNumber}} -
                        {{feeReceiptStd?.classDivision}}</span></div>
                    <div *ngIf="feeReceiptStd?.ModeOfPayment == 'DD' || feeReceiptStd?.ModeOfPayment == 'Cheque'">{{ 'bankName' | translate }} <span style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.BankName}}</span>
                    </div>
                    <div *ngIf="feeReceiptStd?.ModeOfPayment == 'DD' || feeReceiptStd?.ModeOfPayment == 'Cheque'">{{ 'clearDate' | translate }} <span style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ModeOfPayDate |
                        date:
                        'dd-MMM-yyyy'}}</span>
                    </div>
                    <div *ngIf=" feeReceiptStd?.ModeOfPayment == 'QRCode'">{{ 'creditDate' | translate }}
                      <span style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ModeOfPayDate |
                        date:
                        'dd-MMM-yyyy'}}</span>
                    </div>
                    <div *ngIf="feeReceiptStd?.ModeOfPayment == 'Bank-transfer'">&nbsp;<span
                        style="font-weight: 600;text-transform: uppercase;">&nbsp;</span></div>
                  </div>
                  <div class="col-md-4 col-md-offset-2" style="margin-top: -15px;">
                    <div>{{ 'date' | translate }}<span style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.CreatedDate |
                        date: 'dd-MMM-yyyy'}}</span></div>
                    <div>{{ 'admissionNo' | translate }} <span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.registrationId}}</span>
                    </div>
                    <div>{{ 'transactionId' | translate }} <span style="font-weight: 600;">{{feeReceiptStd?.ModeOfPayment == 'Online' ?
                        feeReceiptStd?.paymentId : (feeReceiptStd?.ReferenceNumber ? feeReceiptStd?.ReferenceNumber :
                        'NA')}}</span></div>
                    <div>{{ 'modOfPayment' | translate }} <span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ModeOfPayment ==
                        'Card&Cash' ? 'Card & Cash':feeReceiptStd?.ModeOfPayment}}</span></div>
                    <div *ngIf="feeReceiptStd?.ModeOfPayment == 'DD'">{{ 'ddNumber' | translate }} <span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.DDNumber}}</span>
                    </div>
                    <div *ngIf=" feeReceiptStd?.ModeOfPayment == 'Cheque'">{{ 'chequeNumber' | translate }} <span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ChequeNumber}}</span>
                    </div>
                    <div *ngIf="feeReceiptStd?.ModeOfPayment == 'DD' && feeReceiptStd?.ddAmount">{{ 'ddAmount' | translate }} <span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ddAmount}}</span>
                    </div>
                    <div *ngIf=" feeReceiptStd?.ModeOfPayment == 'Cheque' && feeReceiptStd?.chequeAmount"> {{ 'chequeAmount' | translate }} <span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.chequeAmount}}</span>
                    </div>

                    <!-- <div *ngIf="feeReceiptStd?.ModeOfPayment == 'DD' || feeReceiptStd?.ModeOfPayment == 'Cheque'">
                      Bank Name: <span id="receipt-student-class"
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.BankName}}
                      </span></div> -->
                    <!-- <div *ngIf="feeReceiptStd?.ModeOfPayment == 'DD' || feeReceiptStd?.ModeOfPayment == 'Cheque'">
                      Clear Date: <span id="receipt-student-class"
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ModeOfPayDate | date:
                        'dd-MMM-yyyy'}}
                      </span></div>
                    <div *ngIf="feeReceiptStd?.ModeOfPayment == 'DD' ">
                      DD Number: <span id="receipt-student-class"
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.DDNumber}}
                      </span></div>
                    <div *ngIf=" feeReceiptStd?.ModeOfPayment == 'Cheque'">
                      Check Number: <span id="receipt-student-class"
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ChequeNumber}}
                      </span></div> -->
                    <div *ngIf="feeReceiptStd?.ModeOfPayment == 'Bank-transfer'">{{ 'creditDate' | translate }} <span
                        style="font-weight: 600;text-transform: uppercase;">{{feeReceiptStd?.ModeOfPayDate | date:
                        'dd-MMM-yyyy'}}</span></div>
                  </div>
                </div>
                <div class="col-md-12"
                  style="    width: 100%;float: left;position: relative;min-height: 1px;padding-left: 12px;padding-right: 12px;">
                  <br>
                  <div class="table-responsive" style="margin-top: -15px;overflow-x: auto;min-height: 0.01%;">
                    <table id="feeReceiptTable" class="table table-striped text-center"
                      style="width: 100%;max-width: 100%;margin-bottom: 2px;background-color: transparent;border-collapse: collapse;border-spacing: 0;margin-top: 20px">
                      <thead
                        style="    opacity: 0.75;font-family: monospace;border-top: black solid;border-bottom: black solid;">
                        <tr>
                          <!--<th style="text-align: center;">S. No</th>-->
                          <th style="text-align: left;">{{ 'fee' | translate }}({{currType}})</th>
                          <th style="text-align: center;">{{ 'feeAmt' | translate }}({{currType}})</th>
                          <th style="text-align: center;">{{ 'disAmt' | translate }}({{currType}})</th>
                          <th style="text-align: center;">{{ 'paidAmt' | translate }}({{currType}})</th>
                        </tr>
                      </thead>
                      <tbody *ngIf="feeReceiptSetting.isFeesModuleEnable != 'ENABLED'"
                        style="display: table-row-group;vertical-align: middle;">
                        <tr *ngFor="let p of feeReceipt; let i = index" style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;" *ngIf="p.TermName">
                            {{p.TermName}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: left;" *ngIf="!p.TermName">
                            {{p.isBusFee == 1 ? 'Transport ('+p.name+')':p.name}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;">{{p.ActualAmount}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;">{{p.DiscountAmount || 0}}
                          </td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;">{{p.Amount}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: left;border-top: black solid 1px; border-bottom: black solid 1px; ">
                            {{ 'totalAmount' | translate }}</td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px; border-bottom: black solid 1px;">
                            {{getActualTotalAmount()}}</td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px; border-bottom: black solid 1px;">
                            {{getDiscountTotalAmount()}}</td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px; border-bottom: black solid 1px;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'lateFeeAmount' | translate }}{{getModeOfPayment() == 'Card&Cash' ? '(Cash)' : ''}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-bottom: black solid 1px;">
                            {{getTotalLateFeeAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'netAmount' | translate }}
                          </td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-bottom: black solid 1px;">
                            {{getActualTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Cash'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmountCash' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Card&Cash'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmountCard' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalCardAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Card&Cash'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmountCash' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalCashAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Card'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmount' | translate }}({{getModeOfPayment()}})</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Chq'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmount' | translate }}({{getModeOfPayment() == 'Cash' ? 'Cheque' : getModeOfPayment()}})</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getModeOfPayment() == 'Cash' ? 'Chq' : getModeOfPayment()}} No : {{getChequeNumber()}}
                          </td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getModeOfPayment() == 'Cash' ? 'Chq' : getModeOfPayment()}} Date : {{getModeOfPayDate() |
                            date: 'dd-MMM-yyyy'}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getModeOfPayment() == 'Cash' ? '0' : getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'DD'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmount' | translate }}({{getModeOfPayment()}})</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">{{ 'ddNo' | translate }}
                            {{feeReceiptStd?.DDNumber}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">{{ 'ddDate' | translate }}
                            : {{getModeOfPayDate() | date: 'dd-MMM-yyyy'}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'totalReceivedAmount' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px;border-bottom: black solid 1px">
                            {{getTotalReceivedAmount()}}</td>
                        </tr>
                      </tbody>

                      <tbody *ngIf="feeReceiptSetting.isFeesModuleEnable == 'ENABLED'"
                        style="display: table-row-group;vertical-align: middle;">
                        <tr *ngFor="let p of feeReceipt; let i = index" style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;" *ngIf="p.TermName">
                            {{p.TermName}} ({{p.feeType.Name}})</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: left;" *ngIf="!p.TermName">
                            {{p.isBusFee == 1 ? 'Transport ('+p.name+')':p.name}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;">{{p.feeType ?
                            p.feeType.PaymentAmount : p.ActualAmount}}</td>

                          <td style="background-color: rgb(255, 255, 255);text-align: center;vertical-align: middle;"
                            *ngIf="p.TermName && p.colExists" [attr.rowspan]="p.FeesTypes.length">{{p.DiscountAmount ||
                            0}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;" *ngIf="!p.TermName">
                            {{p.DiscountAmount || 0}}</td>

                          <td style="background-color: rgb(255, 255, 255);text-align: center;vertical-align: middle;"
                            *ngIf="p.TermName && p.colExists" [attr.rowspan]="p.FeesTypes.length">{{p.Amount}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;" *ngIf="!p.TermName">
                            {{p.Amount}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: left;border-top: black solid 1px; border-bottom: black solid 1px; ">
                            {{ 'totalAmount' | translate }}</td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px; border-bottom: black solid 1px;">
                            {{getActualTotalAmount()}}</td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px; border-bottom: black solid 1px;">
                            {{getDiscountTotalAmount()}}</td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px; border-bottom: black solid 1px;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'lateFeeAmount' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-bottom: black solid 1px;">
                            {{getTotalLateFeeAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'netAmount' | translate }}
                          </td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-bottom: black solid 1px;">
                            {{getActualTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Cash'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmountCash' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Card&Cash'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmountCard' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalCardAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Card&Cash'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmountCash' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalCashAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Card'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmount' | translate }}({{getModeOfPayment()}})</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'Chq'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmount' | translate }}({{getModeOfPayment() == 'Cash' ? 'Cheque' : getModeOfPayment()}})</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getModeOfPayment() == 'Cash' ? 'Chq' : getModeOfPayment()}} No : {{getChequeNumber()}}
                          </td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getModeOfPayment() == 'Cash' ? 'Chq' : getModeOfPayment()}} Date : {{getModeOfPayDate() |
                            date: 'dd-MMM-yyyy'}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getModeOfPayment() == 'Cash' ? '0' : getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);" *ngIf="getModeOfPayment() == 'DD'">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'receivedAmount' | translate }}({{getModeOfPayment()}})</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">{{ 'ddDate' | translate }}
                             {{getModeOfPayDate() | date: 'dd-MMM-yyyy'}}</td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;">
                            {{getTotalAmount()}}</td>
                        </tr>
                        <tr style="background-color: rgb(255, 255, 255);">
                          <!-- <td>{{i+1}}</td>-->
                          <td style="background-color: rgb(255, 255, 255);text-align: left;    border: none;">{{ 'totalReceivedAmount' | translate }}</td>
                          <td style="background-color: rgb(255, 255, 255totalReceivedAmount);text-align: center;    border: none;"></td>
                          <td style="background-color: rgb(255, 255, 255);text-align: center;    border: none;"></td>
                          <td
                            style="background-color: rgb(255, 255, 255);text-align: center;border-top: black solid 1px;border-bottom: black solid 1px">
                            {{getTotalReceivedAmount()}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-md-12"
                  style="padding: 20px 0px;    width: 100%;float: left;position: relative;min-height: 1px;padding-left: 12px;padding-right: 12px;">
                  <div class="col-md-6">
                    <button type="button" id="print-fee-form"
                      class="btn btn-raised ink-reaction btn-info hide-while-print">{{ 'print' | translate }}</button>
                  </div>
                  <div class="col-md-4 col-md-offset-2"
                    style="margin-left: 16.666666666666664%;width: 33.33333333333333%;float: right;position: relative;min-height: 1px;padding-left: 12px;padding-right: 12px;">
                    <h5>{{ 'authSignatory' | translate }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Receipt -->

        <!-- Fee consession Receipt -->
        <div class="modal fade view-consession-receipt" id="view-consession-receipt" tabindex="-1" role="dialog"
          aria-hidden="true" data-backdrop="static" data-keyboard="false" style="overflow-y: scroll;">
          <div class="modal-dialog">
            <div class="modal-content"
              style="background-color: white;min-height: 50em;    padding: 15px 20px;width: 47em;">
              <div id="fee-consession-print-container" class="row"
                style="padding: 0px 30px;margin-left: -12px;margin-right: -12px;color: black; font-family:'Times New Roman', serif; font-style: italic;font-size: 12pt">
                <button
                  style="background-color: var(--brand-primary-color);margin-right: -3.7em;margin-top: -2em;float: right;border: none;"
                  type="button" id="close-fees-receipt" (click)="feeReceiptClosed()"
                  class="btn ink-reaction btn-floating-action btn-primary hide-while-print" data-dismiss="modal"
                  aria-hidden="true">&times;</button>

                <div
                  style="color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none;font-size: 22pt;padding-left: 8%;padding-top: 20pt;text-indent: 0pt;line-height: 24pt;text-align: center;">
                  {{appliedDiscountStudentDetails.schoolName}}</div>
                <div
                  style="color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none;font-size: 16pt;text-indent: 0pt;text-align: center;">
                  {{appliedDiscountStudentDetails.locality}} {{appliedDiscountStudentDetails.state}}</div>
                <div
                  style="color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none;font-size: 14pt;text-indent: 0pt;text-align: center;">
                  {{ 'feeConcessionForm' | translate }}</div>
                <div
                  style="color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none;font-size: 13pt;text-indent: 0pt;text-align: center;">
                  {{ 'session' | translate }} {{academicInfo.year}}</div>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt;padding-top: 3pt;text-indent: 0pt;text-align: right;">
                  {{ 'date' | translate }} <u>{{appliedDiscountStudentDate}} </u></p>
                <p style="margin: 0 0 2px;padding-top: 4pt;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'to' | translate }}
                </p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'theDirector' | translate }}</p>
                <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;"><br /></p>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: underline; font-size: 12pt;padding-left: 17pt;text-indent: 0pt;text-align: left;">
                 {{ 'subjectRequestForConcessionInSchoolFee' | translate }}</p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'reasonForRequest' | translate }}
                  {{selectedDiscount.discountReason}}</p>
                <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;"><br /></p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'discountNo' | translate }}
                  {{selectedDiscount.discountName}}</p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'discountAmount' | translate }}
                  {{selectedDiscount.discountAmount ? selectedDiscount.discountAmount :
                  selectedDiscount.discountPercentage}} ({{selectedDiscount.DiscountAmountType}})</p>

                <table style="border-collapse:collapse;margin-left:5.25pt;vertical-align: top; overflow: visible;"
                  cellspacing="0">
                  <tr style="height:21pt">
                    <td style="width:10%;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
                        {{ 'srNo' | translate }}</p>
                    </td>
                    <td style="width:40%;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
                        {{ 'feeName' | translate }}</p>
                    </td>
                    <td style="width:25%;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
                        {{ 'feeType' | translate }}</p>
                    </td>
                    <td style="width:25%;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
                       {{ 'discountedAmount' | translate }}</p>
                    </td>
                  </tr>
                  <tr *ngFor="let d of appliedDiscountComponentList; let i = index" style="height:21pt">
                    <td style="width:10%;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-top: 4pt;text-indent: 0pt;text-align: center;">
                        {{i+1}}</p>
                    </td>
                    <td style="width:40%;border: solid 1px;">
                      <p *ngIf="(d.TermName && d.TypeName) || d.TermName"
                        style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">{{d.TypeName}}{{d.TypeName ?
                        '-':''}}{{d.TermName}} &nbsp;</p>
                      <p *ngIf="!d.TermName && d.TypeName" style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{d.TypeName}} &nbsp;</p>
                      <p *ngIf="d.busTermName" style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{d.busTermName}} &nbsp;</p>
                    </td>
                    <td style="width:25%;border: solid 1px;">
                      <p *ngIf="(d.TermName && d.TypeName) || d.TermName"
                        style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">{{ 'term' | translate }}</p>
                      <p *ngIf="!d.TermName && d.TypeName" style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{ 'other' | translate }}</p>
                      <p *ngIf="d.busTermName" style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">{{ 'transport' | translate }}</p>
                    </td>
                    <td style="width:25%;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">{{d.DiscountAmount}}/-</p>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:10%;border: solid 1px;" colspan="3">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-top: 4pt;text-indent: 0pt;text-align: center;">
                        {{ 'total' | translate }}</p>
                    </td>
                    <td style="width:25%;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{calculateTotalDiscountInApplied()}}/-</p>
                    </td>
                  </tr>
                </table>

                <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;"><br /></p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'admissionNo' | translate }}
                  <u>&nbsp;{{appliedDiscountStudentDetails.registrationId}} </u>
                </p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;line-height: 187%;text-align: left;">{{ 'nameOfStudent' | translate }} <u>{{appliedDiscountStudentDetails.studentName}}</u></p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;line-height: 187%;text-align: left;">
                  {{ 'fathersName' | translate }} <u>{{appliedDiscountStudentDetails.parentName}} </u></p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;line-height: 187%;text-align: left;">{{ 'classSection' | translate }} <u>{{appliedDiscountStudentDetails.classNumber}} -
                    {{appliedDiscountStudentDetails.classDivision}} </u></p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'previousClassCgpa/percentageAttendance' | translate }}
                  <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </u>
                </p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'attachPhotocopyOfReportCard' | translate }}</p>
                <p style="margin: 0 0 2px;padding-left: 17pt;text-indent: 0pt;text-align: left;">{{ 'address' | translate }}
                  <u>{{appliedDiscountStudentDetails.address}} </u>
                </p>
                <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;"><br /></p>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: underline; font-size: 12pt;padding-left: 17pt;text-indent: 0pt;text-align: left;">
                  {{ 'detailsOfParentGuardian' | translate }}</p>
                <table style="border-collapse:collapse;margin-left:5.25pt;vertical-align: top; overflow: visible;"
                  cellspacing="0">
                  <tr style="height:21pt">
                    <td style="width:164pt;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-left: 40pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
                        {{ 'parentGuardian' | translate }}</p>
                    </td>
                    <td style="width:164pt;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-left: 55pt;padding-right: 54pt;text-indent: 0pt;line-height: 13pt;text-align: center;">
                        {{ 'occupation' | translate }}</p>
                    </td>
                    <td style="width:163pt;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-left: 45pt;text-indent: 0pt;line-height: 13pt;text-align: left;">
                        {{ 'mobileNumber' | translate }}</p>
                    </td>
                  </tr>
                  <tr style="height:21pt">
                    <td style="width:164pt;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-top: 4pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                        {{ 'father' | translate }}</p>
                    </td>
                    <td style="width:164pt;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{appliedDiscountStudentDetails.fatherOccupation}}</p>
                    </td>
                    <td style="width:163pt;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{appliedDiscountStudentDetails.mobileNumber ? '+' :
                        ''}}{{appliedDiscountStudentDetails.mobileNumber ? appliedDiscountStudentDetails.countryCode :
                        ''}} {{appliedDiscountStudentDetails.mobileNumber ? appliedDiscountStudentDetails.mobileNumber :
                        ''}}</p>
                    </td>
                  </tr>
                  <tr style="height:21pt">
                    <td style="width:164pt;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-top: 4pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                        {{ 'mother' | translate }}</p>
                    </td>
                    <td style="width:164pt;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{appliedDiscountStudentDetails.motherOccupation}}</p>
                    </td>
                    <td style="width:163pt;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{appliedDiscountStudentDetails.motherPhone ? '+' :
                        ''}}{{appliedDiscountStudentDetails.motherPhone ? appliedDiscountStudentDetails.countryCode :
                        ''}} {{appliedDiscountStudentDetails.motherPhone ? appliedDiscountStudentDetails.motherPhone :
                        ''}}</p>
                    </td>
                  </tr>
                  <tr style="height:21pt">
                    <td style="width:164pt;border: solid 1px;">
                      <p
                        style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-top: 4pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                        {{ 'guardian' | translate }}</p>
                    </td>
                    <td style="width:164pt;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{appliedDiscountStudentDetails.guardianOccupation}}</p>
                    </td>
                    <td style="width:163pt;border: solid 1px;">
                      <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;">
                        {{appliedDiscountStudentDetails.guardianPhone ? '+' :
                        ''}}{{appliedDiscountStudentDetails.guardianPhone ? appliedDiscountStudentDetails.countryCode :
                        ''}} {{appliedDiscountStudentDetails.guardianPhone ? appliedDiscountStudentDetails.guardianPhone
                        : ''}}</p>
                    </td>
                  </tr>
                </table>
                <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;"><br /></p>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: underline; font-size: 12pt;text-indent: 0pt;text-align: center;">
                  {{ 'forOfficeUseOnly' | translate }}</p>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt;padding-top: 2pt;text-indent: 0pt;text-align: center;">
                  {{ 'session' | translate }}{{academicInfo.year}}</p>
                <div style="display:flex">
                  <p
                    style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt;width: 70%;padding-top: 9pt;padding-left: 17pt;text-indent: 0pt;text-align: left;">
                   {{ 'referenceNo' | translate }}
                    <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </u>
                  </p>
                  <p
                    style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt;padding-top: 9pt;padding-left: 17pt;text-indent: 0pt;text-align: right;">
                   {{ 'date' | translate }}
                    <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </u>
                  </p>
                </div>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt;padding-top: 7pt;padding-left: 17pt;text-indent: 0pt;line-height: 150%;text-align: left;">
                  {{ 'reasonForDiscount' | translate }}
                  <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </u></p>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt;padding-top: 7pt;padding-left: 17pt;text-indent: 0pt;line-height: 150%;text-align: left;">
                  {{ 'concessionGranted' | translate }}
                  <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </u>
                </p>
                <p style="margin: 0 0 2px;text-indent: 0pt;text-align: left;"><br /></p>
                <p
                  style="margin: 0 0 2px;color: black; font-family:'Times New Roman', serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt;padding-top: 4pt;padding-left: 17pt;text-indent: 0pt;text-align: left;">
                  {{ 'directorManager' | translate }}</p>

                <div class="col-md-12"
                  style="padding: 20px 0px;    width: 100%;float: left;position: relative;min-height: 1px;padding-left: 12px;padding-right: 12px;font-style:initial">
                  <div class="col-md-6">
                    <button type="button" id="print-fee-consession-form"
                      class="btn btn-raised ink-reaction btn-info hide-while-print">{{ 'print' | translate }}</button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Fee consession Receipt -->

        <!-- Add Student category -->
        <div class="modal fade" id="add-student-category" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-12" style="background-color: white;padding: 0px 20px;">
                <div class="row" style="padding: 10px 10px;">
                  <img src="images_ext/discount.png">
                  <h3 style="margin-top: -27px;margin-left: 2em;color: var(--brand-primary-color);">
                    {{addNewStudentCategory.studentCategoryId ? ('editStudentCategory' | translate) : ('addNewStudentCategory' | translate)}}
                  </h3>
                </div>
                <button
                  style="background-color: var(--brand-primary-color);margin-right: -2.3em;margin-top: -4.7em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form">
                  <div class="form-group">
                    <input type="text" class="form-control" [(ngModel)]="addNewStudentCategory.name"
                      name="studentCategoryName">
                    <label style="font-size: small;">{{ 'name' | translate }}</label>
                  </div>
                  <div class="form-group">
                    <textarea maxlength="300"
                      (keyup)="checkDescriptionLength(addNewStudentCategory,'addNewStudentCategory')"
                      class="form-control" [(ngModel)]="addNewStudentCategory.description"
                      name="studentCategoryDescription"></textarea>
                    <label
                      style="font-size: small;">{{ 'description' | translate }}({{addNewStudentCategory.remainingDescriptionLength}})</label>
                  </div>
                </form>
                <div class="row text-center" style="padding: 15px 0px;">
                  <button *ngIf="!isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;"
                    (click)="addStudentCategory(addNewStudentCategory)">{{addNewStudentCategory.studentCategoryId ?
                    ('save' | translate) : ('create' | translate) }}</button>
                  <button *ngIf="isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" [disabled]="isProcessing">{{ 'pleaseWait' | translate }}</button>
                  <button id="close-create-category" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" data-dismiss="modal">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!-- End of Add Student category -->

        <!-- Add Fee structure -->
        <div class="modal fade" id="add-fee-structure" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-12" style="background-color: white;padding: 0px 20px;">
                <div class="row" style="padding: 10px 10px;">
                  <img src="images_ext/discount.png">
                  <h3 style="margin-top: -27px;margin-left: 2em;color: var(--brand-primary-color);">{{addNewFeeStructure.feeStructureId ?
                    ('editFeeStructure' | translate) : ('addNewFeeStructure' | translate)}}</h3>
                </div>
                <button
                  style="background-color: var(--brand-primary-color);margin-right: -2.3em;margin-top: -4.7em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form">
                  <div class="form-group">
                    <input type="text" class="form-control" [(ngModel)]="addNewFeeStructure.name"
                      name="studentCategoryName">
                    <label style="font-size: small;">{{ 'name' | translate }}</label>
                  </div>
                  <div [style.display]="addNewFeeStructure.collectedAmount > 0 ? '':'none'" class="form-group">
                    <input type="text" class="form-control" value="{{addNewFeeStructure.appliesTo}}"
                      name="studentCategoryName" disabled>
                    <label style="font-size: small;">{{ 'appliesTo' | translate }} </label>
                  </div>
                  <div
                    [style.display]="(!addNewFeeStructure.feeStructureId || addNewFeeStructure.collectedAmount == 0) ? '':'none'"
                    class="form-group">
                    <select [(ngModel)]="addNewFeeStructure.studentCategoryId" id="selectStudentCategory"
                      name="select13" class="form-control">
                      <option value="0">{{ 'selectStudentCategory' | translate }}</option>
                      <option value="{{c.pkStudentsCategoryId}}" *ngFor="let c of studentCategoryList">{{c.Name}}
                      </option>
                    </select>
                    <label for="selectStudentCategory" style="font-size: small;">{{ 'appliesTo' | translate }}</label>
                  </div>
                  <div class="form-group">
                    <textarea maxlength="300" (keyup)="checkDescriptionLength(addNewFeeStructure,'addNewFeeStructure')"
                      class="form-control" [(ngModel)]="addNewFeeStructure.description"
                      name="newFeeStructureDescription"></textarea>
                    <label
                      style="font-size: small;">{{ 'description' | translate }}({{addNewFeeStructure.remainingDescriptionLength}})</label>
                  </div>
                  <div style="font-size: 12px;" class="form-group"
                    [style.display]="addNewFeeStructure.collectedAmount > 0 ? '':'none'">
                    <b style="text-decoration: underline;color:red">{{ 'note' | translate }}</b> {{ 'changing' | translate }} <b>{{ 'appliesTo' | translate }}</b> {{ 'notAllowedHereStudentsAlreadyPaidFeeForThisStructureAndCategory' | translate }}
                  </div>
                </form>
                <div class="row text-center" style="padding: 15px 0px;">
                  <button *ngIf="!isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;"
                    (click)="addFeeStructure(addNewFeeStructure)">{{addNewFeeStructure.studentCategoryId ? ('save' | translate) :
                    ('createText' | translate)}}</button>
                  <button *ngIf="isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" [disabled]="isProcessing">{{ 'pleaseWait' | translate }}</button>
                  <button id="close-create-fee-structure" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" data-dismiss="modal">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!-- End of Add Fee structure -->

        <!--DELETE FEE STRUCTURE START-->
        <div id="deleteFeeStructure" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content" style="margin-top: 190px">
              <div class="modal-body">
                <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times"
                    style="color: var(--brand-primary-color);"></i> {{ 'deleteFeeStructure' | translate }}</h3>
                <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  style="background: var(--brand-primary-color);float: right;margin-top: -3em;margin-right: -2em;border: none;"
                  type="button">×</button>
                <p style="font-size: 19px;margin-left: 5pc;padding: 30px 30px;">{{ 'areYouConfirmToDeleteSelectedFeeStructure' | translate }}</p>
                <div class="text-center">
                  <button type="button" id="deleteStructButton" class="btn btn-raised ink-reaction btn-info"
                    (click)="deleteFeeStructure()" style="padding: 3px 20px;">{{ 'ok' | translate }}</button>
                  <button id="cancelDeletestructButton" type="button" class="btn btn-raised ink-reaction btn-info"
                    data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--DELETE FEE STRUCTURE END-->

        <!-- View or assign students to student category -->
        <div class="modal fade" id="assign-students-to-category" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="width: 100%;">
            <div class="modal-content" style="padding: 5em 1em;border: 10px dashed;">
              <div class="row text-center">
                <h4 style="color: blue;margin-top: -3em;">{{ 'assignStudentsTo' | translate }} {{addNewStudentCategory.name}}</h4>
              </div>
              <div class="row">
                <div class="card">
                  <div class="card-body">
                    <div class="card-head">
                      <ul class="nav nav-tabs" data-toggle="tabs">
                        <li class="active"><a style="cursor: pointer;" data-target="#add-students-to-category"
                            data-toggle="tab">{{ 'addStudents' | translate }}</a></li>
                        <li class=""><a style="cursor: pointer;" data-target="#view-students-in-category"
                            data-toggle="tab">{{ 'existingStudents' | translate }}</a></li>
                      </ul>
                    </div>
                    <div class="card-body tab-content">
                      <div class="tab-pane active" id="add-students-to-category">
                        <form class="form">
                          <div class="form-group" style="margin-left: 16%;">
                            <div class="input-group" style="margin-left: 11%;">
                              <div class="input-group-content" style="width: 30%">
                                <label>{{ 'searchBy' | translate }}</label>
                                <select style="border: 1px solid #e6e6e6;" class="form-control"
                                  id="select-class-to-search-student" name="sadasdd">
                                  <option value="0">{{ 'all' | translate }}</option>
                                  <option value="{{c.classId}}" *ngFor="let c of schoolClasses">{{c.classNumber}} -
                                    {{c.classDivision}}</option>
                                </select>
                              </div>
                              &nbsp;
                              <div class="input-group-content" style="width: 50%">
                                <input type="text" class="form-control" autocomplete="off" id="groupbutton12"
                                    [placeholder]="'searchStudentByName' | translate"
                                  style="border: 1px solid #e6e6e6;padding: 0px 15px;font-weight: 100;font-size: 12px;">
                              </div>
                              <div class="input-group-content" style="    padding-left: 0;">
                                <button (click)="searchStudentForCategory()" class="btn btn-default" type="button"
                                  style="background: var(--brand-primary-color);    color: white;"><i class="fa fa-search"></i></button>
                              </div>
                            </div>
                          </div>
                        </form>
                        <br>
                        <div *ngIf="searchStudentListForCategorySelectedCount" style="text-align: center"><button
                            [disabled]="isProcessing" class="btn btn-raised ink-reaction btn-info"
                            (click)="assignStudentsToCategory()"> {{ 'assign' | translate }} {{searchStudentListForCategorySelectedCount}}
                            {{searchStudentListForCategorySelectedCount == 1 ? 'student' : 'students'}}</button></div>
                        <table id="search-student-list-for-category" class="table table-striped ">
                          <thead>
                            <tr>
                              <th> <input type="checkbox"
                                  [(ngModel)]="selectAllStudentCategorySearchStudentResultsCheckedValue"
                                  (change)="selectAllStudentCategorySearchStudentResults(selectAllStudentCategorySearchStudentResultsCheckedValue)"
                                  style="float: left;">&nbsp;&nbsp;{{ 'selectAll' | translate }}</th>
                              <th>{{ 'name' | translate }}</th>
                              <th>{{ 'parent' | translate }}</th>
                              <th>{{ 'class' | translate }}</th>
                              <th>{{ 'mobile' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let s of studentCategorySearchStudentResults">
                              <td><span *ngIf="s.paidFees > 0">{{'Not allowed (Fees already collected)'}}</span><input
                                  *ngIf="!(s.paidFees > 0)" [(ngModel)]="s.selected"
                                  (change)="checkOUncheckSelectStd(s.selected)" name="selectStudent" type="checkbox">
                              </td>
                              <td>{{s.studentName}}</td>
                              <td>{{s.parentName}}</td>
                              <td>{{s.classNumber}} - {{s.classDivision}}</td>
                              <td>{{s.mobileNumber}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="tab-pane" id="view-students-in-category">
                        <div style="text-align: center">&nbsp; {{ 'total' | translate }} {{addNewStudentCategory.numberOfStudents}} {{ 'studentsAdded' | translate }}</div>
                        <table id="existing-student-list-category" class="table table-striped ">
                          <thead>
                            <tr>
                              <th>{{ 'name' | translate }}</th>
                              <th>{{ 'parent' | translate }}</th>
                              <th>{{ 'class' | translate }}</th>
                              <th>{{ 'mobile' | translate }}</th>
                              <th>{{ 'manage' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div><!--end .card-body -->
                </div>
                <div class="col-md-12 text-right" style="padding: 8px 0px;position: fixed;margin-left: -3em;">
                  <button type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal"
                    aria-hidden="true">{{ 'close' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- View End -->

        <!-- View or assign students to otherfees -->
        <div class="modal fade" id="assign-students-to-otherfees" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="width: 100%;">
            <div class="modal-content" style="padding: 5em 1em;border: 10px dashed;">
              <div class="row text-center">
                <h4 style="color: blue;margin-top: -3em;">{{ 'assignStudentsTo' | translate }} {{selectedOtherFee.Name}}</h4>
              </div>
              <div class="row">
                <div class="card">
                  <div class="card-body">
                    <div class="card-head">
                      <ul class="nav nav-tabs" data-toggle="tabs">
                        <li class="active"><a style="cursor: pointer;" data-target="#add-students-to-otherfees"
                            data-toggle="tab">{{ 'addStudents' | translate }}</a></li>
                        <li class=""><a style="cursor: pointer;" data-target="#view-students-in-otherfees"
                            data-toggle="tab" (click)="getStudentsInOtherFee()">{{ 'existingStudents' | translate }}</a></li>
                      </ul>
                    </div>
                    <div class="card-body tab-content">
                      <div class="tab-pane active" id="add-students-to-otherfees">
                        <form class="form">
                          <div class="form-group" style="margin-left: 16%;">
                            <div class="input-group" style="margin-left: 11%;">
                              <div class="input-group-content" style="width: 30%">
                                <label>{{ 'searchBy' | translate }}</label>
                                <select style="border: 1px solid #e6e6e6;" class="form-control"
                                  id="select-class-to-search-student-otherfees" name="sadasdd">
                                  <option value="0">{{ 'all' | translate }}</option>
                                  <option value="{{c.classId}}" *ngFor="let c of schoolClasses">{{c.classNumber}} -
                                    {{c.classDivision}}</option>
                                </select>
                              </div>
                              &nbsp;
                              <div class="input-group-content" style="width: 50%">
                                <input type="text" class="form-control" autocomplete="off" id="groupbutton12-otherfees"
                                   [placeholder]="'searchStudentByName' | translate"
                                  style="border: 1px solid #e6e6e6;padding: 0px 15px;font-weight: 100;font-size: 12px;">
                              </div>
                              <div class="input-group-content" style="    padding-left: 0;">
                                <button (click)="searchStudentForOtherfee()" class="btn btn-default" type="button"
                                  style="background: var(--brand-primary-color);    color: white;"><i class="fa fa-search"></i></button>
                              </div>
                            </div>
                          </div>
                        </form>
                        <br>
                        <div *ngIf="searchStudentListForOtherSelectedCount" style="text-align: center"><button
                            [disabled]="isProcessing" class="btn btn-raised ink-reaction btn-info"
                            (click)="assignStudentsToOtherFee()"> {{ 'assign' | translate }} {{searchStudentListForOtherSelectedCount}}
                            {{searchStudentListForOtherSelectedCount == 1 ? 'student' : 'students'}}</button></div>
                        <table id="search-student-list-for-otherfees" class="table table-striped ">
                          <thead>
                            <tr>
                              <th> <input type="checkbox"
                                  [(ngModel)]="selectAllStudentOtherFeeSearchStudentResultsCheckedValue"
                                  (change)="selectAllStudentOtherFeeSearchStudentResults(selectAllStudentOtherFeeSearchStudentResultsCheckedValue)"
                                  style="float: left;">&nbsp;&nbsp; {{ 'selectAll' | translate }}</th>
                              <th>{{ 'name' | translate }}</th>
                              <th>{{ 'parent' | translate }}</th>
                              <th>{{ 'class' | translate }}</th>
                              <th>{{ 'mobile' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let s of otherFeeSearchStudentResults">
                              <td><input [(ngModel)]="s.selected" (change)="checkOUncheckSelectStdOtherFee(s.selected)"
                                  name="selectStudent" type="checkbox"></td>
                              <td>{{s.studentName}}</td>
                              <td>{{s.parentName}}</td>
                              <td>{{s.classNumber}} - {{s.classDivision}}</td>
                              <td>{{s.mobileNumber}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="tab-pane" id="view-students-in-otherfees">
                        <div style="text-align: center">&nbsp; {{ 'total' | translate }} {{selectedOtherFee.studentsCount}} {{ 'studentsAdded' | translate }}
                        </div>
                        <table id="existing-student-list-otherfees" class="table table-striped ">
                          <thead>
                            <tr>
                              <th>{{ 'name' | translate }}</th>
                              <th>{{ 'parent' | translate }}</th>
                              <th>{{ 'class' | translate }}</th>
                              <th>{{ 'mobile' | translate }}</th>
                              <!-- <th>Manage</th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let es of studentsInOtherFee">
                              <td>{{es.studentName}}</td>
                              <td>{{es.parentName}}</td>
                              <td>{{es.className}}</td>
                              <td>{{es.mobileNumber}}</td>
                              <!-- <td><a data-toggle="modal" data-target="#remove-student-from-otherfee" class="btn btn-flat ink-reaction btn-default edit-std"><i class="fa fa-edit"></i></a><a class="btn btn-flat ink-reaction remove-std hide"><i class="fa fa-times"></i></a></td> -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div><!--end .card-body -->
                </div>
                <div class="col-md-12 text-right" style="padding: 8px 0px;position: fixed;margin-left: -3em;">
                  <button type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal"
                    aria-hidden="true">{{ 'close' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- View End students to otherfees -->

        <!--ASSIGN FEE WITH STRUCTURE START-->

        <div class="modal fade" id="assignFeeBoard" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel" >
          <div class="modal-dialog" style="width: 95%;">
            <div class="modal-content">
              <div class="modal-header" style="padding: 0px 25px;">
                <button type="button" id="closeFeeBoardModel" class="close" data-dismiss="modal" aria-hidden="true"
                  style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
                <div class="row">
                  <div class="col-md-12" style="text-align:center;margin-top: -1em;">
                    <h3 class="text-primary"
                      style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span
                        style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i
                          class="fa fa-flag"></i></span>{{ 'feeBoardDetails' | translate }} <span id="feesBoardDetailsClassName"></span>
                    </h3>
                    <p style="margin: 0;color: #989898;margin-top: -5px;margin-bottom: 10px;">{{ 'addFeeDetailsHere' | translate }} </p>
                  </div>

                </div>
                <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; padding: 10px;">
                  <label for="classForFeeBoard">{{ 'selectClassToImportFeeBoardConfig' | translate }}</label>
                  <select id="classForFeeBoard" (change)="handleOnChangeForClassList($event)"
                    style="padding: 5px; border-radius: 5px;">
                    <option value="">{{ 'selectClass' | translate }}</option>
                    <option *ngFor="let c of classListForFee" [value]="c.ClassNumber + ' - ' + c.classDivision + '|' + c.classId ">
                      {{c.ClassNumber}} - {{c.classDivision}}
                    </option>
                  </select>
                  <button 
                  title="Import the data from selected class"
                  *ngIf="selectedClassIdForFeeCopy" 
                  (click)="handleCopyButton(true)">
                 {{ 'import' | translate }}
              </button>              
                </div>
              </div>

              <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
                <div class="col-md-12 hide">
                  <form class="form">
                    <div class="form-group">
                      <select id="select-class-add-fee" name="select-section-add-fee"
                        [(ngModel)]="getClassIdForFeeBoard" (change)="feeBoardDetails($event.target.value)"
                        class="form-control" style="border: 1px solid #b9b6b6;">
                        <option value="0">{{ 'selectClass' | translate }}</option>
                        <option value="{{c.classId}}" *ngFor="let c of classStandards">{{c.classNumber}}
                          {{c.classDivision}}</option>
                      </select>
                      <div class="form-control-line"></div>
                    </div>
                  </form>
                </div>
                <div class="col-md-12 hide">
                  <div *ngIf="selectClassForFeeDetail" class="col-md-12 text-center" style="color: teal;">
                    <h3>{{ 'pleaseSelectClassToViewTheDetails' | translate }}</h3>
                  </div>
                </div>
                <div *ngIf="feeBoardStatus"
                  style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                  <div class="col-md-12" style="text-align: center;">
                    <!-- <img src="assets/img/search_icon_animation.gif" style="   width: 300px;">-->
                    <h3 style="margin: 0;color: #a1a1a1;font-weight: 900;">{{ 'pleaseWait' | translate }}</h3>
                  </div>
                </div>
                <div *ngIf="feeBoardTableList">
                  <div class="col-md-12">
                    <div class="table-responsive" style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">
                      <table id="selectedFeeDtail" class="table table-striped ">
                        <thead style="background: var(--brand-primary-color);color: white;">
                          <tr
                            style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'termConfig' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'structureName' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'viewHistory' | translate }}</b>
                            </th>
                            <th *ngFor="let feeName of feeBoardDataHeader" data-toggle="tooltip"
                              title="{{feeName.Name}}"
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{textWrappingForTermName(feeName.Name)}}({{currType}})</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let fees of feeBoardData"
                            style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">
                            <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"><i
                                class="btn btn-flat ink-reaction md md-assignment" data-toggle="tooltip"
                                title="click here to view/edit structure" style="cursor:pointer;"
                                (click)="getClassTermConfig(this.getClassIdForFeeBoard,fees.pkFeeStructuresId,fees)"
                                data-toggle="modal" data-target="#termFeeConfig"></i></td>
                            <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">{{fees.Name}}
                            </td>
                            <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"><i
                                class="btn btn-flat ink-reaction fa fa-history" data-toggle="tooltip"
                                title="click here to view history" style="cursor:pointer;" data-toggle="modal"
                                data-target="#viewFeeBoardHistory"
                                (click)="getFeeBoardDetailView(fees.pkFeeStructuresId,this.getClassIdForFeeBoard,fees.Name)"></i>
                            </td>
                            <td *ngFor="let data of fees.feeTypes"
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"><input
                                type="number" min="0" style="width: 76px" class="no-spin" [(ngModel)]="data.Amount"
                                (keyup)="data.Amount = $event.target.value;isTermConfigchanged = true;setMaxLength(data);"
                                name="feeAmount"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" style="padding: 10px 0px;">
                    <button type="button" id="addFeeButton" class="btn btn-raised ink-reaction btn-info"
                      (click)="configFeeBoard()">{{ 'save' | translate }}</button>
                    <button type="button" id="cancelAddFee" data-dismiss="modal"
                      class="btn btn-raised ink-reaction btn-info" (click)="handleFeeBordCancel()">{{ 'cancel' | translate }}</button>
                  </div>
                </div>
              </div>

              <div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
                <!-- <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-raised ink-reaction btn-info">Add student</button> -->
                <p style="color: #717171;">© {{currentYear}} {{ 'bluewingsAllRightReserved' | translate:{ brandName: brand.name } }}</p>
              </div>
            </div><!-- /.modal-content -->
          </div>
        </div>
        <div class="modal fade" id="topModal" tabindex="-1" role="dialog" aria-labelledby="topModalLabel" style="z-index: 1051;">
          <div class="modal-dialog" role="document" style="display: flex; align-items: center;">
            <div class="modal-content">
              <div class="modal-header">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <h5 class="modal-title" id="topModalLabel"> {{ 'confirmationOfFee' | translate }} {{ isFeeBoardDataCopied ? 'Board' : 'Term' }} {{ 'configuration' | translate }}</h5> 
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="modal-body">
                <p>{{ 'areYouSureYouWantToImportTheFeeConfigurationFromA' | translate }}
                  <strong>{{ isFeeBoardDataCopied ?  selectedClassForFeeBoard : selectedClassForTermInfo }}</strong> ? {{ 'thisWill' | translate }} <strong>{{ 'replicateTheCurrentData' | translate }}</strong> {{ 'temporarilyToFinalizeTheChangesClick' | translate }} <strong>{{ 'save' | translate }}</strong>.
                </p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-info" data-dismiss="modal">{{ 'cancel' | translate }}</button>
                <button type="button" class="btn btn-success" (click)="handleFeeConfigCopy();" data-dismiss="modal">{{ 'ok' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal -->
       
        <!--ASSIGN FEE WITH STRUCTURE END-->

        <!--FEE BOARD HISTORY START-->

        <div class="modal fade" id="viewFeeBoardHistory" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
          aria-hidden="true">
          <div class="modal-dialog" style="width: 65%;">
            <div class="modal-content">
              <div class="modal-header" style="padding: 0px 25px;">
                <button type="button" id="closeFeeBoardHistoryModel" class="close" data-dismiss="modal"
                  aria-hidden="true"
                  style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
                <div class="row">
                  <div class="col-md-12" style="text-align:center;margin-top: -1em;">
                    <h3 class="text-primary"
                      style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span
                        style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i
                          class="fa fa-flag"></i></span>{{ 'feeBoardHistory' | translate }} <span id="FeeBoardHistory"></span></h3>
                    <p style="margin: 0;color: #989898;margin-top: 15px;margin-bottom: 10px;">{{ 'viewHistoryFor' | translate }}
                      <b>{{getStructureName}}</b>
                    </p>
                  </div>
                </div>
              </div>
              <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
                <div class="col-md-12">
                  <div class="row">
                    <!-- <div *ngIf="termFeeConfigurations.length == 0">Please add fee in fees board</div>-->
                    <div class="table-responsive"
                      style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;padding: 1em 1em;">
                      <table id="feeboard_new" class="table table-striped" style="border-left: 1px solid #b9b6b6;">
                        <thead style="background: var(--brand-primary-color);color: white;">
                          <tr
                            style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'modifiedBy' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'feesCategory' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                             {{ 'originalValue' | translate }}({{currType}})</th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{ 'newValue' | translate }}({{currType}})</th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                             {{ 'modifiedDate' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let his of getFeeBoardHistoryForView" class="gradeX">
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{his.username}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{his.TermName}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{his.OldValue}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{his.NewValue}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{his.CreatedTime | date: 'dd-MMM-yyyy hh:mm a'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="feeBoardHistoryStatus"
                style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                <div class="col-md-12" style="text-align: center;">
                  <!-- <img src="assets/img/search_icon_animation.gif" style="   width: 300px;">-->
                  <h3 style="margin-top: -28px;color: #a1a1a1;font-weight: 900;">{{ 'pleaseWait' | translate }}.</h3>
                </div>
              </div>

              <div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
                <p style="color: #717171;"></p>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div>

        <!--FEE BOARD HISTORY END-->



        <!--TERM FEE CONFIGURATION START-->

        <div class="modal fade" id="termFeeConfig" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
          aria-hidden="true">
          <div class="modal-dialog" style="width: 95%;">
            <div class="modal-content">
              <div class="modal-header" style="padding: 0px 25px;">
                <button type="button" id="closetermFeeConfigModel" class="close" data-dismiss="modal" aria-hidden="true"
                  style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
                <div class="row">
                  <div class="col-md-12" style="text-align:center;margin-top: -1em;">
                    <h3 class="text-primary"
                      style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span
                        style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i
                          class="fa fa-flag"></i></span>{{ 'termFeeConfiguration' | translate }} <span
                        id="termFeeConfigClassName"></span></h3>
                    <p style="margin: 0;color: #989898;margin-top: -5px;margin-bottom: 10px;">{{feeConfigStrucName}}</p>
                  </div>

                </div>
                <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; padding: 10px;">
                  <label for="classSelectForFeeTerm">{{ 'selectClassToImportFeeTermConfig' | translate }}</label>
                  <select id="classSelectForFeeTerm" (change)="handleOnChangeForClassForFeeTerm($event)"
                   style="padding: 5px; border-radius: 5px;">
                    <option value="">{{ 'selectClass' | translate }}</option>
                    <option *ngFor="let c of classListForFee" [value]="c.ClassNumber + ' - ' + c.classDivision + '|' + c.classId">
                      {{c.ClassNumber}} - {{c.classDivision}}
                    </option>
                  </select>
                  <button  title="Import data from selected class"
                    *ngIf="selectedClassIdForFeeTerm" (click)="handleCopyButton(false)">
                    {{ 'import' | translate }}
                  </button>
                </div>
              </div>
              <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
                <div class="col-md-12">
                  <div class="row">
                    <!-- <div *ngIf="termFeeConfigurations.length == 0">Please add fee in fees board</div>-->
                    <div class="table-responsive" style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">
                      <table id="termfeeconfiguration_newnew" class="table table-striped ">
                        <thead style="background: var(--brand-primary-color);color: white;">
                          <tr
                            style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'feesCategory' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'viewHistory' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'totalAmount' | translate }}({{currType}})</b>
                            </th>
                            <th *ngFor="let t of termList"
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{t.TermName}}({{currType}})</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="gradeX" *ngFor="let termfee of termFeeConfigurations; let i = index">
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{termfee.Name}}</td>
                            <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"><i
                                class="btn btn-flat ink-reaction fa fa-history" data-toggle="tooltip"
                                title="click here to view history" style="cursor:pointer;" data-toggle="modal"
                                data-target="#viewTermConfigHistory"
                                (click)="getTermConfigHistoryDetailView(termfee)"></i></td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{termfee.Amount}}</td>
                            <td *ngFor="let feecomp of termfee.termFees"
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <input type="number" min="0" style="width: 76px" class="no-spin"
                                [(ngModel)]="feecomp.PaymentAmount"
                                (keyup)="feecomp.PaymentAmount = $event.target.value;isTermConfigchanged = true;setMaxLengthForTerm(feecomp)"
                                name="termconf">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="termConfigStatus"
                style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                <div class="col-md-12" style="text-align: center;">
                  <!-- <img src="assets/img/search_icon_animation.gif" style="   width: 300px;">-->
                  <h3 style="margin-top: -28px;color: #a1a1a1;font-weight: 900;">{{ 'pleaseWait' | translate }}</h3>
                </div>
              </div>
              <div class="col-md-12 text-center" style="padding: 10px 0px;">
                <button type="button" id="termConfig" class="btn btn-raised ink-reaction btn-info disable_buttons"
                  (click)="updateTermFeeConfigForStru()">{{'save' | translate}}</button>
                <button type="button" id="offcanvas_updatetermfeeconfig_cancel_button" data-dismiss="modal"
                  class="btn btn-raised ink-reaction btn-info disable_buttons" (click)="handleCancelFeeTerm()">{{ 'cancel' | translate }}</button>
              </div>
              <div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
                <!-- <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                                        <button type="button" class="btn btn-raised ink-reaction btn-info">Add student</button> -->
                <p style="color: #717171;"></p>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div>

        <!--TERM FEE CONFIGURATION END-->

        <!--TERM FEE CONFIGURATION HISTORY START-->
        <div class="modal fade" id="viewTermConfigHistory" tabindex="-1" role="dialog"
          aria-labelledby="simpleModalLabel" aria-hidden="true">
          <div class="modal-dialog" style="width: 65%;">
            <div class="modal-content">
              <div class="modal-header" style="padding: 0px 25px;">
                <button type="button" id="closeTermConfigHistoryModel" class="close" data-dismiss="modal"
                  aria-hidden="true"
                  style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
                <div class="row">
                  <div class="col-md-12" style="text-align:center;margin-top: -1em;">
                    <h3 class="text-primary"
                      style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span
                        style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i
                          class="fa fa-flag"></i></span>{{ 'termConfigHistory' | translate }} <span id="TermConfigHistory"></span></h3>
                    <p style="margin: 0;color: #989898;margin-top: 15px;margin-bottom: 10px;">{{ 'viewHistoryFor' | translate }}
                      <b>{{getTypeName}}</b>
                    </p>
                  </div>
                </div>
              </div>
              <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
                <div class="col-md-12">
                  <div class="row">
                    <!-- <div *ngIf="termFeeConfigurations.length == 0">Please add fee in fees board</div>-->
                    <div class="table-responsive"
                      style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;padding: 1em 1em;">
                      <table id="TermConfig_new" class="table table-striped" style="border-left: 1px solid #b9b6b6;">
                        <thead style="background: var(--brand-primary-color);color: white;">
                          <tr
                            style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'modifiedBy' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <b>{{ 'termName' | translate }}</b>
                            </th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{ 'originalValue' | translate }}({{currType}})</th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{ 'newValue' | translate }}({{currType}})</th>
                            <th
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{ 'modifiedDate' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="gradeX" *ngFor="let termhis of getTermConfigHistoryForView"
                            style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{termhis.username}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{termhis.TermName}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{termhis.OldValue}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{termhis.NewValue}}</td>
                            <td
                              style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              {{termhis.CreatedTime | date: 'dd-MMM-yyyy hh:mm a'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="termConfigHistoryStatus"
                style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                <div class="col-md-12" style="text-align: center;">
                  <!-- <img src="assets/img/search_icon_animation.gif" style="   width: 300px;">-->
                  <h3 style="margin: 0;color: #a1a1a1;font-weight: 900;">{{ 'pleaseWait' | translate }}.</h3>
                </div>
              </div>

              <div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
                <p style="color: #717171;"></p>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div>
        <!--TERM FEE CONFIGURATION HISTORY END-->

        <!--STUDENT FEE DETAIL START-->

        <div class="modal fade" id="studentFeeDetail" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
          aria-hidden="true">
          <div class="modal-dialog" style="width: 98%;">
            <div class="modal-content">
              <div class="modal-header" style="padding: 0px 25px;">
                <button type="button" id="closeStudentFeeModel" class="close" data-dismiss="modal" aria-hidden="true"
                  style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
                <div class="row">
                  <div class="col-md-12" style="text-align:center;margin-top: -1em;">
                    <h3 class="text-primary"
                      style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span
                        style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i
                          class="fa fa-users"></i></span>{{ 'classFeeDetails' | translate }}<span id="studentFeeByClass"></span></h3>
                    <p style="margin-left: 4em;color: #989898;margin-top: -5px;margin-bottom: 10px;">{{ 'feeDetailFor' | translate }}
                      <b>{{selectedClass.classNumber}} - {{selectedClass.classDivision}}</b>
                    </p>
                  </div>
                </div>
              </div>
              <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
                <div *ngIf="studentFeeStatus"
                  style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;z-index: 999;">
                  <div class="col-md-12" style="text-align: center;">
                    <h3 style="color: #a1a1a1;font-weight: 900;">{{ 'pleaseWait' | translate }}</h3>
                  </div>
                </div>
                <div *ngIf="studentFeeDetailTable">
                  <div class="col-md-12">
                    <div [style.display]="openSendSMSView ? 'none' : ''">
                      <div class="text-center">
                        <table>
                          <tr>
                            <td style="width:10%"></td>
                            <td><span><i class="fa fa-square-o" aria-hidden="true"
                                  style="background-color: rgb(10, 189, 10);margin-left: 15em;color: rgb(10, 189, 10);"></i>
                                {{ 'feesPaid' | translate }}</span></td>
                            <td><span><i class="fa fa-square-o" aria-hidden="true"
                                  style="background-color: rgb(255, 0, 0);margin-left: 1em;color: rgb(255, 0, 0);"></i>
                                {{ 'overDues' | translate }}</span></td>
                            <td><span><i class="fa fa-square-o" aria-hidden="true"
                                  style="background-color: gray;margin-left: 1em;color: gray;"></i>{{ 'deactivated' | translate }}</span>
                            </td>
                            <td>&nbsp;&nbsp;</td>
                            <td>
                              <form class="form-inline text-center search-groups" autocomplete="off">
                                <div class="form-group" style="padding: 0;">
                                  <h3 class="lead">{{ 'filterFeesBy' | translate }}</h3>
                                </div>
                                <div class="form-group" style="padding: 0">
                                  <select id="selectFee" name="selectFee" (change)="filterFees($event.target.value)"
                                    class="form-control" style="height: 2em;">
                                    <option value="">{{ 'all' | translate }}</option>
                                    <option value="Dues">{{ 'overDues' | translate }}</option>
                                    <option value="Collected">{{ 'collected' | translate }}</option>
                                  </select>
                                  <div class="form-control-line"></div>
                                </div>
                                <div class="form-group" style="padding: 0;">
                                 <button class="export-btn" (click)="openExportReportConfiguration()">{{ 'export' | translate }} <i class="ri-upload-2-line"></i></button>
                                </div>
                              </form>
                            </td>
                          </tr>
                        </table>
                      </div>

      <p-dialog 
  [(visible)]="excelExportPopUp" 
  [modal]="true" 
  [style]="{ width: '600px', padding: '0' }" 
  [draggable]="false" 
  [resizable]="false" 
  [contentStyle]="{'padding': '20px'}"
  [showHeader]="false"
  class="export-report-dialog"
  [baseZIndex]="10000" 
  [closable]="true"
>
  <button class="export-report-close-btn" (click)="excelExportPopUp=false">&times;</button>

      <div class="export-report-form-title">{{ 'optionExport' | translate }}</div>
     <div class="option-container">
  <div class="option-type-export">{{ 'standardOptions' | translate }}</div>
  <div class="option-type-export-separator"></div>
</div>
<div class="export-report-toggles-container">

        <div class="toggle-column">
          <div class="toggle-item">
            <label class="toggle-label">
              <input type="checkbox" [(ngModel)]="standardOption" (ngModelChange)="onStandardOptionChange($event)" />
              {{ 'standardOptionMessage' | translate }}
            </label>
            <label for="standard-option">
              <i class="ri-information-line"></i> {{ 'standardOptionInfo' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input type="checkbox" [(ngModel)]="downloadPendingReport" (ngModelChange)="onDownloadPendingReportChange($event)" />
              {{ 'downloadPendingFeesReport' | translate }}
            </label>
            <label>
              <i class="ri-information-line"></i> {{ 'downloadPendingFeesReportInfo' | translate }}
            </label>
          </div>

        </div>

        
      </div>
           <div class="option-container" *ngIf="!downloadPendingReport">
  <div class="option-type-export">{{'advanceFilter' | translate}}</div>
  <div class="option-type-export-separator"></div>
</div>
  <div class="export-report-dialog-inner-container" *ngIf="!downloadPendingReport">


      <div class="export-report-toggles-container">
        <div class="toggle-column">
          <div class="toggle-item">
            <label class="toggle-label">
              <input  [disabled]="standardOption"  type="checkbox" [(ngModel)]="showActualFees" />
              {{ 'actualFees' | translate }}
            </label>
            <label for="R">
              <i class="ri-information-line"></i> {{ 'showActualFees' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input  [disabled]="standardOption"  type="checkbox" [(ngModel)]="showTotalCollected" />
              {{ 'totalCollectedFees' | translate }}
            </label>
            <label>
              <i class="ri-information-line"></i> {{ 'showTotalCollected' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input  [disabled]="standardOption"  type="checkbox" [(ngModel)]="showTotalPending" />
              {{ 'totalPendingFees' | translate }}
            </label>
            <label for="R">
              <i class="ri-information-line"></i> {{ 'showTotalPending' | translate }}
            </label>
          </div>

                <div class="toggle-item">
            <label class="toggle-label">
              <input [disabled]="standardOption" type="checkbox" [(ngModel)]="showOtherFee" />
              {{ 'actualOther' | translate }}
            </label>
            <label for="R">
              <i class="ri-information-line"></i> {{ 'showOtherFee' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input [disabled]="standardOption" type="checkbox" [(ngModel)]="showOtherFeePending" />
              {{ 'otherFeePending' | translate }}
            </label>
            <label for="R">
              <i class="ri-information-line"></i> {{ 'showPendingOtherFee' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input  [disabled]="standardOption"  type="checkbox" [(ngModel)]="showRowLevelTotal" />
              {{ 'rowLevelTotal' | translate }}
            </label>
            <label for="">
              <i class="ri-information-line"></i> {{ 'showRowLevelTotal' | translate }}
            </label>
          </div>
        </div>

        
      </div>
      <!-- <i class="add-academic-icon pi pi-file-excel"></i>
      <p class="export-report-title">{{ 'exportExcel' | translate }}</p>
      <p class="export-report-subtitle">{{ 'messageForReportExport' | translate }}</p> -->
    

   
      
     
      <div class="export-report-toggles-container">

        <div class="toggle-column">
          <div class="toggle-item">
            <label class="toggle-label">
              <input [disabled]="standardOption" type="checkbox" [(ngModel)]="showColumnLevelTotal" />
              {{ 'columnLevelTotal' | translate }}
            </label>
            <label for="">
              <i class="ri-information-line"></i> {{ 'showColumnLevelTotal' | translate }}
            </label>
          </div>

        <div class="toggle-item">
            <label class="toggle-label">
              <input [disabled]="standardOption" type="checkbox" [(ngModel)]="showOtherFeeCollected" />
              {{ 'totalOtherCollectedFee' | translate }}
            </label>
            <label for="R">
              <i class="ri-information-line"></i> {{ 'showCollectedOtherFee' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input [disabled]="standardOption"  type="checkbox" [(ngModel)]="showGrandTotal" />
              {{ 'showGrandTotal' | translate }}
            </label>
            <label for="">
              <i class="ri-information-line"></i> {{ 'showGrandTotalDescription' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input [disabled]="standardOption"  type="checkbox" [(ngModel)]="showBalance" />
              {{ 'showBalance' | translate }}
            </label>
            <label for="">
              <i class="ri-information-line"></i> {{ 'showBalanceDescription' | translate }}
            </label>
          </div>

          <div class="toggle-item">
            <label class="toggle-label">
              <input [disabled]="standardOption"  type="checkbox" [(ngModel)]="showReceived" />
              {{ 'showReceived' | translate }}
            </label>
            <label for="">
              <i class="ri-information-line"></i> {{ 'showReceivedDescription' | translate }}
            </label>
          </div>
        </div>
      </div>

    
  </div>

  <div *ngIf="downloadPendingReport" class="pending-report-section">
    <div class="option-container" style="margin-bottom: 10px;">
      <div class="option-type-export">{{ 'studentFilter' | translate }}</div>
      <div class="option-type-export-separator"></div>
    </div>
    <div class="pending-report-filter-row export-report-toggles-container">
      <label class="toggle-label">
        <input type="checkbox" [checked]="!pendingActiveFilter && !pendingDeactiveFilter" disabled />
        {{ 'allFilter' | translate }}
      </label>
      <label class="toggle-label">
        <input type="checkbox" [(ngModel)]="pendingActiveFilter" />
        {{ 'activeStudent' | translate }}
      </label>
      <label class="toggle-label">
        <input type="checkbox" [(ngModel)]="pendingDeactiveFilter" />
        {{ 'deactiveStudent' | translate }}
      </label>
    </div>
  </div>

  <div class="export-btn-row">
    <button (click)="exportToExcel()" class="export-report-submit-btn">{{ 'exportReportExcel' | translate }}</button>
    <button (click)="exportToPrint()" class="export-report-submit-btn">{{ 'printReportExcel' | translate }}</button>
  </div>
</p-dialog>
                      <div style="text-align: center" ngClass="{{selectedOverdueStudentsCount > 0 ? '' : 'invisible'}}">
                        <button (click)="openSendSMSView = true;" class="btn btn-raised ink-reaction btn-info"
                          style="z-index: 200"> {{ 'sendOverdueSmsTo' | translate }} {{selectedOverdueStudentsCount}}
                          {{selectedOverdueStudentsCount > 1 ? 'students' : 'student'}}</button>
                      </div>
                      <div class="table-responsive feeStd" style="padding: 10px 0px; margin-top: -4%;">
                        <table id="classFeeDetailTable" class="table table-striped ">
                          <thead style="background: var(--brand-primary-color);color: white;">
                            <tr
                              style="font-size: 10px;border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                              <th class='notexport' *ngIf="academicPermissions.MESSAGES === 'ENABLED'">{{ 'select' | translate }}</th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                <b>{{ 'studentName' | translate }}</b>
                              </th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                <b>{{ 'parentName' | translate }}</b>
                              </th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                <b>{{ 'structureName' | translate }}</b>
                              </th>
                               <th *ngFor="let feeName of headerFeeName" data-toggle="tooltip"
                                title="{{feeName.FeeName}}"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                <b>{{feeName.FeeName}}&nbsp;<br>{{'Pending'}}({{currType}})</b>
                              </th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                {{ 'totalBusFare' | translate }}&nbsp;<br>{{ 'pending' | translate }}({{currType}})</th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                {{ 'totalCollectedAmount' | translate }}({{currType}})</th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                {{ 'totalDiscount' | translate }}({{currType}})</th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                {{ 'netCollectedAmount' | translate }}({{currType}})</th>
                              <th
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                                {{ 'totalPendingAmount' | translate }}({{currType}})</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let fee of allStudentAllFee"
                              [style.background-color]="fee.isBlocked == 1 ? 'gray' : ''"
                              style="font-size: 10px;border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">
                              <td *ngIf="academicPermissions.MESSAGES === 'ENABLED'"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"><span
                                  class="data-to-export hide"></span><label id="select_student_lable"
                                  *ngIf="fee.isBlocked === 0"
                                  class='checkbox-inline checkbox-styled checkbox-primary'><input
                                    (change)="overdueStudentSelected(fee)" [(ngModel)]="fee.selectedStudent"
                                    type='checkbox'><span class='checkbox-material'><span
                                      class='check'></span></span></label></td>
                              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;"
                                title="{{fee.studentName}}"><span
                                  class="data-to-export hide">{{fee.studentName}}</span>{{textWrappingForStudentName(fee.studentName)}}
                              </td>
                              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"
                                title="{{fee.parentName}}"><span
                                  class="data-to-export hide">{{fee.parentName}}</span>{{textWrappingForStudentName(fee.parentName)}}
                              </td>
                              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"
                                title="{{fee.structureName}}"><span class="data-to-export hide">{{fee.structureName ?
                                  fee.structureName : 'Default'}}</span>{{fee.structureName ?
                                textWrappingForStudentName(fee.structureName):'Default'}}</td>
                              <td id="{{'test_'+fee.studentId+'_'+data.feesId}}" *ngFor="let data of headerFeeName"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"><span
                                  class="data-to-export"
                                  id="{{'tdId_'+fee.studentId+'_'+data.feesId}}">{{ 'na' | translate }}</span>&nbsp;<span class="hide"
                                  id="{{'filter_'+fee.studentId+'_'+data.feesId}}"></span></td>
                              <td id="{{'busFeeColl_'+fee.studentId}}"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"><span
                                  class="data-to-export" id="{{'busFeeId_'+fee.studentId}}">{{ 'na' | translate }}</span>&nbsp;<span
                                  class="hide" id="{{'busCol_'+fee.studentId}}"></span></td>
                              <td id="{{'collected_'+fee.studentId}}"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"
                                class="data-to-export">0</td>
                              <td id="{{'discount_'+fee.studentId}}"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"
                                class="data-to-export">0</td>
                              <td id="{{'netcollected_'+fee.studentId}}"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6"
                                class="data-to-export">0</td>
                              <td id="{{'pending_'+fee.studentId+fee.studentId}}" class="data-to-export"
                                style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">0</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div *ngIf="openSendSMSView">
                      <br>
                      <div style="text-align: center">{{ 'sendOverdueMessageTo' | translate }} {{selectedOverdueStudentsCount}}
                        {{selectedOverdueStudentsCount > 1 ? 'parents' : 'parent'}}</div>
                      <br>
                      <app-sendSms [userType]="'BOTH'" [user_count]="selectedOverdueStudentsCount"
                        [sendTo]="'SELECTIVE_STUDENT'" [studentType]="'SELECTIVE_STUDENT'"
                        [studentList]="selectedOverdueStudentsList"></app-sendSms>
                      <br>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
                <!-- <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-raised ink-reaction btn-info">Add student</button> -->
                <p style="color: #717171;">© {{currentYear}} {{ 'bluewingsAllRightReserved' | translate:{ brandName: brand.name } }}</p>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div>

        <!--STUDENT FEE DETAIL END-->


        <!-- Change student from student category  -->
        <div class="modal fade" id="remove-student-from-group" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="padding: 10em 0em;">
            <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
              <div class="row text-center">
                <div class="form-group">
                  <div class="input-group" style="margin-left: 27%;">
                    <div class="input-group-content">
                      <label>{{ 'selectCategoryToMove' | translate }}</label>
                      <select (change)="onChangeStudentCategorySelection(selectedCategoryToMove)"
                        [(ngModel)]="selectedCategoryToMove" style="border: 1px solid #e6e6e6;" class="form-control"
                        id="select-category-to-move-student" name="select-category-to-move-student">
                        <option value="0">{{ 'default' | translate }}</option>
                        <option value="{{c.pkStudentsCategoryId}}" *ngFor="let c of studentCategoryList">{{c.Name}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedCategoryToMove != this.addNewStudentCategory.studentCategoryId"><span>{{ 'byMovingToAnotherCategoryItWillAffectStudentsFeeStructure' | translate }}</span></div>
              </div>
              <div class="text-center" style="padding: 8px 0px;">
                <button [disabled]="isProcessing"
                  *ngIf="selectedCategoryToMove != this.addNewStudentCategory.studentCategoryId" type="button"
                  class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                  (click)="moveStudentToAnotherCategory(selectedStudentIdToMove,selectedCategoryToMove)">{{ 'move' | translate }}</button>
                <button [disabled]="isProcessing" type="button" class="btn btn-raised ink-reaction btn-info"
                  style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Change student from student category End  -->

        <!-- Add Discount -->
        <div class="modal fade" id="add-discount" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="col-md-12" style="background-color: white;padding: 0px 20px;">
                <div class="row" style="padding: 10px 10px;">
                  <img src="images_ext/discount.png">
                  <h3 style="margin-top: -27px;margin-left: 2em;color: var(--brand-primary-color);">{{ 'addNewDiscount' | translate }}</h3>
                </div>
                <button
                  style="background-color: var(--brand-primary-color);margin-right: -2.3em;margin-top: -4.7em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form">
                  <div class="form-group">
                    <input type="text" class="form-control" id="discountName" [(ngModel)]="addDiscount.discountName"
                      name="discountName">
                    <label style="font-size: small;">{{ 'discountName' | translate }}</label>
                  </div>
                  <div class="form-group">
                    <select [ngModelOptions]="{standalone: true}" [(ngModel)]="addDiscount.feeStructuresId"
                      id="fee-structure-add-discount" name="select1" class="form-control">
                      <option value="general">{{ 'generalDefault' | translate }}</option>
                      <option *ngFor="let o of feeStructureListForSelect" [value]="o.pkFeeStructuresId">{{o.Name}}
                      </option>
                    </select>
                    <label for="fee-structure-add-discount">{{ 'feeStructure' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                  <div style="display: flex;">
                    <div class="form-group" style="width: 7%;">
                      <select class="form-control" name="discountAmountType" (change)="addDiscount.discountAmount = ''"
                        [(ngModel)]="addDiscount.discountAmountType">
                        <option value="AMOUNT">{{currType}}</option>
                        <option value="PERCENT">%</option>
                      </select>
                      <label style="font-size: small;">{{ 'type' | translate }}</label>
                    </div>
                    <div class="form-group" style="width: 90%;margin-left: 3%;">
                      <input type="number" class="form-control" id="amount" [(ngModel)]="addDiscount.discountAmount"
                        name="discAmount">
                      <label style="font-size: small;">{{addDiscount.discountAmountType == 'AMOUNT' ? 'Amount'
                        :'Percent'}}</label>
                    </div>
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" id="discountReason" [(ngModel)]="addDiscount.discountReason"
                      name="discountReason">
                    <label style="font-size: small;">{{ 'reasonForDiscount' | translate }}</label>
                  </div>
                </form>
                <div class="row form-group">
                  <!--<div class="row" style="border: 1px solid;width: 95%;margin-left: 2%;">
                    <div class="col-md-12" style="padding: 5px 25px;">
                      <form class="form" style="overflow: auto;" id="termlist">
                        <div class="checkbox checkbox-styled col-md-3" style="display: inline-block;margin: 0px;" *ngFor="let term of allFeeNames.termList">
                          <label>
                            <input type="checkbox" [(ngModel)]="term.selected" name="termName">
                            <span title="{{term.TermName}}">{{truncateText(term.TermName,15)}}</span>
                          </label>
                        </div>
                      </form>
                    </div>
                  </div>-->

                  <div style="width: 95%;margin-left: 2%;" class="row">
                    <div class="col-md-12" style="padding: 5px 10px;height: 200px;overflow: auto;">
                      <form class="form" style="overflow: auto;" id="typelist">
                        <div class="checkbox checkbox-styled col-md-12" style="display: inline-block;margin: 0px;"
                          *ngFor="let type of allFeeNames.typeList">
                          <label>
                            <input type="checkbox" [(ngModel)]="type.selected"
                              (change)="selectAllTermsInComponent(type,type.selected)"
                              name="{{'typeName'+type.pkFeesTypeId}}">
                            <span title="{{type.Name}}">{{truncateText(type.Name,15)}}
                              <!--Selected terms: {{0}}/{{type.terms.length}}--></span>
                          </label>
                          <i *ngIf="type.terms && !type.expand" (click)="type.expand = true;" class="fa fa-caret-down"
                            aria-hidden="true" style="margin-left: 7px;cursor: pointer;"></i>
                          <i *ngIf="type.terms && type.expand" (click)="type.expand = false;" class="fa fa-caret-right"
                            aria-hidden="true" style="margin-left: 7px;cursor: pointer;"></i>
                          <!--<span>terms: {{ type.terms.length}}</span>-->
                          <div *ngIf="type.expand" class="col-md-12" style="padding: 5px 25px;">
                            <form class="form" style="overflow: auto;" id="termlist">
                              <div class="checkbox checkbox-styled col-md-3" style="display: inline-block;margin: 0px;"
                                *ngFor="let term of type.terms">
                                <label>
                                  <input type="checkbox" (change)="term.selected == false ? type.selected = false : ''"
                                    [(ngModel)]="term.selected" name="{{'termName'+term.pkFeesTermId}}">
                                  <span title="{{term.TermName}}">{{truncateText(term.TermName,15)}}</span>
                                </label>
                              </div>
                            </form>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <hr>
                  <div style="width: 95%;margin-left: 2%;" class="row">
                    <div class="col-md-12" style="padding: 5px 10px;">
                      <form class="form" style="overflow: auto;" id="bustermlist">
                        <!--<i *ngIf="processingNW" class="fa fa-spinner" aria-hidden="true"></i>-->
                        <div class="checkbox checkbox-styled col-md-3" style="display: inline-block;margin: 0px;"
                          *ngFor="let type of allFeeNames.busTermList">
                          <label>
                            <input type="checkbox" [(ngModel)]="type.selected" name="bustermlist">
                            <span title="{{type.termName}}">{{truncateText(type.termName,15)}}</span>
                          </label>
                        </div>
                      </form>
                    </div>
                  </div>
                </div><!--end .form-group -->
                <div class="row text-center" style="padding: 15px 0px;">
                  <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                    id="addDiscountbutton" (click)="adddiscount(addDiscount)">{{ 'proceed' | translate }}</button>
                  <button id="popupAddDiscount" type="button" class="btn btn-raised ink-reaction btn-info"
                    style="padding: 3px 20px;" data-dismiss="modal">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!-- End of Add Discount -->

        <!-- Apply Discount -->
        <div class="modal fade" id="apply-discount" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content col-md-12" style="background-color: white;padding: 15px 20px;width: 150%;">
              <div class="col-md-12" style="border: 1px dashed gray;;padding: 4em 0em;">
                <button
                  style="background-color: var(--brand-primary-color);margin-right: -2.5em;margin-top: -5em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <div class="row" style="margin-top: -3em;padding: 0px 2em;">
                  <img src="images_ext/discount.png">
                  <h3 style="margin-top: -1.5em;margin-left: 2em;">{{ 'applyDiscount' | translate }}</h3>
                </div>
                <div class="row col-md-12 text-center" style="    padding: 0em 2em;">
                  <div>{{ 'searchStudentsFrom' | translate }} <b>{{selectedDiscount.FeeStructureName || 'Default/ Basic'}}</b> {{ 'feeStructure' | translate }}</div>
                  <div class="custom-toggle-container" data-type="horizontal">
                    <form class="form-inline text-center search-groups" autocomplete="off">
                      <div class="form-group" style="margin: 0px;">
                        <select id="selectSectionId" (change)="searchStudentsForApplyDiscount()" name="select13"
                          class="form-control">
                          <!--<option value="0">Select Section</option>-->
                          <option value="all" *ngIf="selectedDiscount.pkStudentsCategoryId">{{ 'allFrom' | translate }}
                            {{selectedDiscount.FeeStructureName || 'Default/ Basic'}}</option>
                          <option *ngFor="let secId of classSectionsInStudentCategory" value="{{secId.classId}}">
                            {{secId.classNumber}} - {{secId.classDivision}}</option>
                        </select>
                        <div class="form-control-line"></div>
                      </div>
                    </form>
                    <div class="toggle-student-container">
                      <input type="checkbox" [(ngModel)]="isStudentActiveForDiscount" (click)="toggleDiscount()"
                        [disabled]='discountLoader' />
                      <div class="slider-student-status"></div>
                    </div>
                    <img src="../../assets//img//info.png" class="info-student-status"
                      title="You can view the list of active and&#10;deactive students by using this button.">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="table-responsive" style="padding: 10px 15px;">
                    <table id="searchStudentApplyDiscountTable" class="table table-striped disc-table"
                      *ngIf="!discountLoader">
                      <thead>
                        <tr>
                          <th><input type="checkbox" id="selectAll" (change)="selectAll()" style="float: left;">&nbsp;
                            {{ 'selectAll' | translate }}</th>
                          <th>{{ 'studentName' | translate }}</th>
                          <th>{{ 'parentName' | translate }}</th>
                          <th>{{ 'registrationNumber' | translate }}</th>
                          <th>{{ 'mobileNo' | translate }}</th>
                          <th>{{ 'class' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody *ngIf="discountStudentList.length > 0 && !discountLoader ; else noData">
                        <tr *ngFor="let s of discountStudentList">
                          <td>
                            <div class="checkbox">
                              <label><input type="checkbox" [(ngModel)]="s.select" name="selectstudent"></label>
                            </div>
                          </td>
                          <td>{{s.studentName}}</td>
                          <td>{{s.parentName}}</td>
                          <td>{{s.registrationId}}</td>
                          <td>{{s.mobileNumber}}</td>
                          <td>{{s.className}}</td>
                        </tr>
                      </tbody>
                      <ng-template #noData>
                        <tr>
                          <td colspan="6" class="no-discount-details-exist">{{ 'noDataAvailableInTable' | translate }}</td>
                        </tr>
                      </ng-template>
                    </table>
                    <app-new-loader *ngIf="discountLoader"></app-new-loader>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="text-right">
                    <button type="button" id="closeApplyDiscountpopup" class="btn btn-raised ink-reaction btn-info"
                      data-dismiss="modal">{{ 'cancel' | translate }}</button>
                    <button type="button" class="btn btn-raised ink-reaction btn-info" id="applydiscountbutton"
                      (click)="applyDiscountToStudent()">{{ 'apply' | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Apply Discount -->

        <!--Apply Discount Status-->
        <div data-toggle="modal" id="applyDiscountStatus_open" data-target="#applyDiscountStatus"></div>
        <div class="modal fade" id="applyDiscountStatus" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" style="width: 150%;">
              <div class="card">
                <div class="card-head">
                  <div class="col-md-12">
                    <img src="images_ext/battery-with-verification-sign.png" style="margin-left: 8em;">
                    <h3 style="margin-top: -2em;text-align: center;">{{ 'statusOfDiscountApplied' | translate }}</h3>
                    <!--<hr>-->
                  </div>
                </div>
                <div class="card-body">
                  <table class="table table-striped no-margin" id="applyDiscountStatusTable">
                    <thead>
                      <tr>
                        <th>{{ 'studentName' | translate }}</th>
                        <th>{{ 'className' | translate }}</th>
                        <th>{{ 'registrationNumber' | translate }}</th>
                        <th>{{ 'status' | translate }}</th>
                        <th>{{ 'reason' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let st of applyDiscountStatus">
                        <td>{{st.student.studentName}}</td>
                        <td>{{st.student.className}}</td>
                        <td>{{st.student.registrationId}}</td>
                        <td *ngIf="st.status == 'APPLIED'" style="color: #0ce00c;"><b>{{st.status == 'APPLIED' ?
                            'Applied' : 'Failed'}}</b></td>
                        <td *ngIf="st.status != 'APPLIED'" style="color: red;"><b>{{st.status == 'APPLIED' ? 'Applied' :
                            'Failed'}}</b></td>
                        <td *ngIf="st.status == 'APPLIED'">
                          <span>{{ 'discountSuccessfullyAppliedFor' | translate }} </span>
                          <span *ngIf="(st.TermName && st.TypeName) || st.TermName"><b>{{st.TypeName}} {{st.TypeName ?
                              '-':''}} {{st.TermName}}{{ 'term' | translate }}</b></span>
                          <span *ngIf="st.TypeName && !st.TermName"><b>{{st.TypeName}}{{ 'other' | translate }}</b></span>
                          <span *ngIf="st.busTermName"><b>{{st.busTermName}}{{ 'transport' | translate }}</b></span>
                        </td>
                        <td *ngIf="st.status == 'ALREADY_APPLIED'">
                          <span>{{ 'discountSuccessfullyAppliedFor' | translate }} </span>
                          <span *ngIf="(st.TermName && st.TypeName) || st.TermName"><b>{{st.TypeName}} {{st.TypeName ?
                              '-':''}} {{st.TermName}}{{ 'term' | translate }}</b></span>
                          <span *ngIf="st.TypeName && !st.TermName"><b>{{st.TypeName}}{{ 'other' | translate }}</b></span>
                          <span *ngIf="st.busTermName"><b>{{st.busTermName}}{{ 'transport' | translate }}</b></span>
                        </td>
                        <td *ngIf="st.status == 'NOT_APPLIED'">
                          <span *ngIf="(st.TermName && st.TypeName) || st.TermName"><b>{{st.TypeName}} {{st.TypeName ?
                              '-':''}} {{st.TermName}}{{ 'term' | translate }}</b></span>
                          <span *ngIf="st.TypeName && !st.TermName"><b>{{st.TypeName}}{{ 'other' | translate }}</b></span>
                          <span *ngIf="st.busTermName"><b>{{st.busTermName}}({{'transport' | translate}})</b></span>
                          <span> {{ 'pendingAmountIs' | translate }} <b>{{st.pendingAmount}}</b> {{ 'andDiscountAmountIs' | translate }}
                            <b>{{st.discountAmount}}</b></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-right">
                    <button type="button" class="btn btn-raised ink-reaction btn-info disable_buttons"
                      data-dismiss="modal" style="padding: 3px 20px;margin-top: 3em;">{{ 'close' | translate }}</button>
                  </div>
                </div><!--end .card-body -->
              </div>
            </div>
          </div>
        </div>
        <!--End Of Status-->
        <!--Applied Discount Students List-->
        <div data-toggle="modal" data-target="#appliedDiscountStudent" id="appliedDiscountStudent_open"></div>
        <div class="modal fade" id="appliedDiscountStudent" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" style="width: 170%;
    margin-left: -35%;">
              <div class="card">
                <div class="card-head">
                  <div class="col-md-12">
                    <img src="images_ext/battery-with-verification-sign.png" style="margin-left: 8em;">
                    <h3 style="margin-top: -2em;text-align: center">{{ 'appliedDiscountHistory' | translate }}</h3>
                  </div>
                </div>
                <div class="card-body">
                  <table class="table table-striped no-margin" id="appliedStudentList">
                    <thead>
                      <tr>
                        <th>{{ 'studentName' | translate }}</th>
                        <th>{{ 'registrationNumber' | translate }}</th>
                        <th>{{ 'discountAmount' | translate }}({{currType}})</th>
                        <th>{{ 'class' | translate }}</th>
                        <th>{{ 'feeName' | translate }}</th>
                        <th>{{ 'discountedOn' | translate }}</th>
                        <th>{{ 'receiptNo' | translate }}</th>
                        <th>{{ 'feeConcessionForm' | translate }}</th>
                        <!--<th>Delete &nbsp; <input class="hide" type="checkbox" name="selectDeleteAppliedDiscountAll" [(ngModel)]="selectDeleteAppliedDiscountAllVal" (change)="selectDeleteAppliedDiscountAll(selectDeleteAppliedDiscountAllVal)"></th>-->
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let list of appliedDiscountStudentList"
                        [style.background-color]="list.isBlocked == 1 ? 'gray' : ''">
                        <td>{{list.studentName}}</td>
                        <td>{{list.registrationId}}</td>
                        <td>{{list.DiscountAmount}}/-</td>
                        <td>{{list.classNumber}} - {{list.classDivision}}</td>
                        <td *ngIf="(list.TermName && list.TypeName) || list.TermName">{{list.TypeName}}{{list.TypeName ?
                          '-':''}}{{list.TermName}}{{ 'term' | translate }}</td>
                        <td *ngIf="!list.TermName && list.TypeName">{{list.TypeName}}{{ 'other' | translate }}</td>
                        <td *ngIf="list.busTermName">{{list.busTermName}}{{ 'transport' | translate }}</td>
                        <td>{{list.CreatedDate}}</td>
                        <td>{{list.ReceiptNumber}}</td>
                        <td><a (click)="appliedStudentDiscountConsessionForm(list)" data-dismiss="modal"
                            data-toggle="modal" data-target="#view-consession-receipt"
                            style="cursor: pointer;text-decoration: underline;color: blue;"><i class="md md-assignment"
                              aria-hidden="true"></i></a></td>
                        <!--<td style="display: flex;" *ngIf="false">
                        <button [disabled]="list.select" (click)="openDeleteFeePopup(list,'#appliedDiscountStudent','hide')" data-dismiss="modal" data-toggle="modal" data-target="#delete-fees_1" class="btn btn-flat ink-reaction" >
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>
                        <div style="    margin-top: 8px;" *ngIf="false">
                          <label><input type="checkbox" [(ngModel)]="list.select" name="{{'discount'+list.pkFeesCollectionId}}"></label>
                        </div>
                      </td>-->
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-right">
                    <button type="button" class="btn btn-raised ink-reaction btn-info disable_buttons"
                      data-dismiss="modal" style="padding: 3px 20px;margin-top: 3em;">{{ 'close' | translate }}</button>
                  </div>
                </div><!--end .card-body -->
              </div>
            </div>
          </div>
        </div>

        <!--End of applied Students list-->

        <!--Error collecting Fee-->
        <app-error-popup (ok_button_event)="reInitiateStudentFeeCollection()"
          [button_text]="errorStudentFeeCollectionProcess.buttonText"
          [body_content]="errorStudentFeeCollectionProcess.prefixMessage+'&nbsp;&nbsp;&nbsp;'+errorStudentFeeCollectionProcess.message"
          [visible]="errorStudentFeeCollectionProcess.isError ? 'block' : 'none'"
          [title]="errorStudentFeeCollectionProcess.title"></app-error-popup>

        <!--End of Error collecting Fee-->

        <app-student-transport-settings-popup *ngIf="openStudentTransportOptionSettingsPopup" [currType]="currType"
          (save_button_event)="afterTransportOptionsSaved()" (closePopup)="transportOptionsPopupClose()"
          [button_text]="'Save'" [visible]="openStudentTransportOptionSettingsPopup ? 'block' : 'none'"
          [studentName]="studentFeeDashDetails.student.studentName"
          [studentId]="studentFeeDashDetails.student.studentId" [academicId]="academicInfo.current_academic"
          [academicYear]="academicInfo.year"></app-student-transport-settings-popup>
        <app-student-basic-info *ngIf="openStudentBasicInfoPopup" (save_button_event)="afterStudentBasicInfoSaved()"
          (closePopup)="studentBasicInfoPopupClose()" [button_text]="'Save'"
          [visible]="openStudentBasicInfoPopup ? 'block' : 'none'"
          [studentName]="studentFeeDashDetails.student.studentName"
          [studentId]="studentFeeDashDetails.student.studentId" [academicId]="academicInfo.current_academic"
          [schoolCurrency]="currType"></app-student-basic-info>
        <app-student-contact-info *ngIf="openStudentContactInfoPopup"
          (save_button_event)="afterStudentContactInfoSaved()" (closePopup)="studentContactInfoPopupClose()"
          [button_text]="'Save'" [visible]="openStudentContactInfoPopup ? 'block' : 'none'"
          [studentName]="studentFeeDashDetails.student.studentName"
          [studentId]="studentFeeDashDetails.student.studentId" [academicId]="academicInfo.current_academic"
          [schoolCurrency]="currType"></app-student-contact-info>

        <app-edit-student-popup *ngIf="openEditStudentPopup" [currType]="currType"
          (save_button_event)="editStudentOptionSaved()" (closePopup)="editStudentPopupClose()" [button_text]="'Save'"
          [visible]="openEditStudentPopup ? 'block' : 'none'" [studentName]="studentFeeDashDetails.student.studentName"
          [studentId]="studentFeeDashDetails.student.studentId" [academicId]="academicInfo.current_academic"
          [academicYear]="academicInfo.year"></app-edit-student-popup>
        <!--End Of Status-->
        <!--  -->
      </section>
    </div><!--end #content-->
    <!-- END CONTENT -->

    <!-- Menubar -->
    <!--  -->





    <div class="offcanvas">

      <!-- View Class fee details -->
      <div id="offcanvas-view-class-fee" class="offcanvas-pane width-12" style="width:1130px;overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="col-md-12" style="background: var(--brand-primary-color);min-height: 300px;padding: 20px 5px;">
            <div class="col-md-4 text-center" style="color:white;">
              <img src="images_ext/tuition-and-fees.png" class="img-responsive" style="margin: 0 auto;">
              <h5 class="lead" style="padding-bottom: 5px;margin-bottom: 0;">{{ 'feeDetails' | translate }}</h5>
              <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              <div class="col-md-12" style="padding: 30px 0px 0px 0px;">
                <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">{{currType}}
                  {{selectedClass.totalFee}}</h2>
                <p>{{ 'totalFee' | translate }}</p>
              </div>
              <p class="text-right hide"><a href="#"
                  style="border: 1px solid;padding: 2px 20px;text-decoration: none;">{{ 'viewMore' | translate }}</a></p>

            </div>

            <div class="col-md-4" style="color:white;border-right: 1px solid #88c6f7;border-left: 1px solid #88c6f7;">
              <div class="row" style="margin: 10px 0px;">
                <div class="col-md-3">
                  <img src="images_ext/graduate.png" class="img-responsive">
                </div>
                <div class="col-md-9">
                  <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">
                    {{selectedClass.totalStudents}}</h2>
                  <p>{{ 'totalStudents' | translate }}</p>
                </div>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="row" style="margin: 10px 0px;">
                <div class="col-md-3">
                  <img src="images_ext/coins.png" class="img-responsive">
                </div>
                <div class="col-md-9">
                  <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">{{currType}}
                    {{selectedClass.collectedFee}}</h2>
                  <p>{{ 'collectedFees' | translate }}</p>
                </div>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="row" style="margin: 10px 0px;">
                <div class="col-md-3">
                  <img src="images_ext/get-money.png" class="img-responsive">
                </div>
                <div class="col-md-9">
                  <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">{{currType}}
                    {{selectedClass.pendingFee}}</h2>
                  <p>{{ 'pendingFees' | translate }}</p>
                </div>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
            </div>


            <div class="col-md-4 text-center" style="color:white;">
              <div class="" style="padding-top: 3em;">
                <h5 style="font-size: 2em;">{{selectedClass.classNumber}} - {{selectedClass.classDivision}}</h5>
                <div class="hide" style="background: white;padding: 10px 0px;margin: 10px 40px;border-radius: 10px;">
                  <button type="button" class="btn ink-reaction btn-floating-action btn-primary"
                    style="  background: var(--brand-primary-color);   border: none;"><i class="fa fa-plus"></i></button>
                  <h5 class="lead" style="padding-bottom: 5px;margin-bottom: 0;color: var(--brand-primary-color);">{{ 'createNew' | translate }}<br>{{ 'notification' | translate }}</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" style="background: #f1f1f1;border: 1px solid #dddddd;margin-top: -3em;">
            <p class="lead" style="margin: 10px 0px;">{{ 'studentsFeeDetails' | translate }}</p>
          </div><!--end .col -->
          <div class="table-responsive" style="padding: 5px 5px;">
            <table class="table table-striped ">
              <thead>
                <tr>
                  <th>{{ 'studentName' | translate }}</th>
                  <th>{{ 'parentName' | translate }}</th>
                  <th *ngFor="let fee of headerFeeName">{{fee.FeeName}}</th>
                  <th>{{ 'pendingFees' | translate }}({{currType}})</th>
                  <th>{{ 'collectedFees' | translate }}({{currType}})</th>
                </tr>
              </thead>
              <tbody>

              </tbody>
            </table>
          </div>

        </div>
      </div>
      <!-- End view categories -->

      <!-- Edit Fee Component -->
      <div id="offcanvas-edit-fee" class="offcanvas-pane width-12" style="width:700px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="padding: 0;">
          <div class="col-md-12" style="background-color:var(--brand-primary-color);color:white;padding:3em 0em">
            <div class="col-md-4 text-center" style="padding: 2em 2em;">
              <span>
                <i class="fa fa-university fa-2x" aria-hidden="true"></i>
                <span style="font-size: 20px;margin-left: 5px;">{{selectedClassSectionFeeBoard.classStandard}}</span>
              </span>
              <p class="lead"
                style="font-size:inherit;color: rgba(255, 255, 255, 0.69);margin-left: 31px;margin-top: -8px;">{{ 'class' | translate }}</p>
              <span style="margin-left: 3.5em;">
                <i class="fa fa-puzzle-piece fa-2x" aria-hidden="true"></i>
                <span style="font-size: 20px;margin-left: 5px;">{{selectedClassSectionFeeBoard.classNumber}}
                  {{selectedClassSectionFeeBoard.classDivision}}</span>
              </span>
              <p class="lead"
                style="font-size:inherit;color: rgba(255, 255, 255, 0.69);margin-left: 31px;margin-top: -8px;">{{ 'section' | translate }}
              </p>
            </div>
            <div class="col-md-4 text-center" style="border-right: 1px solid #88c6f7;border-left: 1px solid #88c6f7;">
              <span>{{currType}}</span>
              <p class="lead text-center" style="margin-top: 10px">{{ 'updateFeeBoard' | translate }}</p>
            </div>
            <div class="col-md-4 text-center" style="padding: 2em 2em;">
              <span>
                <i class="fa fa-calendar fa-2x" aria-hidden="true"></i>
                <span style="font-size: 20px;margin-left: 5px;">{{selectedClassSectionFeeBoard.AcademicYear}}</span>
              </span>
              <p class="lead"
                style="font-size:inherit;color: rgba(255, 255, 255, 0.69);margin-left: 31px;margin-top: -8px;">{{ 'academicYear' | translate }}</p>
              <span style="margin-left: -1em;">
                <i class="fa fa-users fa-2x" aria-hidden="true" style="margin-left: -2em;"></i>
                <span style="font-size: 20px;margin-left: 5px;">{{selectedClassSectionFeeBoard.TotalStudents}}</span>
              </span>
              <p class="lead"
                style="font-size:inherit;color: rgba(255, 255, 255, 0.69);margin-left: 31px;margin-top: -8px;">{{ 'noOfStudents' | translate }}</p>
            </div>
          </div>
          <div class="col-md-12" style="padding: 5em 3em;">
            <form class="form">
              <div class="form-group col-md-6" *ngFor="let f of selectedClassSectionFeeBoard.feeTypes">
                <input (change)="f.updated = true" title="{{f.paid ? 'Some students already paid their fees' : ''}}"
                  type="text" name="{{f.pkFeesTypeId}}" [(ngModel)]="f.Amount" class="form-control"
                  id="{{f.pkFeesTypeId}}">
                <label for="{{f.pkFeesTypeId}}">{{f.Name}}</label>
              </div>
              <!-- <div class="col-md-4" style="padding: 0.5em 0em;">
                                <button data-toggle="modal" data-target="#add-fee-component" type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">Add Fee Component</button>
                            </div> -->
              <div class="col-md-4 col-md-offset-4" style="padding: 0.5em 0em;">
                <button type="button" class="btn btn-raised ink-reaction btn-info"
                  (click)="updateFeeBoard(selectedClassSectionFeeBoard)" style="padding: 3px 20px;">{{ 'update' | translate }}</button>
                <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="cancelFeeBoardUpdate()"
                  style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- End of Fee component -->
      <!-- Add fee component -->
      <div class="modal fade" id="add-fee-component" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content" style="margin-top: 5em;">
            <div class="col-md-6 text-center" style="background-color: var(--brand-primary-color);color: white;padding: 18px 0px;">
              <i class="fa fa-cubes fa-5x" aria-hidden="true"></i>
              <h3>{{ 'addNewFeeComponent' | translate }}</h3>
              <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
            </div>
            <div class="col-md-6" style="background-color: white">
              <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1em;float: right;border: none;"
                type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                aria-hidden="true">&times;</button>
              <form class="form" role="form" style="padding: 2em 3em;">
                <div class="form-group">
                  <input type="text" class="form-control" id="category">
                  <label for="category" style="font-size: small;">{{ 'addFeeComponent' | translate }}</label>
                </div>
                <div class="text-center">
                  <button type="button" class="btn btn-raised ink-reaction btn-info btn-md">{{ 'add' | translate }}</button>
                  <button type="button" class="btn btn-raised ink-reaction btn-info btn-md">{{ 'cancel' | translate }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- End of add fee component-->
      <!-- Manage Fee Component -->
      <div id="offcanvas-manage-feeComponent" class="offcanvas-pane width-12"
        style="width:600px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="padding: 0;">
          <div class="col-md-12" style="background: var(--brand-primary-color);min-height: 250px;padding: 20px 5px;display: none">
            <div class="col-md-4 text-center" style="color:white;padding-top: 30px;">
              <img src="images_ext/rupee.png" style="width: 50px;">
              <h2 style="letter-spacing: 1px;font-size: 20px;">65,000</h2>
              <p>{{ 'admissionFee' | translate }}</p>
              <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
            </div>
            <div class="col-md-4 text-center"
              style="color:white;border-right: 1px solid #88c6f7;border-left: 1px solid #88c6f7;">
              <div class="row" style="padding: 30px 0px;">
                <img src="images_ext/rupee-symbol.png" style="width: 80px;">
                <h3>{{ 'admissionFee' | translate }}</h3>
              </div>
            </div>
            <div class="col-md-4 text-center" style="color: white;margin-top: 30px;">
              <img src="images_ext/student.png" style="width: 50px;">
              <h3>{{ 'newStudent' | translate }}</h3>
              <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              <p>{{ 'studentType' | translate }}</p>
            </div>
          </div>
          <div class="col-md-12" style="background:#f1f1f1;border:1px solid #dddddd;color: gray;">
            <p class="lead" style="margin: 10px 0px;">{{ 'updateFeeComponent' | translate }}</p>
          </div>
          <div class="col-md-12" style="padding: 2em 2em;">
            <form class="form" role="form" style="padding: 1.2em 0em;">
              <div class="form-group">
                <input type="text" class="form-control" style="font-size: small;" id="editFeeComponentName"
                  name="editFeeComponentName" [(ngModel)]="editFeeComponent.Name">
                <label>{{ 'feeComponentName' | translate }}</label>
              </div>
              <div class="form-group">
                <div class="checkbox checkbox-styled">
                  <label>
                    <input class="termType" type="checkbox" id="editFeeComponentIncludeTerm"
                      name="editFeeComponentIncludeTerm">
                    <span style="color: rgba(49, 53, 52, 0.51);">{{ 'includeInTerm' | translate }}</span>
                  </label>
                </div>
                <div class="form-group date1" style="margin-top: 25px;" *ngIf="!editFeeComponent.includeInTerm">
                  <input type="text" data-date-format="dd/mm/yyyy" class="form-control datepicker1"
                    id="editFeeComponentDueDate" name="editFeeComponentDueDate" [(ngModel)]="editFeeComponent.duedate"
                    style="font-size: small;"><i class="glyphicon glyphicon-calendar"
                    style="float: right;margin-top: -15px;"></i>
                  <label for="editFeeComponentDueDate">{{ 'dueDate' | translate }}</label>
                </div>
              </div>
              <div class="form-group">
                <select id="editSelectAppliesTo" [disabled]="true" [(ngModel)]="editFeeComponent.AppliesTo"
                  name="editSelectAppliesTo" class="form-control"
                  style="color: rgba(49, 53, 52, 0.51);font-size: small;">
                  <option value=""></option>
                  <option value="ALL_STUDENTS">{{ 'allStudents' | translate }}</option>
                  <option value="NEW_STUDENTS">{{ 'newStudents' | translate }}</option>
                  <option value="OLD_STUDENTS">{{ 'oldStudents' | translate }}</option>
                  <option value="BUS_FACILITY_STUDENTS">{{ 'studentsUsingBusFacility' | translate }}</option>
                </select>
                <label for="editSelectAppliesTo" style="font-size: small;">{{ 'studentType' | translate }}</label>
              </div>
              <div class="text-right" style="margin-top: 4em">
                <button type="button" class="btn btn-raised ink-reaction btn-info"
                  (click)="editFeeComponentFn(editFeeComponent)" style="padding: 3px 20px;">{{ 'update' | translate }}</button>
                <button id="close-edit-component-fee-offcanvas" type="button"
                  class="btn btn-raised ink-reaction btn-info" data-dismiss="offcanvas"
                  style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- End of Manage Component -->
      <!-- Update Term Fee Component -->
      <div id="offcanvas-manage-termFee" class="offcanvas-pane width-12" style="width:500px;overflow-x: hidden;">
        <div class="offcanvas-head" style="padding: 0;">
          <div class="col-md-12" style="background: var(--brand-primary-color);min-height: 250px;padding: 20px 5px;">
            <!-- <div class="col-md-4 text-center" style="color:white;padding-top: 30px;">
                              <img src="images_ext/rupee-symbol.png" style="width: 50px;">
                              <hr style="border-top-color: #88c6f7; width: 50%;">
                              <p>Term1</p>
                          </div> -->
            <div class="col-md-6 text-center" style="color:white;border-right: 1px solid #88c6f7;">
              <div class="row" style="padding: 30px 0px;">
                <img src="images_ext/tuition-and-fees.png" style="width: 80px;">
                <h3>{{ 'term' | translate }}</h3>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                <p>{{editTermData.TermName}}</p>
              </div>
            </div>
            <div class="col-md-6 text-center" style="color: white;margin-top: 30px;">
              <img src="images_ext/calendar.png" style="width: 50px;">
              <h3>{{ 'academicYear' | translate }}</h3>
              <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              <p>{{feeDashDetails?.academicYear}}</p>
            </div>
          </div>
          <div class="col-md-12" style="background:#f1f1f1;border:1px solid #dddddd;color: gray;">
            <p class="lead" style="margin: 10px 0px;">{{ 'updateTermComponent' | translate }}</p>
          </div>
          <div class="col-md-12" style="padding: 2em 2em;">
            <form class="form" role="form" style="padding-top: 2em;">
              <div class="form-group">
                <input type="text" [(ngModel)]="editTermData.TermName" name="editterm" id="edit_term_name"
                  class="form-control" style="font-size: small;color: rgba(49, 53, 52, 0.51);">
                <label for="edit_term_name">{{ 'termFeeName' | translate }}</label>
              </div>
              <div class="form-group">
                <div class="form-group">
                  <input type="text" data-date-format="dd/mm/yyyy" id="dueDate_term" class="form-control datepicker1"
                    style="font-size: small;color: rgba(49, 53, 52, 0.51);"><i class="glyphicon glyphicon-calendar"
                    style="float: right;margin-top: -15px;"></i>
                  <label for="dueDate_term">{{ 'dueDate' | translate }}</label>
                </div>
              </div>
              <div class="text-right" style="margin-top: 4em">
                <button (click)="updateTerm(editTermData)" type="button" class="btn btn-raised ink-reaction btn-info"
                  style="padding: 3px 20px;">{{ 'update' | translate }}</button>
                <button (click)="cancelTermUpdate()" type="button" class="btn btn-raised ink-reaction btn-info"
                  style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- End Of Term Fee Component -->
      <!-- Update Fee Term Configuration -->
      <div id="offcanvas-manage-termFeeConfiguration_n" class="offcanvas-pane width-12"
        style="width:500px;overflow-x: hidden;">
        <div class="offcanvas-head" style="padding: 0;">
          <div class="col-md-12" style="background: var(--brand-primary-color);min-height: 250px;padding: 20px 5px;">
            <div class="col-md-6 text-center" style="color:white;border-right: 1px solid #88c6f7;">
              <div class="row" style="padding: 30px 0px;">
                <img src="images_ext/tuition-and-fees.png" style="width: 80px;">
                <h3>{{editTermFeeConfig.Name}}</h3>
              </div>
            </div>
            <div class="col-md-6 text-center" style="color: white;margin-top: 30px;">
              <img src="images_ext/presentation.png" style="width: 80px;">
              <h3>{{ 'class' | translate }} {{editTermFeeConfig.classNumber}} - {{editTermFeeConfig.classDivision}}</h3>
            </div>
          </div>
          <div class="col-md-12" style="background:#f1f1f1;border:1px solid #dddddd;color: gray;">
            <p class="lead" style="margin: 10px 0px;">{{ 'updateTermFeeConfiguration' | translate }}</p>
          </div>
          <div class="col-md-12" style="padding: 2em 2em;">
            <form class="form" role="form" style="padding-top: 2em;">
              <div class="col-md-6">
                <div class="form-group" *ngFor="let ter of editTermFeeConfig.termFees">
                  <input (keypress)="ter.updated = true" name="{{'ter_'+ter.pkFeesTermId}}" type="text"
                    class="form-control" [(ngModel)]="ter.PaymentAmount" id="{{'ter_'+ter.pkFeesTermId}}">
                  <label for="{{'ter_'+ter.pkFeesTermId}}">{{ter.TermName}}</label>
                </div>
              </div>
              <div class="col-md-6 invisible">
                <div class="form-group" *ngFor="let ter of editTermFeeConfig.termFees">
                  <input type="text" class="form-control" name="{{'ter2_'+ter.pkFeesTermId}}"
                    id="{{'ter2_'+ter.pkFeesTermId}}">
                  <label for="{{'ter2_'+ter.pkFeesTermId}}">{{ter.TermName}}</label>
                </div>

              </div>
              <div class="text-center">
                <button id="offcanvas_updatetermfee_cancel_button" type="button"
                  class="btn btn-raised ink-reaction btn-info disable_buttons"
                  style="padding: 3px 20px;margin-top: 3em;" href="#offcanvas-manage-termFeeConfiguration_n"
                  data-toggle="offcanvas">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- End of Fee Term Configuration -->

      <!-- Delete  -->
      <div class="modal fade" id="delete-routes" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" style="padding: 10em 0em;">
          <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
            <div class="row text-center">
              <h4 #delete_text id="delete_text">{{ 'areYouConfirmToDelete' | translate }} </h4>
            </div>
            <div class="text-center" style="padding: 8px 0px;">
              <button type="button" class="btn btn-raised ink-reaction btn-info"
                style="padding: 3px 20px;">{{ 'delete' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Delete  -->

      <!-- Delete Discount -->
      <div class="modal fade" id="delete_discount" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" style="padding: 10em 0em;">
          <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
            <div class="row text-center">
              <h4>{{ 'areYouConfirmToDelete' | translate }} <b><i>{{selectedDiscount.discountName}}</i></b> {{ 'discount' | translate }}</h4>
            </div>
            <div class="text-center" style="padding: 8px 0px;">
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                id="delete_discount_proceed" (click)="delete_discount()">{{ 'delete' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info" id="delete_discount_close"
                style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Delete  -->

      <!-- Delete  Fee -->
      <div class="modal fade" id="delete-fees_1" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" style="padding: 10em 0em;">
          <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;width: 150%;">
            <div class="row text-center">
              <h4>{{ 'areYouSureYouWantToDeleteBelowFeeReceipt' | translate }}</h4>
              <div class="col-md-12" style="padding: 2em 2em;" *ngIf="deleteFeeStep ==  1">
                <!--<span id="fee-receipt-delete-message"></span>-->
                <table class="table table-striped" style="border: 1px solid;">
                  <thead style="background-color: var(--brand-primary-color);color: white;">
                    <tr>
                      <th>{{ 'receiptNo' | translate }}</th>
                      <th>{{ 'feesName' | translate }}</th>
                      <th>{{ 'discount' | translate }}({{currType}})</th>
                      <th>{{ 'dueDate' | translate }}</th>
                      <th>{{ 'paidAmount' | translate }}({{currType}})</th>
                      <th>{{ 'paidDate' | translate }}</th>
                      <th>{{ 'mode' | translate }}</th>
                      <th>{{ 'collectedBy' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr style="background-color: rgba(242, 243, 243, 0.35);"
                      *ngFor="let h of deletingFeeList;let i=index">
                      <td style="vertical-align: middle;border-right: 1px solid #f0f1f1;" *ngIf="i == 0"
                        [attr.rowspan]="deletingFeeList.length">{{h.ReceiptNumber}}</td>
                      <td>{{h.isBusFee == 1 ? 'Transport ('+h.Name+')' : h.Name}}</td>
                      <td>{{h.DiscountAmount || 0}}</td>
                      <td>{{h.DueDate | date: 'dd-MMM-yyyy'}}</td>
                      <td>{{h.Amount}}</td>
                      <td>{{h.CreatedDate | date: 'dd-MMM-yyyy'}}</td>
                      <td>{{h.ModeOfPayment || 'Discount'}}</td>
                      <td>{{h.username || '-'}}</td>
                    </tr>
                  </tbody>
                </table>
                <form class="form" role="form" style="padding-top: 2em;">
                  <div style="margin-left: 25%;margin-right: 25%;">
                    <div class="form-group">
                      <select class="form-control" id="delete_fee_reasons" [(ngModel)]="selectedReasonToDeleteFee"
                        name="select-delete-reason">
                        <option value="0">{{ 'select' | translate }}</option>
                        <option *ngFor="let r of updateFeeReasonsList" [value]="r.pkFeesCollectionUpdateReasonsId">
                          {{r.Reason}}</option>
                        <option value="NEW">{{ 'addNewReason' | translate }}</option>
                      </select>
                      <label style="text-align: start;" for="delete_fee_reasons">{{ 'selectReason' | translate }}</label>
                    </div>
                    <div *ngIf="selectedReasonToDeleteFee == 'NEW'" class="form-group">
                      <input [(ngModel)]="newReasonToDeleteFee" id="add-reason" name="add-reason" type="text"
                        class="form-control">
                      <label style="text-align: start;" maxlength="100" for="delete_fee_popup">{{ 'provideReason' | translate }}</label>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-12" style="padding: 2em 2em;" *ngIf="deleteFeeStep ==  2">
                <form class="form" role="form" style="padding-top: 2em;">
                  <div style="margin-left: 25%;
    margin-right: 25%;">
                    <div class="form-group">
                      <input [(ngModel)]="passwordToDeleteFee" id="delete_fee_popup" name="delete_fee_popup"
                        type="password" class="form-control">
                      <label style="text-align: start;" for="delete_fee_popup">{{ 'enterYourLoginPasswordToProceed' | translate }}</label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="text-center" style="padding: 8px 0px;" *ngIf="deleteFeeStep ==  1">
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                (click)="deleteFee(deleteFeeStep)">{{ 'proceed' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info close-delete-fee"
                style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true"
                (click)="closeDeleteFee(changePopupState)">{{ 'cancel' | translate }}</button>
            </div>
            <div class="text-center" style="padding: 8px 0px;" *ngIf="deleteFeeStep ==  2">
              <button type="button" id="delete-fee-button" class="btn btn-raised ink-reaction btn-info"
                style="padding: 3px 20px;" (click)="deleteFee(deleteFeeStep)">{{ 'delete' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info close-delete-fee"
                style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true"
                (click)="closeDeleteFee(changePopupState)">{{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Delete  Fee -->

      <!-- Delete  -->
      <div id="fee_payment_preview_open" data-target="#fee_payment_preview" data-toggle="modal"></div>
      <div class="modal fade" id="fee_payment_preview" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content" style="border: 3px solid #ff9518;">
            <div class="modal-header" style="background: #ff9518">
              <div class="modal-title" *ngIf="previewPaymentDetailsData">
                <div style="text-align: center;font-weight: bold">{{ 'paymentConfirmation' | translate }}</div>
              </div>
            </div>
            <div class="modal-body" *ngIf="previewPaymentDetailsData">
              <div class="table-responsive">
                <table class="table table-striped disc-table">
                  <tr>
                    <td>{{ 'studentName' | translate }} </td>
                    <td>:</td>
                    <td style="font-weight: bold;color: red">{{previewPaymentDetailsData.studentDetail.studentName}}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ 'parentName' | translate }} </td>
                    <td>:</td>
                    <td>{{previewPaymentDetailsData.studentDetail.parentName}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'mobileNumber' | translate }} </td>
                    <td>:</td>
                    <td>{{previewPaymentDetailsData.studentDetail.mobileNumber}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'class' | translate }}</td>
                    <td>:</td>
                    <td>{{studentFeeDashDetails.student.classNumber}}-{{studentFeeDashDetails.student.classDivision}}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ 'totalFeeAmount' | translate }} </td>
                    <td>:</td>
                    <td>{{currType}} {{payableAmount}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'totalLateFeeAmount' | translate }} </td>
                    <td>:</td>
                    <td>{{currType}} {{payableLateFee}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'payableAmount' | translate }} </td>
                    <td>:</td>
                    <td style="font-weight: bold;color: red">{{currType}}
                      {{previewPopupTotal(totalPayableAmount,payableLateFee)}}</td>
                  </tr>
                </table>
                <div *ngIf="validateFeeData(previewPaymentDetailsData.feesArray).isValid"><span
                    style="text-decoration: underline;font-weight: bold;color: red">{{ 'note' | translate }}</span> {{ 'pleaseReview' | translate }} <span
                    style="color: orangered;font-weight: bold">{{ 'studentDetailsPayableAmount' | translate }}</span> {{ 'isPaymentOf' | translate }}
                  <span style="color: orangered;font-weight: bold">{{currType}}
                    {{previewPopupTotal(totalPayableAmount,payableLateFee)}}</span> {{ 'isPayingFor' | translate }} <span
                    style="color: orangered;font-weight: bold">{{previewPaymentDetailsData.studentDetail.studentName}}</span>,
                  {{ 'thenClickOn' | translate }} <b>{{ 'yesProceed' | translate }}</b> {{ 'orIfInformationShowingIsWrongThenClickOn' | translate }} <b>{{ 'retry' | translate }}</b>
                </div>
                <div *ngIf="!validateFeeData(previewPaymentDetailsData.feesArray).isValid"><span
                    style="text-decoration: underline;font-weight: bolder;color: red">{{ 'paymentFailed' | translate }}</span>{{ 'weFoundThatTheInformationShowingIsWrongThenClickOn' | translate }} <b>{{ 'retry' | translate }}</b></div>
              </div>
            </div>
            <div class="modal-footer" style="background: #ff9518">
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                (click)="reInitiateStudentFeeCollection()" data-dismiss="modal">{{ 'retry' | translate }}</button>
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                (click)="yesProceedPay(previewPaymentDetailsData)" data-dismiss="modal" aria-hidden="true">{{ 'yesProceed' | translate }}</button>
            </div>
          </div>
        </div>
      </div>

      <div id="all_previous_academic_fee_trigger" data-target="#all_previous_academic_fee" data-toggle="modal"></div>
      <div class="modal fade" id="all_previous_academic_fee" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content" style="border: 3px solid #2296f3;">
            <div class="modal-header" style="background: #2296f3">
              <div class="modal-title">
                <div style="text-align: center;font-weight: bold; color: white;font-size: 15px;">{{ 'studentAllAcademic'sPendingFee' | translate }}</div>
              </div>
            </div>
            <div class="modal-body" *ngIf="studentAllAcademicFee.length > 0">
              <div class="table-responsive">
                <table class="table table-striped disc-table">
                  <thead>
                    <tr>
                      <th>{{ 'academicYear' | translate }}</th>
                      <th>{{ 'pendingFee' | translate }}</th>
                      <th>{{ 'action' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let h of studentAllAcademicFee;let i=index">
                      <td>{{h.old_year}}</td>
                      <td>{{h.balanceFee}}</td>
                      <td><a *ngIf="h.balanceFee > 0"
                          style="text-decoration: underline;font-weight: bold;cursor: pointer;color: var(--brand-primary-color);"
                          data-dismiss="modal"
                          (click)="academicInfo.current_academic = h.old_ac_id;academicChanged()">{{ 'collect' | translate }}</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                data-dismiss="modal" aria-hidden="true">{{ 'close' | translate }}</button>
            </div>
          </div>
        </div>
      </div>

      <div id="student_siblings_trigger" data-target="#student_siblings" data-toggle="modal"></div>
      <div class="modal fade bs-example-modal-lg" id="student_siblings" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog bs-example-modal-lg" style="width: 80%;">
          <div class="modal-content" style="border: 3px solid #2296f3;">
            <div class="modal-header" style="background: #2296f3">
              <div class="modal-title">
                <div style="text-align: center;font-weight: bold; color: white;font-size: 15px;">{{ 'siblingsOf' | translate }}
                  {{studentFeeDashDetails?.student?.studentName}}</div>
              </div>
            </div>
            <div class="modal-body">
              <div *ngIf="studentAllSiblings.length > 0">
                <div class="table-responsive">
                  <table class="table table-striped disc-table">
                    <thead>
                      <tr>
                        <th>{{ 'name' | translate }}</th>
                        <th>{{ 'registrationId' | translate }}</th>
                        <th>{{ 'class' | translate }}</th>
                        <th>{{ 'rollNo' | translate }}</th>
                        <th>{{ 'feeStructure' | translate }}</th>
                        <th>{{ 'totalFee' | translate }}</th>
                        <th>{{ 'paidFee' | translate }}</th>
                        <th>{{ 'discountFee' | translate }}</th>
                        <th>{{ 'balanceFee' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let list of studentAllSiblings">
                        <td>{{list.student.studentName}}</td>
                        <td>{{list.student.registrationId}}</td>
                        <td>{{list.student.classNumber}}-{{list.student.classDivision}}</td>
                        <td>{{list.student.rollNumber}}</td>
                        <td>{{list.student.feeStructureName || 'Default'}}</td>
                        <td>{{(list.TermFees.TermAmount || 0) + (list.TypeFees.FeeTypeAmount || 0)}}</td>
                        <td>{{(list.TermFees.Paid || 0) + (list.TypeFees.Paid || 0)}}</td>
                        <td>{{(list.TermFees.Discount || 0) + (list.TypeFees.Discount || 0)}}</td>
                        <td>{{(list.TermFees.Balance || 0) + (list.TypeFees.Balance || 0)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
                data-dismiss="modal" aria-hidden="true">{{ 'close' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div><!--end #base-->
  <!-- END BASE -->

  <script>
    $('.fees').addClass('active');
  </script>
  <!-- END JAVASCRIPT -->

  <!-- fees collection by -->
  <script>
    $(document).ready(function () {
      $('#example').DataTable({
        dom: 'Bfrtip',
        buttons: [
          'copyHtml5',
          'excelHtml5',
          'csvHtml5',
          'pdfHtml5'
        ]
      });
      $('#termType-fee').DataTable();
      $('#termfeeconfiguration').DataTable();
    });
    $('.day-week .btn-floating-action').click(function () {
      $('.day-week .btn-floating-action').each(function () {
        $(this).addClass('disabled');
      });
      $(this).removeClass('disabled');
    });

    /* $('.gradeX.class-fee').attr('href','#offcanvas-view-class-fee');
     $('.gradeX.class-fee').attr('data-toggle','offcanvas');
 
     $('.editfee').attr('href','#offcanvas-edit-fee');
     $('.editfee').attr('data-toggle','offcanvas');
 
     //$('.manage-component').attr('href','#offcanvas-manage-feeComponent');
     $('.manage-component').attr('data-toggle','offcanvas');
 
    /!* $('.manage-term').attr('href','#offcanvas-manage-termFee');
     $('.manage-term').attr('data-toggle','offcanvas');*!/
 
     $('.manage-termConfiguration').attr('href','#offcanvas-manage-termFeeConfiguration');
     $('.manage-termConfiguration').attr('data-toggle','offcanvas');*/

  </script>
  <script>
    $(document).ready(function () {
      $('#term').click(function () {
        $('.term-item').show();
        $('.typeComponent').hide();
      });
      $('#type').click(function () {
        $('.typeComponent').show();
        $('.term-item').hide();
      });
      $('.multipleSelect1').multiselect();
    });
  </script>
  <script type="text/javascript">
    $('.termType').click(function () {
      if ($(this).prop("checked") == true) {
        $('.date1').hide();
      }
      else if ($(this).prop("checked") == false) {
        $('.date1').show();
      }
    })

  </script>
  <script>
    $(document).ready(function () {
      $('.datepicker1').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true
      });
      $('#proceed').click(function () {
        $('#payment-mode a').click();
      });
      $('#back').click(function () {
        $('.paymentdetail a').click();
      });
      $('#makepayment').click(function () {
        $('#transection a').click();
      });
    });
  </script>
  <script>
    $(document).ready(function () {
      $('.cash').click(function () {
        $('#payByDD').hide();
        $('#payBycheque').hide();
      });
      $('.DD').click(function () {
        $('#payByDD').show();
        $('#payBycheque').hide();
      });
      $('.cheque').click(function () {
        $('#payBycheque').show();
        $('#payByDD').hide();
      });
      $('#add-payment').click(function () {
        $('#online-payment').show();
      });
      $('#cancel-payment').click(function () {
        $('#online-payment').hide();
      });
      $('#singinforUpdate').click(function () {
        $('#signinToAccount').show();
        $('#merchantaccountStatus').hide();
      });
    });
  </script>

</div>